import * as i0 from '@angular/core';
import { EventEmitter, Component, Output, Injectable, Input, HostListener, ViewChild, NgModule } from '@angular/core';
import * as i3 from '@angular/common/http';
import { HttpHeaders } from '@angular/common/http';
import { map, debounceTime, retry, tap } from 'rxjs/operators';
import * as i1 from 'abs-ngx-library/src/lib/core';
import { EnviormentConfig } from 'abs-ngx-library/src/lib/core';
import { BehaviorSubject, Subject, Subscription, first, map as map$1 } from 'rxjs';
import * as i2 from 'abs-ngx-library/src/lib/toaster-al';
import { ToasterType, ToasterModule } from 'abs-ngx-library/src/lib/toaster-al';
import * as i5 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i2$1 from '@angular/forms';
import { FormsModule } from '@angular/forms';

function ProductSNSModalALComponent_ng_container_0_div_19_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 30);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const featurePoint_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(featurePoint_r3.featurePointTitle);
} }
function ProductSNSModalALComponent_ng_container_0_div_19_span_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 31);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const featurePoint_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(featurePoint_r3.featurePointDescription);
} }
function ProductSNSModalALComponent_ng_container_0_div_19_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 24)(1, "div", 25);
    i0.ɵɵelement(2, "span", 26);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 27);
    i0.ɵɵtemplate(4, ProductSNSModalALComponent_ng_container_0_div_19_span_4_Template, 2, 1, "span", 28)(5, ProductSNSModalALComponent_ng_container_0_div_19_span_5_Template, 2, 1, "span", 29);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const featurePoint_r3 = ctx.$implicit;
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", featurePoint_r3.featurePointTitle);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", featurePoint_r3.featurePointDescription);
} }
function ProductSNSModalALComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 2);
    i0.ɵɵlistener("keydown", function ProductSNSModalALComponent_ng_container_0_Template_div_keydown_1_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.onKeydownEvent($event, "#info-modal")); });
    i0.ɵɵelementStart(2, "div", 3)(3, "div", 4)(4, "div", 5)(5, "button", 6);
    i0.ɵɵlistener("keydown.enter", function ProductSNSModalALComponent_ng_container_0_Template_button_keydown_enter_5_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.closeModal()); })("click", function ProductSNSModalALComponent_ng_container_0_Template_button_click_5_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); ctx_r1.closeModal(); return i0.ɵɵresetView(ctx_r1.analyticsSnsModalClick("ar:learn-more|close")); });
    i0.ɵɵelement(6, "span", 7);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 8)(8, "div", 9)(9, "div", 10)(10, "div", 11);
    i0.ɵɵelement(11, "img", 12);
    i0.ɵɵelementStart(12, "span", 13);
    i0.ɵɵelement(13, "span", 14);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(14, "h1", 15);
    i0.ɵɵtext(15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "h2", 16);
    i0.ɵɵtext(17);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(18, "div", 17);
    i0.ɵɵtemplate(19, ProductSNSModalALComponent_ng_container_0_div_19_Template, 6, 2, "div", 18);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(20, "div", 19)(21, "div", 20)(22, "button", 21);
    i0.ɵɵlistener("click", function ProductSNSModalALComponent_ng_container_0_Template_button_click_22_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); ctx_r1.closeModal(); return i0.ɵɵresetView(ctx_r1.analyticsSnsModalClick("ar:learn-more|got-it")); });
    i0.ɵɵtext(23);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(24, "div", 22)(25, "a", 23);
    i0.ɵɵlistener("click", function ProductSNSModalALComponent_ng_container_0_Template_a_click_25_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.analyticsLinkClick("faqs")); });
    i0.ɵɵtext(26);
    i0.ɵɵelementEnd()()()()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r1.dataConfig.showModal ? "show d-block" : "d-none");
    i0.ɵɵattribute("aria-hidden", !ctx_r1.dataConfig.showModal);
    i0.ɵɵadvance(10);
    i0.ɵɵpropertyInterpolate("src", ctx_r1.dataConfig.contents == null ? null : ctx_r1.dataConfig.contents.featureLogo, i0.ɵɵsanitizeUrl);
    i0.ɵɵpropertyInterpolate2("alt", "", ctx_r1.dataConfig.contents == null ? null : ctx_r1.dataConfig.contents.snsText, " ", ctx_r1.dataConfig.contents == null ? null : ctx_r1.dataConfig.contents.snsOffer, "");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate2(" ", ctx_r1.dataConfig.contents == null ? null : ctx_r1.dataConfig.contents.snsText, " ", ctx_r1.dataConfig.contents == null ? null : ctx_r1.dataConfig.contents.snsOffer, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.dataConfig.contents == null ? null : ctx_r1.dataConfig.contents.featureSubHeader, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngForOf", ctx_r1.dataConfig.contents == null ? null : ctx_r1.dataConfig.contents.featurePoints);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r1.dataConfig.contents == null ? null : ctx_r1.dataConfig.contents.featureButtonLabel);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("href", ctx_r1.dataConfig.contents == null ? null : ctx_r1.dataConfig.contents.footerLink, i0.ɵɵsanitizeUrl);
    i0.ɵɵattribute("aria-label", ctx_r1.dataConfig.contents == null ? null : ctx_r1.dataConfig.contents.footerLinkText);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.dataConfig.contents == null ? null : ctx_r1.dataConfig.contents.footerLinkText, " ");
} }
function ProductSNSModalALComponent_ng_container_1_ng_container_16_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 43)(2, "input", 44);
    i0.ɵɵtwoWayListener("ngModelChange", function ProductSNSModalALComponent_ng_container_1_ng_container_16_Template_input_ngModelChange_2_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r1 = i0.ɵɵnextContext(2); i0.ɵɵtwoWayBindingSet(ctx_r1.formModel.frequency, $event) || (ctx_r1.formModel.frequency = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("change", function ProductSNSModalALComponent_ng_container_1_ng_container_16_Template_input_change_2_listener() { const frequency_r6 = i0.ɵɵrestoreView(_r5).$implicit; const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.clickFrequency(frequency_r6.count)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "label", 45);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const frequency_r6 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("id", "frequencyLabel" + frequency_r6.count)("value", frequency_r6.count);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.formModel.frequency);
    i0.ɵɵadvance();
    i0.ɵɵproperty("htmlFor", "frequencyLabel" + frequency_r6.count);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", "Every " + frequency_r6.displayFrequency, " ");
} }
function ProductSNSModalALComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 32);
    i0.ɵɵlistener("keydown", function ProductSNSModalALComponent_ng_container_1_Template_div_keydown_1_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.onKeydownEvent($event, "#frequency-modal")); });
    i0.ɵɵelementStart(2, "div", 3)(3, "form", null, 0)(5, "div", 33)(6, "div", 34)(7, "div", 35)(8, "h1", 36);
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "button", 37);
    i0.ɵɵlistener("keydown.enter", function ProductSNSModalALComponent_ng_container_1_Template_button_keydown_enter_10_listener() { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.closeModal()); })("click", function ProductSNSModalALComponent_ng_container_1_Template_button_click_10_listener() { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(); ctx_r1.closeModal(); return i0.ɵɵresetView(ctx_r1.analyticsSnsModalClick("ar:frequency|close")); });
    i0.ɵɵelement(11, "span", 7);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(12, "h2", 38);
    i0.ɵɵtext(13);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(14, "div", 39)(15, "div", 40);
    i0.ɵɵtemplate(16, ProductSNSModalALComponent_ng_container_1_ng_container_16_Template, 5, 5, "ng-container", 41);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(17, "div", 19)(18, "div", 20)(19, "button", 42);
    i0.ɵɵlistener("click", function ProductSNSModalALComponent_ng_container_1_Template_button_click_19_listener() { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.saveFrequency()); });
    i0.ɵɵtext(20);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(21, "div", 22)(22, "a", 23);
    i0.ɵɵlistener("click", function ProductSNSModalALComponent_ng_container_1_Template_a_click_22_listener() { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.analyticsLinkClick("faqs")); });
    i0.ɵɵtext(23);
    i0.ɵɵelementEnd()()()()()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r1.dataConfig.showModal ? "show d-block" : "d-none");
    i0.ɵɵattribute("aria-hidden", !ctx_r1.dataConfig.showModal);
    i0.ɵɵadvance(8);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.dataConfig.contents == null ? null : ctx_r1.dataConfig.contents.frequencyHeader, " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r1.dataConfig.contents == null ? null : ctx_r1.dataConfig.contents.frequencySubHeader);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngForOf", ctx_r1.dataConfig.frequencies);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.dataConfig.contents == null ? null : ctx_r1.dataConfig.contents.frequencyButtonLabel, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("href", ctx_r1.dataConfig.contents == null ? null : ctx_r1.dataConfig.contents.footerLink, i0.ɵɵsanitizeUrl);
    i0.ɵɵattribute("aria-label", ctx_r1.dataConfig.contents == null ? null : ctx_r1.dataConfig.contents.footerLinkText);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.dataConfig.contents == null ? null : ctx_r1.dataConfig.contents.footerLinkText, " ");
} }
function ProductSNSModalALComponent_ng_container_2_div_21_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 70);
    i0.ɵɵelement(1, "div", 71);
    i0.ɵɵelementStart(2, "div", 72);
    i0.ɵɵtext(3);
    i0.ɵɵpipe(4, "date");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r1.dataConfig.nextFulfillmentType === "DUG" ? "svg-pickup" : "svg-delivery");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2("", ctx_r1.dataConfig.nextFulfillmentType == "dug" ? ctx_r1.dataConfig.contents == null ? null : ctx_r1.dataConfig.contents.footerNextFulfillmentPickup : ctx_r1.dataConfig.contents == null ? null : ctx_r1.dataConfig.contents.footerNextFulfillmentDelivery, ": ", i0.ɵɵpipeBind2(4, 3, ctx_r1.dataConfig.nextFulfillmentDate, "MMM. dd"), "");
} }
function ProductSNSModalALComponent_ng_container_2_option_28_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 73);
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const frequency_r8 = ctx.$implicit;
    i0.ɵɵproperty("id", "frequencyLabel" + frequency_r8.count)("value", frequency_r8.count);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate("Every " + frequency_r8.displayFrequency);
} }
function ProductSNSModalALComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 46);
    i0.ɵɵlistener("keydown", function ProductSNSModalALComponent_ng_container_2_Template_div_keydown_1_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.onKeydownEvent($event, "#add-recurring-order-modal")); });
    i0.ɵɵelementStart(2, "div", 3)(3, "div", 47)(4, "div", 34)(5, "div", 35)(6, "h1", 48);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "button", 37);
    i0.ɵɵlistener("keydown.enter", function ProductSNSModalALComponent_ng_container_2_Template_button_keydown_enter_8_listener() { i0.ɵɵrestoreView(_r7); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.closeModal()); })("click", function ProductSNSModalALComponent_ng_container_2_Template_button_click_8_listener() { i0.ɵɵrestoreView(_r7); const ctx_r1 = i0.ɵɵnextContext(); ctx_r1.closeModal(); return i0.ɵɵresetView(ctx_r1.analyticsSnsModalClick("ar:adding-to-recurring-order|close")); });
    i0.ɵɵelement(9, "span", 7);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(10, "h2", 49);
    i0.ɵɵtext(11);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(12, "div", 50)(13, "div", 51)(14, "div", 52);
    i0.ɵɵelement(15, "img", 53);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(16, "div", 54)(17, "div", 55);
    i0.ɵɵtext(18);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(19, "div", 56);
    i0.ɵɵtext(20);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(21, ProductSNSModalALComponent_ng_container_2_div_21_Template, 5, 6, "div", 57);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(22, "div", 58)(23, "quantity-stepper-al-v1", 59);
    i0.ɵɵlistener("updateQscQtyEmitter", function ProductSNSModalALComponent_ng_container_2_Template_quantity_stepper_al_v1_updateQscQtyEmitter_23_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.getUpdatedQty($event)); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(24, "div", 60)(25, "div", 61)(26, "label", 62)(27, "select", 63);
    i0.ɵɵlistener("change", function ProductSNSModalALComponent_ng_container_2_Template_select_change_27_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.saveRecurringFreq($event.target.value)); });
    i0.ɵɵtemplate(28, ProductSNSModalALComponent_ng_container_2_option_28_Template, 2, 3, "option", 64);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(29, "span", 65);
    i0.ɵɵtext(30, "Frequency");
    i0.ɵɵelementEnd()()()()()();
    i0.ɵɵelementStart(31, "div", 66)(32, "div", 67)(33, "button", 68);
    i0.ɵɵlistener("click", function ProductSNSModalALComponent_ng_container_2_Template_button_click_33_listener() { i0.ɵɵrestoreView(_r7); const ctx_r1 = i0.ɵɵnextContext(); ctx_r1.saveRecurringDetails(); return i0.ɵɵresetView(ctx_r1.analyticsSnsModalClick("ar:subscribe-schedule-and-save-plp|subscribed")); });
    i0.ɵɵtext(34);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(35, "button", 69);
    i0.ɵɵlistener("click", function ProductSNSModalALComponent_ng_container_2_Template_button_click_35_listener() { i0.ɵɵrestoreView(_r7); const ctx_r1 = i0.ɵɵnextContext(); ctx_r1.closeModal(); return i0.ɵɵresetView(ctx_r1.analyticsSnsModalClick("ar:adding-to-recurring-order|not-now")); });
    i0.ɵɵtext(36);
    i0.ɵɵelementEnd()()()()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r1.dataConfig.showModal ? "show d-block" : "d-none");
    i0.ɵɵattribute("aria-hidden", !ctx_r1.dataConfig.showModal);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.dataConfig.contents == null ? null : ctx_r1.dataConfig.contents.addRecurHeader, " ");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r1.dataConfig.contents == null ? null : ctx_r1.dataConfig.contents.addRecurMessage);
    i0.ɵɵadvance(4);
    i0.ɵɵpropertyInterpolate1("src", "https://images.albertsons-media.com/is/image/ABS/", ctx_r1.dataConfig.product.id, "?$ecom-product-card-desktop-jpg$&defaultImage=Not_Available", i0.ɵɵsanitizeUrl);
    i0.ɵɵpropertyInterpolate("alt", ctx_r1.dataConfig.product.name);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.dataConfig.contents == null ? null : ctx_r1.dataConfig.contents.addRecurTitle);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.dataConfig.product.name, "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", (ctx_r1.dataConfig == null ? null : ctx_r1.dataConfig.nextFulfillmentType == null ? null : ctx_r1.dataConfig.nextFulfillmentType.length) != 0 && (ctx_r1.dataConfig == null ? null : ctx_r1.dataConfig.nextFulfillmentDate == null ? null : ctx_r1.dataConfig.nextFulfillmentDate.length) != 0);
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate("id", ctx_r1.dataConfig.product.id);
    i0.ɵɵproperty("ngClass", "quantity-stepper-v3 quantity-stepper-v3--responsive-width")("product", ctx_r1.dataConfig.product)("calledBy", "snsCheckoutFlowModal")("configObj", ctx_r1.configObj)("isAnyProductHasAddlInfo", true)("isQscV2", false);
    i0.ɵɵadvance(5);
    i0.ɵɵproperty("ngForOf", ctx_r1.dataConfig.frequencies);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate(ctx_r1.dataConfig.contents == null ? null : ctx_r1.dataConfig.contents.addRecurButtonLabel);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.dataConfig.contents == null ? null : ctx_r1.dataConfig.contents.addRecurButtonNotNowLabel);
} }
function ProductSNSModalALComponent_ng_container_3_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 85);
    i0.ɵɵtext(1, " We're unable to subscribe, due to a technical error, we're unable to add this item to a Schedule & Save subscription. Please try again later. ");
    i0.ɵɵelementEnd();
} }
function ProductSNSModalALComponent_ng_container_3_div_6_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 85);
    i0.ɵɵtext(1, " We're unable to unsubscribe the item at this time. Please try again later. You may also cancel the item subscription within your Schedule & Save settings once the order is complete. ");
    i0.ɵɵelementEnd();
} }
function ProductSNSModalALComponent_ng_container_3_ng_container_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1, " Due to a technical error, we're unable to add this item to a Schedule & Save subscription. Please try again later. ");
    i0.ɵɵelementContainerEnd();
} }
function ProductSNSModalALComponent_ng_container_3_ng_container_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtext(1, " We're unable to unsubscribe the item at this time. Please try again later. You may also cancel the item subscription within your Schedule & Save settings once the order is complete. ");
    i0.ɵɵelementContainerEnd();
} }
function ProductSNSModalALComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 74);
    i0.ɵɵlistener("keydown", function ProductSNSModalALComponent_ng_container_3_Template_div_keydown_1_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.onKeydownEvent($event, "#error-modal")); });
    i0.ɵɵelementStart(2, "div", 75)(3, "div", 76)(4, "div", 5);
    i0.ɵɵtemplate(5, ProductSNSModalALComponent_ng_container_3_div_5_Template, 2, 0, "div", 77)(6, ProductSNSModalALComponent_ng_container_3_div_6_Template, 2, 0, "div", 77);
    i0.ɵɵelementStart(7, "button", 78);
    i0.ɵɵlistener("keydown.enter", function ProductSNSModalALComponent_ng_container_3_Template_button_keydown_enter_7_listener() { i0.ɵɵrestoreView(_r9); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.closeModal()); })("click", function ProductSNSModalALComponent_ng_container_3_Template_button_click_7_listener() { i0.ɵɵrestoreView(_r9); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.closeModal()); });
    i0.ɵɵelement(8, "span", 7);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(9, "div", 79);
    i0.ɵɵelement(10, "div", 80);
    i0.ɵɵelementStart(11, "h1", 81);
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 82);
    i0.ɵɵtemplate(14, ProductSNSModalALComponent_ng_container_3_ng_container_14_Template, 2, 0, "ng-container", 1)(15, ProductSNSModalALComponent_ng_container_3_ng_container_15_Template, 2, 0, "ng-container", 1);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(16, "div", 83)(17, "div", 20)(18, "button", 84);
    i0.ɵɵlistener("click", function ProductSNSModalALComponent_ng_container_3_Template_button_click_18_listener() { i0.ɵɵrestoreView(_r9); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.closeModal()); });
    i0.ɵɵtext(19, "Close");
    i0.ɵɵelementEnd()()()()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r1.dataConfig.showModal ? "show d-block" : "d-none");
    i0.ɵɵattribute("aria-hidden", !ctx_r1.dataConfig.showModal);
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngIf", ctx_r1.dataConfig.errModalType === "subscribe");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.dataConfig.errModalType === "unsubscribe");
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" We're unable to ", ctx_r1.dataConfig.errModalType, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.dataConfig.errModalType === "subscribe");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.dataConfig.errModalType === "unsubscribe");
} }
function ProductSNSModalALComponent_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 86);
    i0.ɵɵlistener("keydown", function ProductSNSModalALComponent_ng_container_4_Template_div_keydown_1_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.onKeydownEvent($event, "#success-modal")); });
    i0.ɵɵelementStart(2, "div", 3)(3, "div", 87)(4, "div", 34)(5, "div", 35)(6, "h1", 88);
    i0.ɵɵtext(7);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(8, "button", 37);
    i0.ɵɵlistener("keydown.enter", function ProductSNSModalALComponent_ng_container_4_Template_button_keydown_enter_8_listener() { i0.ɵɵrestoreView(_r10); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.closeModal()); })("click", function ProductSNSModalALComponent_ng_container_4_Template_button_click_8_listener() { i0.ɵɵrestoreView(_r10); const ctx_r1 = i0.ɵɵnextContext(); ctx_r1.closeModal(); return i0.ɵɵresetView(ctx_r1.analyticsSnsModalClick("ar:item-scheduled|close")); });
    i0.ɵɵelement(9, "span", 7);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(10, "div", 89)(11, "h2", 90);
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "div", 91);
    i0.ɵɵelement(14, "img", 53);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 92)(16, "span", 93);
    i0.ɵɵelement(17, "span", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "div", 94);
    i0.ɵɵtext(19);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "div", 95);
    i0.ɵɵtext(21);
    i0.ɵɵpipe(22, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(23, "div", 96)(24, "div", 97);
    i0.ɵɵtext(25);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(26, "div", 98)(27, "span", 97);
    i0.ɵɵtext(28);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(29, "a", 99);
    i0.ɵɵlistener("click", function ProductSNSModalALComponent_ng_container_4_Template_a_click_29_listener() { i0.ɵɵrestoreView(_r10); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.analyticsLinkClick("manage")); });
    i0.ɵɵtext(30);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(31, "div", 100)(32, "div", 20)(33, "button", 68);
    i0.ɵɵlistener("click", function ProductSNSModalALComponent_ng_container_4_Template_button_click_33_listener() { i0.ɵɵrestoreView(_r10); const ctx_r1 = i0.ɵɵnextContext(); ctx_r1.closeModal(); return i0.ɵɵresetView(ctx_r1.analyticsSnsModalClick("ar:item-scheduled|continue-shopping")); });
    i0.ɵɵtext(34);
    i0.ɵɵelementEnd()()()()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", ctx_r1.dataConfig.showModal ? "show d-block" : "d-none");
    i0.ɵɵattribute("aria-hidden", !ctx_r1.dataConfig.showModal);
    i0.ɵɵadvance(6);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.dataConfig.contents == null ? null : ctx_r1.dataConfig.contents.itemSchedHeader, " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" ", ctx_r1.dataConfig.contents == null ? null : ctx_r1.dataConfig.contents.itemSchedMessage, " ");
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("src", "https://images.albertsons-media.com/is/image/ABS/", ctx_r1.dataConfig.productId, "?$ecom-product-card-desktop-jpg$&defaultImage=Not_Available", i0.ɵɵsanitizeUrl);
    i0.ɵɵpropertyInterpolate("alt", ctx_r1.dataConfig.product.name);
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(ctx_r1.dataConfig.nextFulfillmentType == "dug" ? ctx_r1.dataConfig.contents == null ? null : ctx_r1.dataConfig.contents.footerNextFulfillmentPickup : ctx_r1.dataConfig.contents == null ? null : ctx_r1.dataConfig.contents.footerNextFulfillmentDelivery);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate2("", ctx_r1.dataConfig.nextFulfillmentType == "dug" ? ctx_r1.dataConfig.contents == null ? null : ctx_r1.dataConfig.contents.itemSchedNextFulfillmentDatePickupText : ctx_r1.dataConfig.contents == null ? null : ctx_r1.dataConfig.contents.itemSchedNextFulfillmentDateDeliveryText, " ", i0.ɵɵpipeBind2(22, 16, ctx_r1.dataConfig.productFulfillDate, "MMM. dd"), "");
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate2("", ctx_r1.dataConfig.contents == null ? null : ctx_r1.dataConfig.contents.itemSchedFrequencyText, " ", ctx_r1.dataConfig.selectedFrequency == "1" ? "week" : ctx_r1.dataConfig.selectedFrequency + " weeks", " ");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("", ctx_r1.dataConfig.contents == null ? null : ctx_r1.dataConfig.contents.itemSchedChangesText, " ");
    i0.ɵɵadvance();
    i0.ɵɵattribute("aria-label", (ctx_r1.dataConfig.contents == null ? null : ctx_r1.dataConfig.contents.itemSchedChangesText) + (ctx_r1.dataConfig.contents == null ? null : ctx_r1.dataConfig.contents.itemSchedManageLinkText));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.dataConfig.contents == null ? null : ctx_r1.dataConfig.contents.itemSchedManageLinkText);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r1.dataConfig.contents == null ? null : ctx_r1.dataConfig.contents.itemSchedButtonLabel);
} }
class ProductSNSModalALComponent {
    constructor(_arService, _productSnsModalService, elementRef, _commonService) {
        this._arService = _arService;
        this._productSnsModalService = _productSnsModalService;
        this.elementRef = elementRef;
        this._commonService = _commonService;
        this.closeModalEvent = new EventEmitter();
        this.selectFrequency = new EventEmitter();
        this.qscQuantity = 1;
        this.recurringFrequency = "1";
        this.configObj = {
            programType: 'abs'
        };
    }
    ngOnInit() {
        this.formModel = { frequency: this.dataConfig.selectedFrequency };
        this.dataConfig.contents = this._productSnsModalService.getDynamicContents();
    }
    onKeydownEvent($event, modelId) {
        const focusableElements = 'button:not([disabled]), [href], input, select, textarea, a, [tabindex]:not([tabindex="-1"])';
        this._commonService.handleTabFocus($event, modelId, this.elementRef.nativeElement, focusableElements);
    }
    closeModal() {
        this.closeModalEvent.emit();
    }
    saveFrequency() {
        this._productSnsModalService.emitFrequency(this.formModel.frequency);
        this.closeModal();
        this.analyticsSnsModalClick('ar:frequency|save');
    }
    getFocusableElements(selector) {
        const focusableContent = this.elementRef.nativeElement.querySelectorAll(selector);
        const visibleFocusableElement = [];
        focusableContent.forEach((focusable) => {
            if ($(focusable).is(':visible')) {
                visibleFocusableElement.push(focusable);
            }
        });
        return visibleFocusableElement;
    }
    clickFrequency(frequency) {
        this.formModel.frequency = frequency;
    }
    getUpdatedQty(quantity) {
        this.qscQuantity = quantity;
    }
    saveRecurringFreq(frequency) {
        this.recurringFrequency = frequency;
    }
    saveRecurringDetails() {
        // pass the modal details as payload to addSubscription in object format.
        let productDetails = {
            bpn: this.dataConfig.product.id,
            upc: this.dataConfig.product.upc,
            quantity: this.qscQuantity,
            startDate: this.dataConfig.nextFulfillmentDate,
            subscriptionSource: this.dataConfig.subscriptionSource,
            frequency: this.recurringFrequency,
            productTitle: this.dataConfig.product.name,
            originalPrice: this.dataConfig.product.price
        };
        this._arService.buildAndPostAddSubscription(productDetails).subscribe(response => {
            this.closeModal();
            if (!!response) {
                // save the POST response to local storage
                this._arService.setArSubscription(response);
                // show success modal
                this.dataConfig.modal = 'successModal';
                this.dataConfig.showModal = true;
                this.dataConfig.productId = productDetails.bpn;
                this.dataConfig.nextFulfillmentType = response.fulfillment?.fulfillmentType.toLowerCase();
                let productObj = response.itemsSubscribed.find(obj => obj.productBpn === this.dataConfig.productId);
                this.dataConfig.productFulfillDate = productObj?.nextFulfillmentDate;
                this.dataConfig.selectedFrequency = productObj?.frequency?.count;
            }
            else {
                this.closeModal();
                this.dataConfig.modal = 'errorModal';
                this.dataConfig.showModal = true;
                this.dataConfig.errModalType = 'subscribe';
            }
            setTimeout(() => {
                this._productSnsModalService.show(this.dataConfig);
                if (window['AB']?.DATALAYER) {
                    window['AB']?.DATALAYER.setSnsModalViewEvents(this.dataConfig);
                }
            }, 200);
        }, (err) => {
            // show error modal here
            this.closeModal();
            this.dataConfig.modal = 'errorModal';
            this.dataConfig.showModal = true;
            this.dataConfig.errModalType = 'subscribe';
            setTimeout(() => {
                this._productSnsModalService.show(this.dataConfig);
            }, 200);
        });
    }
    analyticsLinkClick(link) {
        if (window['AB']?.DATALAYER) {
            window['AB']?.DATALAYER.setSnsModalLinkClick(link, this.dataConfig);
        }
    }
    analyticsSnsModalClick(action) {
        if (window['AB']?.DATALAYER) {
            window['AB']?.DATALAYER.setSnsModalClickEvents(action, this.dataConfig, this.formModel, this.recurringFrequency);
        }
    }
    static { this.ɵfac = function ProductSNSModalALComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ProductSNSModalALComponent)(i0.ɵɵdirectiveInject(i1.ArService), i0.ɵɵdirectiveInject(ProductSNSModalALService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.CommonService)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: ProductSNSModalALComponent, selectors: [["product-sns-modal-al"]], outputs: { closeModalEvent: "closeModalEvent", selectFrequency: "selectFrequency" }, decls: 5, vars: 5, consts: [["frequencyForm", "ngForm"], [4, "ngIf"], ["id", "info-modal", "tabindex", "-1", "data-backdrop", "false", "aria-labelledby", "modal-label-modal-sns", 1, "modal", "fade", "sns-modal-container", 3, "keydown", "ngClass"], ["role", "document", 1, "modal-dialog", "sns-modal"], ["role", "dialog", "aria-labelledby", "scheduleNsaveContentTxt", 1, "modal-content", "sns-modal", "sns-modal__content", "py-4"], [1, "modal-header", "sns-modal__header", "sns-modal--content-frequency__header", "px-4", "py-3"], ["data-qa", "abt-abtpopupxbtn-ss", "data-dismiss", "modal", "aria-label", "Close", 1, "close", "sns-modal__close-btn", "mb-2", "mr-1", 3, "keydown.enter", "click"], [1, "svg-icon", "svg-close-primary"], [1, "sns-modal__body", "px-3"], [1, "sns-modal__body-top-container"], [1, "sns-modal__body-img-text-block", "d-flex", "flex-column", "align-items-center"], [1, "sns-modal__body-img"], ["aria-hidden", "true", 3, "src", "alt"], [1, "sns-modal__body-icon-container"], [1, "sns-modal__body-sns-icon"], ["id", "scheduleNsaveContentTxt", 1, "title-lg", "mt-4", "sns-modal__body-sns-text"], [1, "title-sm", "sns-modal__ada-color", "sns-modal--content-info__subheader", "text-center"], [1, "sns-modal__body-bottom-container"], ["class", "sns-modal--content-info__info-pill d-flex mt-4 mb-4", 4, "ngFor", "ngForOf"], [1, "sns-modal__footer", "d-flex", "pt-4", "align-items-center", "flex-column"], [1, "sns-modal__footer-btn"], ["data-qa", "abt-gtitbtn-ss", 1, "btn", "btn-xl", "btn-primary", 3, "click"], [1, "sns-modal__footer-more-info", "d-flex", "flex-column", "align-items-center"], ["role", "link", "target", "\u201D_blank\u201D", 1, "link-xs", "sns-modal__footer-faq-link", 3, "click", "href"], [1, "sns-modal--content-info__info-pill", "d-flex", "mt-4", "mb-4"], [1, "mt-1", "sns-modal__body-info-pill-chkmark"], [1, "sns-modal__body-info-pill-chkmark-svg"], [1, "ml-3", "sns-modal__body-info-pill-text-container", "d-flex", "flex-column", "align-items-start"], ["class", "title-sm-bold", 4, "ngIf"], ["class", "sns-modal__ada-color body-text", 4, "ngIf"], [1, "title-sm-bold"], [1, "sns-modal__ada-color", "body-text"], ["id", "frequency-modal", "tabindex", "-1", "data-backdrop", "false", "aria-labelledby", "modal-label-modal-sns", 1, "modal", "fade", "sns-modal-container", 3, "keydown", "ngClass"], ["role", "dialog", "aria-labelledby", "frequencyHeaderTxt", 1, "modal-content", "sns-modal", "sns-modal__content", "py-4"], [1, "modal-header", "sns-modal__header", "sns-modal--content-frequency__header", "px-4", "py-3", "flex-column"], [1, "align-items-center", "d-flex", "mb-2"], ["id", "frequencyHeaderTxt", 1, "modal-title", "w-100", "text-center", "title-lg"], ["data-dismiss", "modal", "aria-label", "Close", 1, "p-0", "m-0", "close", "sns-modal__close-btn", 3, "keydown.enter", "click"], [1, "title-sm", "text-center"], [1, "sns-modal__body", "sns-modal--content-frequency__body", "px-3"], [1, "sns-modal__body-frequency-container"], [4, "ngFor", "ngForOf"], ["type", "submit", 1, "btn", "btn-xl", "btn-primary", 3, "click"], [1, "form-check", "radioButton__group", "pl-0"], ["type", "radio", "name", "frequency", 1, "form-check-input", "radioButton__input", "radioButton--input", "d-block", 3, "ngModelChange", "change", "id", "value", "ngModel"], [1, "form-check-label", "radioButton__label", "radioButton__label--md", "body-text", 3, "htmlFor"], ["data-backdrop", "false", "tabindex", "-1", "id", "add-recurring-order-modal", "aria-labelledby", "modal-label-modal-sns", 1, "modal", "fade", "sns-modal-container", 3, "keydown", "ngClass"], ["role", "dialog", "aria-labelledby", "addRecurringHeaderTxt", 1, "modal-content", "sns-modal__content", "py-4"], ["id", "addRecurringHeaderTxt", 1, "modal-title", "w-100", "text-center", "title-lg", "d-flex", "flex-start"], [1, "title-sm"], [1, "sns-modal__body", "px-3", "pb-5"], [1, "sns-modal__info-box"], [1, "sns-modal__image-content", "float-left"], [1, "sns-modal__image", 3, "src", "alt"], [1, "sns-modal__info-content", "float-left"], [1, "price-lg", "sns-modal__default"], [1, "title-xs", "sns-modal__title", "mb-2"], ["class", "sns-modal__fulfill align-items-center d-flex background-color-secondary-200", 4, "ngIf"], [1, "sns-modal__freq-content", "d-flex", "flex-column", "pt-4"], [3, "updateQscQtyEmitter", "ngClass", "id", "product", "calledBy", "configObj", "isAnyProductHasAddlInfo", "isQscV2"], [1, "input-field", "responsive-width"], ["role", "listbox", 1, "input-field__wrapper", "text-dropdown-responsive"], ["for", "week", 1, "input-field__float-label"], ["id", "week", "name", "frequency", "placeholder", " ", "aria-label", "Frequency", 3, "change"], ["name", "frequency", "class", "dropdown__group", 3, "id", "value", 4, "ngFor", "ngForOf"], [1, "word-highlight-xs"], [1, "sns-modal__footer", "d-flex", "pt-4", "align-items-end", "flex-column"], [1, "sns-modal__button-box", "align-items-center", "d-flex"], ["data-dismiss", "modal", 1, "btn", "btn-xl", "btn-primary", 3, "click"], ["data-dismiss", "modal", 1, "btn", "btn-xl", "btn-secondary", "sns-modal__button", "mr-3", 3, "click"], [1, "sns-modal__fulfill", "align-items-center", "d-flex", "background-color-secondary-200"], [3, "ngClass"], [1, "word-highlight-xs", "ml-1"], ["name", "frequency", 1, "dropdown__group", 3, "id", "value"], ["id", "error-modal", "role", "dialog", "aria-labelledby", "modal-label-modal-sns", "aria-hidden", "true", "tabindex", "-1", "data-backdrop", "false", 1, "modal", "fade", "sns-modal-container", 3, "keydown", "ngClass"], ["role", "document", 1, "modal-dialog", "modal-dialog-centered", "sns-modal--content-error"], [1, "modal-content", "sns-modal--content-error__content", "pt-3"], ["class", "sr-only", "id", "errorModalDescription", 4, "ngIf"], ["data-dismiss", "modal", "aria-label", "Close", "aria-describedby", "errorModalDescription", 1, "close", "sns-modal__close-btn", "mb-2", "mr-1", 3, "keydown.enter", "click"], [1, "d-flex", "flex-column", "align-items-center", "px-3", "pb-4"], [1, "svg-caution", "mb-3"], [1, "title-sm-bold", "text-center", "mb-3"], [1, "sns-modal--content-error__container", "sns-modal__ada-color", "text-center", "d-flex", "align-items-center", "mt-2"], [1, "d-flex", "p-4", "justify-content-center"], [1, "btn", "btn-xl", "btn-primary", 3, "click"], ["id", "errorModalDescription", 1, "sr-only"], ["id", "success-modal", "tabindex", "-1", "data-backdrop", "false", "aria-labelledby", "modal-label-modal-sns", 1, "modal", "fade", "sns-modal-container", 3, "keydown", "ngClass"], ["role", "dialog", "aria-labelledby", "itemSchedHeaderTxt", 1, "modal-content", "sns-modal", "sns-modal__content", "py-4"], ["id", "itemSchedHeaderTxt", 1, "modal-title", "w-100", "text-center", "title-lg"], [1, "sns-modal__body", "sns-modal--content-success__body", "d-flex", "flex-column", "align-items-center", "px-2", "pt-4", "pb-5"], [1, "title-sm", "sns-modal__ada-color", "text-center", "mb-3", "sns-modal--content-success__sub-header"], [1, "sns-modal--content-success__image", "p-2", "mb-4"], [1, "sns-container", "d-flex", "flex-column", "align-items-center", "mt-2", "p-3"], [1, "d-flex", "align-items-center", "justify-content-center", "sns-modal--content-success__repeat-icon", "background-color-secondary-200"], [1, "my-1", "word-highlight-sm"], [1, "poppins-title-xl", "mb-4"], [1, "text-center", "pt-3", "sns-modal--content-success__info"], [1, "body-text-sm", "sns-modal__ada-color"], [1, "sns-modal__terms", "sns-modal--content-success__terms", "d-flex", "flex-row", "mt-4"], ["role", "link", "href", "/schedule-and-save/manage", 1, "link-sm", "sns-modal__default", 3, "click"], [1, "sns-modal__footer", "d-flex", "pt-4", "justify-content-center"]], template: function ProductSNSModalALComponent_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, ProductSNSModalALComponent_ng_container_0_Template, 27, 14, "ng-container", 1)(1, ProductSNSModalALComponent_ng_container_1_Template, 24, 9, "ng-container", 1)(2, ProductSNSModalALComponent_ng_container_2_Template, 37, 20, "ng-container", 1)(3, ProductSNSModalALComponent_ng_container_3_Template, 20, 7, "ng-container", 1)(4, ProductSNSModalALComponent_ng_container_4_Template, 35, 19, "ng-container", 1);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", ctx.dataConfig.modal === "infoModal");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.dataConfig.modal === "freqModal");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.dataConfig.modal === "addRecurringModal");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.dataConfig.modal === "errorModal");
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.dataConfig.modal === "successModal");
        } }, encapsulation: 2 }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProductSNSModalALComponent, [{
        type: Component,
        args: [{ selector: 'product-sns-modal-al', template: "<ng-container  *ngIf=\"dataConfig.modal === 'infoModal'\">\n    <div\n    class=\"modal fade sns-modal-container\"\n    id=\"info-modal\"\n    tabindex=\"-1\"\n    data-backdrop=\"false\"\n    aria-labelledby=\"modal-label-modal-sns\"\n    [attr.aria-hidden]=\"!dataConfig.showModal\"\n    [ngClass]=\"dataConfig.showModal? 'show d-block': 'd-none'\"\n    (keydown)=\"onKeydownEvent($event, '#info-modal')\"\n    >\n        <div class=\"modal-dialog sns-modal\" role=\"document\">\n            <div role=\"dialog\" aria-labelledby=\"scheduleNsaveContentTxt\" class=\"modal-content sns-modal sns-modal__content py-4\">\n                <div class=\"modal-header sns-modal__header sns-modal--content-frequency__header px-4 py-3 \">\n                    <button \n                    data-qa=\"abt-abtpopupxbtn-ss\" \n                    (keydown.enter)=\"closeModal()\" \n                    (click)=\"closeModal();analyticsSnsModalClick('ar:learn-more|close')\" \n                    class=\"close sns-modal__close-btn mb-2 mr-1\" \n                    data-dismiss=\"modal\" \n                    aria-label=\"Close\">\n                        <span class=\"svg-icon svg-close-primary\"></span>\n                    </button>\n                </div>\n                <div class=\"sns-modal__body px-3\">\n                    <div class=\"sns-modal__body-top-container\">\n                        <div class=\"sns-modal__body-img-text-block d-flex flex-column align-items-center\">\n                            <div class=\"sns-modal__body-img\">\n                                <img aria-hidden=\"true\" src=\"{{ dataConfig.contents?.featureLogo }}\" alt=\"{{ dataConfig.contents?.snsText }} {{ dataConfig.contents?.snsOffer }}\">\n                                <span class=\"sns-modal__body-icon-container\">\n                                    <span class=\"sns-modal__body-sns-icon\"></span>\n                                </span>\n                            </div>\n                            <h1 id=\"scheduleNsaveContentTxt\" class=\"title-lg mt-4 sns-modal__body-sns-text\">\n                                {{ dataConfig.contents?.snsText }} {{ dataConfig.contents?.snsOffer }}\n                            </h1>\n                            <h2 class=\"title-sm sns-modal__ada-color sns-modal--content-info__subheader text-center\">\n                                {{ dataConfig.contents?.featureSubHeader }}\n                            </h2>\n                        </div>\n                    </div>\n                    <div class=\"sns-modal__body-bottom-container\">\n                        <div *ngFor=\"let featurePoint of dataConfig.contents?.featurePoints\" class=\"sns-modal--content-info__info-pill d-flex mt-4 mb-4\">\n                            <div class=\"mt-1 sns-modal__body-info-pill-chkmark\">\n                                <span class=\"sns-modal__body-info-pill-chkmark-svg\"></span>\n                            </div>\n                            <div class=\"ml-3 sns-modal__body-info-pill-text-container d-flex flex-column align-items-start\">\n                                <span *ngIf=\"featurePoint.featurePointTitle\" class=\"title-sm-bold\">{{ featurePoint.featurePointTitle }}</span>\n                                <span *ngIf=\"featurePoint.featurePointDescription\" class=\"sns-modal__ada-color body-text\">{{ featurePoint.featurePointDescription }}</span>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"sns-modal__footer d-flex pt-4 align-items-center flex-column\">\n                    <div class=\"sns-modal__footer-btn\">\n                        <button class=\"btn btn-xl btn-primary\" (click)=\"closeModal();analyticsSnsModalClick('ar:learn-more|got-it')\" data-qa=\"abt-gtitbtn-ss\">{{ dataConfig.contents?.featureButtonLabel }}</button>\n                    </div>\n                    <div class=\"sns-modal__footer-more-info d-flex flex-column align-items-center\">\n                        <a  role=\"link\"\n                            class=\"link-xs sns-modal__footer-faq-link\"\n                            href=\"{{ dataConfig.contents?.footerLink }}\"\n                            target=\u201D_blank\u201D\n                            (click)=\"analyticsLinkClick('faqs')\"\n                            [attr.aria-label]=\"dataConfig.contents?.footerLinkText\"\n                        >\n                        {{ dataConfig.contents?.footerLinkText }}\n                        </a>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</ng-container>\n<ng-container *ngIf=\"dataConfig.modal === 'freqModal'\">\n    <div\n        class=\"modal fade sns-modal-container\"\n        id=\"frequency-modal\"\n        tabindex=\"-1\"\n        data-backdrop=\"false\"\n        aria-labelledby=\"modal-label-modal-sns\"\n        [attr.aria-hidden]=\"!dataConfig.showModal\"\n        [ngClass]=\"dataConfig.showModal? 'show d-block': 'd-none'\"\n        (keydown)=\"onKeydownEvent($event, '#frequency-modal')\"\n    >\n        <div class=\"modal-dialog sns-modal\" role=\"document\">\n            <form #frequencyForm=\"ngForm\">\n                <div role=\"dialog\" aria-labelledby=\"frequencyHeaderTxt\" class=\"modal-content sns-modal sns-modal__content py-4\">\n                    <div class=\"modal-header sns-modal__header sns-modal--content-frequency__header px-4 py-3 flex-column\">\n                        <div class=\"align-items-center d-flex mb-2\">\n                            <h1 class=\"modal-title w-100 text-center title-lg\" id=\"frequencyHeaderTxt\">\n                                {{ dataConfig.contents?.frequencyHeader }}\n                            </h1>\n                            <button \n                            (keydown.enter)=\"closeModal()\" \n                            (click)=\"closeModal();analyticsSnsModalClick('ar:frequency|close')\" \n                            class=\"p-0 m-0 close sns-modal__close-btn\" \n                            data-dismiss=\"modal\" \n                            aria-label=\"Close\">\n                                <span class=\"svg-icon svg-close-primary\"></span>\n                            </button>\n                        </div>\n                        <h2 class=\"title-sm text-center\">{{ dataConfig.contents?.frequencySubHeader }}</h2>\n                    </div>\n                    <div class=\"sns-modal__body sns-modal--content-frequency__body px-3\">\n                        <div class=\"sns-modal__body-frequency-container\">\n                            <ng-container *ngFor=\"let frequency of dataConfig.frequencies\">\n                                <div class=\"form-check radioButton__group pl-0\">\n                                    <input class=\"form-check-input radioButton__input radioButton--input d-block\" \n                                        type=\"radio\" name=\"frequency\" \n                                        [id]=\"'frequencyLabel' + frequency.count\" \n                                        [value]=\"frequency.count\"[(ngModel)]=\"formModel.frequency\"\n                                        (change)=\"clickFrequency(frequency.count)\"/>\n                                        <label class=\"form-check-label radioButton__label radioButton__label--md body-text\" \n                                        [htmlFor]=\"'frequencyLabel' + frequency.count\">\n                                        {{ \"Every \" + frequency.displayFrequency }}\n                                    </label>\n                                  </div>\n                            </ng-container>\n                        </div>\n                    </div>\n                    <div class=\"sns-modal__footer d-flex pt-4 align-items-center flex-column\">\n                        <div class=\"sns-modal__footer-btn\">\n                            <button\n                                type=\"submit\"\n                                class=\"btn btn-xl btn-primary\"\n                                (click)=\"saveFrequency()\"\n                            >\n                            {{ dataConfig.contents?.frequencyButtonLabel }}\n                            </button>\n                        </div>\n                        <div class=\"sns-modal__footer-more-info d-flex flex-column align-items-center\">\n                            <a\n                                role=\"link\"\n                                class=\"link-xs sns-modal__footer-faq-link\"\n                                href=\"{{ dataConfig.contents?.footerLink }}\"\n                                target=\u201D_blank\u201D\n                                (click)=\"analyticsLinkClick('faqs')\"\n                                [attr.aria-label]=\"dataConfig.contents?.footerLinkText\">\n                                {{ dataConfig.contents?.footerLinkText }}\n                            </a>\n                        </div>\n                    </div>\n                </div>\n            </form>\n        </div>\n    </div>\n</ng-container>\n<ng-container *ngIf=\"dataConfig.modal === 'addRecurringModal'\">\n    <div\n        class=\"modal fade sns-modal-container\"\n        data-backdrop=\"false\"\n        tabindex=\"-1\"\n        id=\"add-recurring-order-modal\"\n        aria-labelledby=\"modal-label-modal-sns\"\n        [attr.aria-hidden]=\"!dataConfig.showModal\"\n        [ngClass]=\"dataConfig.showModal? 'show d-block': 'd-none'\"\n        (keydown)=\"onKeydownEvent($event, '#add-recurring-order-modal')\"\n    >\n        <div class=\"modal-dialog sns-modal\" role=\"document\">\n            <div role=\"dialog\" aria-labelledby=\"addRecurringHeaderTxt\" class=\"modal-content sns-modal__content py-4\">\n                <div class=\"modal-header sns-modal__header sns-modal--content-frequency__header px-4 py-3 flex-column\">\n                    <div class=\"align-items-center d-flex mb-2\">\n                        <h1 class=\"modal-title w-100 text-center title-lg d-flex flex-start\" id=\"addRecurringHeaderTxt\">\n                            {{ dataConfig.contents?.addRecurHeader }}\n                        </h1>\n                        <button \n                        (keydown.enter)=\"closeModal()\" \n                        (click)=\"closeModal();analyticsSnsModalClick('ar:adding-to-recurring-order|close')\" \n                        class=\"p-0 m-0 close sns-modal__close-btn\" \n                        data-dismiss=\"modal\" \n                        aria-label=\"Close\">\n                            <span class=\"svg-icon svg-close-primary\"></span>\n                        </button>\n                    </div>\n                    <h2 class=\"title-sm\">{{ dataConfig.contents?.addRecurMessage }}</h2>\n                </div>\n                <div class=\"sns-modal__body px-3 pb-5\">\n                    <div class=\"sns-modal__info-box\">\n                        <div class=\"sns-modal__image-content float-left\">\n                            <img class=\"sns-modal__image\" src=\"https://images.albertsons-media.com/is/image/ABS/{{dataConfig.product.id}}?$ecom-product-card-desktop-jpg$&defaultImage=Not_Available\" alt=\"{{dataConfig.product.name}}\" />\n                        </div>\n                        <div class=\"sns-modal__info-content float-left\">\n                            <div class=\"price-lg sns-modal__default\">{{ dataConfig.contents?.addRecurTitle }}</div>\n                            <div class=\"title-xs sns-modal__title mb-2\"> {{dataConfig.product.name}}</div>\n                            <div class=\"sns-modal__fulfill align-items-center d-flex background-color-secondary-200\" *ngIf=\"dataConfig?.nextFulfillmentType?.length != 0 && dataConfig?.nextFulfillmentDate?.length != 0\">\n                                <div [ngClass]=\"dataConfig.nextFulfillmentType === 'DUG' ? 'svg-pickup' : 'svg-delivery'\">\n                                </div>\n                                <div class=\"word-highlight-xs ml-1\">{{dataConfig.nextFulfillmentType == 'dug' ? dataConfig.contents?.footerNextFulfillmentPickup : dataConfig.contents?.footerNextFulfillmentDelivery }}: {{dataConfig.nextFulfillmentDate | date: 'MMM. dd'}}</div>\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"sns-modal__freq-content d-flex flex-column pt-4\">\n\n                        <quantity-stepper-al-v1\n                            [ngClass]=\"'quantity-stepper-v3 quantity-stepper-v3--responsive-width'\"\n                            id=\"{{dataConfig.product.id}}\"\n                            [product]=\"dataConfig.product\"\n                            [calledBy]=\"'snsCheckoutFlowModal'\"\n                            [configObj]=\"configObj\"\n                            (updateQscQtyEmitter)=\"getUpdatedQty($event)\"\n                            [isAnyProductHasAddlInfo] = \"true\"\n                            [isQscV2]=\"false\" >\n                        </quantity-stepper-al-v1>\n\n                        <div class=\"input-field responsive-width\">\n                            <div class=\"input-field__wrapper text-dropdown-responsive\" role=\"listbox\">\n                                <label for=\"week\" class=\"input-field__float-label\">\n                                    <select id=\"week\" \n                                    name=\"frequency\" \n                                    placeholder=\" \" \n                                    aria-label=\"Frequency\" \n                                    (change)=\"saveRecurringFreq($event.target.value)\"\n                                    >\n                                        <option *ngFor=\"let frequency of dataConfig.frequencies\"\n                                        name=\"frequency\"\n                                        [id]=\"'frequencyLabel' + frequency.count\"\n                                        class=\"dropdown__group\"\n                                        [value]=\"frequency.count\"\n                                        >{{ \"Every \" + frequency.displayFrequency }}</option>\n                                    </select>\n                                    <span class=\"word-highlight-xs\">Frequency</span>\n                                </label>\n                            </div>\n                        </div>\n                    </div>\n                </div>\n                <div class=\"sns-modal__footer d-flex pt-4 align-items-end flex-column\">\n                    <div class=\"sns-modal__button-box align-items-center d-flex\">\n                        <button class=\"btn btn-xl btn-primary\" data-dismiss=\"modal\" (click)=\"saveRecurringDetails();analyticsSnsModalClick('ar:subscribe-schedule-and-save-plp|subscribed')\">{{ dataConfig.contents?.addRecurButtonLabel }}</button>\n                        <button class=\"btn btn-xl btn-secondary sns-modal__button mr-3\" data-dismiss=\"modal\" (click)=\"closeModal();analyticsSnsModalClick('ar:adding-to-recurring-order|not-now')\">{{ dataConfig.contents?.addRecurButtonNotNowLabel }}</button>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</ng-container>\n\n<ng-container *ngIf=\"dataConfig.modal === 'errorModal'\">\n    <div class=\"modal fade sns-modal-container\" id=\"error-modal\" role=\"dialog\"\n        aria-labelledby=\"modal-label-modal-sns\" aria-hidden=\"true\"\n        tabindex=\"-1\"\n        data-backdrop=\"false\"\n        [attr.aria-hidden]=\"!dataConfig.showModal\"\n        [ngClass]=\"dataConfig.showModal? 'show d-block': 'd-none'\"\n        (keydown)=\"onKeydownEvent($event, '#error-modal')\"\n        >\n        <div class=\"modal-dialog modal-dialog-centered sns-modal--content-error\" role=\"document\">\n            <div class=\"modal-content sns-modal--content-error__content pt-3\">\n                <div class=\"modal-header sns-modal__header sns-modal--content-frequency__header px-4 py-3 \">\n                    <div class=\"sr-only\" id=\"errorModalDescription\" *ngIf=\"dataConfig.errModalType === 'subscribe'\">\n                        We're unable to subscribe, due to a technical error, we're unable to add this item to a Schedule & Save subscription. Please try again later.\n                    </div>\n                    <div class=\"sr-only\" id=\"errorModalDescription\" *ngIf=\"dataConfig.errModalType === 'unsubscribe'\">\n                        We're unable to unsubscribe the item at this time. Please try again later. You may also cancel the item subscription within your Schedule & Save settings once the order is complete.\n                    </div>\n                    <button\n                    (keydown.enter)=\"closeModal()\" \n                    (click)=\"closeModal()\" \n                    class=\"close sns-modal__close-btn mb-2 mr-1\" \n                    data-dismiss=\"modal\" \n                    aria-label=\"Close\"\n                    aria-describedby=\"errorModalDescription\">\n                        <span class=\"svg-icon svg-close-primary\"></span>\n                    </button>\n                </div>\n                <div class=\"d-flex flex-column align-items-center px-3 pb-4\">\n                    <div class=\"svg-caution mb-3\"></div>\n                    <h1 class=\"title-sm-bold text-center mb-3\">\n                        We&#39;re unable to {{dataConfig.errModalType}}\n                    </h1>\n\n                    <div class=\"sns-modal--content-error__container sns-modal__ada-color text-center d-flex align-items-center mt-2\">\n                        <ng-container *ngIf=\"dataConfig.errModalType === 'subscribe'\">\n                            Due to a technical error, we&#39;re unable to add this item to a Schedule & Save subscription. Please try again later.\n                        </ng-container>\n\n                        <ng-container *ngIf=\"dataConfig.errModalType === 'unsubscribe'\">\n                            We&#39;re unable to unsubscribe the item at this time. Please try again later. You may also cancel the item subscription within your Schedule & Save settings once the order is complete.\n                        </ng-container>\n                    </div>\n                </div>\n                <div class=\"d-flex p-4 justify-content-center\">\n                    <div class=\"sns-modal__footer-btn\">\n                        <button class=\"btn btn-xl btn-primary\" (click)=\"closeModal()\">Close</button>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</ng-container>\n<ng-container *ngIf=\"dataConfig.modal === 'successModal'\">\n    <div\n        class=\"modal fade sns-modal-container\"\n        id=\"success-modal\"\n        tabindex=\"-1\"\n        data-backdrop=\"false\"\n        aria-labelledby=\"modal-label-modal-sns\"\n        [attr.aria-hidden]=\"!dataConfig.showModal\"\n        [ngClass]=\"dataConfig.showModal? 'show d-block': 'd-none'\"\n        (keydown)=\"onKeydownEvent($event, '#success-modal')\"\n        >\n        <div class=\"modal-dialog sns-modal\" role=\"document\">\n            <div role=\"dialog\" aria-labelledby=\"itemSchedHeaderTxt\" class=\"modal-content sns-modal sns-modal__content py-4\">\n                <div class=\"modal-header sns-modal__header sns-modal--content-frequency__header px-4 py-3 flex-column\">\n                    <div class=\"align-items-center d-flex mb-2\">\n                        <h1 class=\"modal-title w-100 text-center title-lg\" id=\"itemSchedHeaderTxt\">\n                            {{ dataConfig.contents?.itemSchedHeader }}\n                        </h1>\n                        <button \n                        (keydown.enter)=\"closeModal()\" \n                        (click)=\"closeModal();analyticsSnsModalClick('ar:item-scheduled|close')\" \n                        class=\"p-0 m-0 close sns-modal__close-btn\" \n                        data-dismiss=\"modal\" \n                        aria-label=\"Close\">\n                            <span class=\"svg-icon svg-close-primary\"></span>\n                        </button>\n                    </div>\n                </div>\n                <div class=\"sns-modal__body sns-modal--content-success__body d-flex flex-column align-items-center px-2 pt-4 pb-5\">\n                    <h2 class=\"title-sm sns-modal__ada-color text-center mb-3 sns-modal--content-success__sub-header\">\n                        {{ dataConfig.contents?.itemSchedMessage }}\n                    </h2>\n                    <div class=\"sns-modal--content-success__image p-2 mb-4\">\n                        <img class=\"sns-modal__image\" src=\"https://images.albertsons-media.com/is/image/ABS/{{dataConfig.productId}}?$ecom-product-card-desktop-jpg$&defaultImage=Not_Available\" alt=\"{{dataConfig.product.name}}\" />\n                    </div>\n                    <div class=\"sns-container d-flex flex-column align-items-center mt-2 p-3\">\n                        <span class=\"d-flex align-items-center justify-content-center sns-modal--content-success__repeat-icon background-color-secondary-200\">\n                            <span class=\"sns-modal__body-sns-icon\"></span>\n                        </span>\n                        <div class=\"my-1 word-highlight-sm\">{{dataConfig.nextFulfillmentType == 'dug' ? dataConfig.contents?.footerNextFulfillmentPickup : dataConfig.contents?.footerNextFulfillmentDelivery }}</div>\n                        <div class=\"poppins-title-xl mb-4\">{{dataConfig.nextFulfillmentType == 'dug' ? dataConfig.contents?.itemSchedNextFulfillmentDatePickupText : dataConfig.contents?.itemSchedNextFulfillmentDateDeliveryText}} {{dataConfig.productFulfillDate | date: 'MMM. dd'}}</div>\n                        <div class=\"text-center pt-3 sns-modal--content-success__info\">\n                            <div class=\"body-text-sm sns-modal__ada-color\">{{ dataConfig.contents?.itemSchedFrequencyText }} {{dataConfig.selectedFrequency == '1' ? 'week' : dataConfig.selectedFrequency + ' weeks'}}\n                            </div>\n                        </div>\n                    </div>\n                    <div class=\"sns-modal__terms sns-modal--content-success__terms d-flex flex-row mt-4\">\n                        <span class=\"body-text-sm sns-modal__ada-color\">{{ dataConfig.contents?.itemSchedChangesText }} </span>\n                        <a\n                        role=\"link\"\n                        href=\"/schedule-and-save/manage\"\n                        class=\"link-sm sns-modal__default\"\n                        [attr.aria-label]=\"dataConfig.contents?.itemSchedChangesText + dataConfig.contents?.itemSchedManageLinkText\"\n                        (click)=\"analyticsLinkClick('manage')\"\n                        >{{ dataConfig.contents?.itemSchedManageLinkText }}</a>\n                    </div>\n                </div>\n                <div class=\"sns-modal__footer d-flex pt-4 justify-content-center\">\n                    <div class=\"sns-modal__footer-btn\">\n                        <button \n                        class=\"btn btn-xl btn-primary\"\n                        data-dismiss=\"modal\"\n                        (click)=\"closeModal();analyticsSnsModalClick('ar:item-scheduled|continue-shopping')\"\n                        >{{ dataConfig.contents?.itemSchedButtonLabel }}</button>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</ng-container>\n" }]
    }], () => [{ type: i1.ArService }, { type: ProductSNSModalALService }, { type: i0.ElementRef }, { type: i1.CommonService }], { closeModalEvent: [{
            type: Output
        }], selectFrequency: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(ProductSNSModalALComponent, { className: "ProductSNSModalALComponent", filePath: "components/product-sns-modal-al/product-sns-modal-al.component.ts", lineNumber: 19 }); })();

class ProductSNSModalALService {
    constructor(componentFactoryResolver, appRef, injector) {
        this.componentFactoryResolver = componentFactoryResolver;
        this.appRef = appRef;
        this.injector = injector;
        this.frequencySelected = new BehaviorSubject(null);
        this.errorModalSnsInfo = new BehaviorSubject(null);
    }
    show(dataConfig) {
        // create a component reference from the component
        const component = this.componentFactoryResolver
            .resolveComponentFactory(ProductSNSModalALComponent)
            .create(this.injector);
        component.instance.dataConfig = dataConfig;
        // Attach component to the appRef so that it's inside the ng component tree
        this.appRef.attachView(component.hostView);
        component.instance.closeModalEvent.subscribe(val => {
            if (!!dataConfig &&
                dataConfig.hasOwnProperty('modal') &&
                dataConfig.modal === 'errorModal' && dataConfig.selectedFrequency) {
                this.errorModalSnsInfo.next({
                    isChecked: dataConfig.errModalType !== 'subscribe',
                    selectedFrequency: dataConfig.selectedFrequency
                });
            }
            this.appRef.detachView(component.hostView);
            $('product-sns-modal-al').siblings(':not(script, style, #contactUsModal)').removeAttr('aria-hidden');
            const prevElement = $('#' + dataConfig.prevIdToFocus);
            if (prevElement && prevElement.length) {
                setTimeout(() => prevElement.focus(), 0);
            }
            component.destroy();
        });
        // Get DOM element from component
        const domElem = component.hostView
            .rootNodes[0];
        // Append DOM element to the body
        document.body.appendChild(domElem);
        // Put focus inside the modal
        setTimeout(() => $('.sns-modal__close-btn').focus(), 0);
        $('product-sns-modal-al').siblings(':not(script, style, #contactUsModal)').attr('aria-hidden', 'true');
    }
    emitFrequency(frequency) {
        this.frequencySelected.next(frequency);
    }
    getDynamicContents() {
        const selector = 'sns-dynamic-data-content';
        const elemRef = document.getElementsByClassName(selector);
        if (elemRef?.length > 0) {
            const contents = elemRef[0].getAttribute('data-prop-sns');
            return contents ? JSON.parse(contents) : {};
        }
        return {};
    }
    static { this.ɵfac = function ProductSNSModalALService_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ProductSNSModalALService)(i0.ɵɵinject(i0.ComponentFactoryResolver), i0.ɵɵinject(i0.ApplicationRef), i0.ɵɵinject(i0.Injector)); }; }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: ProductSNSModalALService, factory: ProductSNSModalALService.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(ProductSNSModalALService, [{
        type: Injectable
    }], () => [{ type: i0.ComponentFactoryResolver }, { type: i0.ApplicationRef }, { type: i0.Injector }], null); })();

/**
 * Quantity Dropdown for products that have the cost expressed in LB(weight)
 *
 * @template <quantity-dropdown-al-v1>
 */
const _c0$2 = (a0, a1) => ({ "product-btn--with-addl-info": a0, "product-btn--without-ar": a1 });
const _c1$2 = a0 => ({ "dropup": a0 });
const _c2$2 = a0 => ({ "est__dropdown--menu--display": a0 });
const _c3$2 = a0 => ({ "est__dropdown--menu--item-remove--disabled": a0 });
const _c4$2 = a0 => ({ "product-btn--without-ar": a0 });
const _c5$2 = a0 => ({ "btn": true, "product-btn__qty-step": true, "product-btn__qty-step--loading": a0 });
const _c6$2 = a0 => ({ "qsc-dropdown-v2-extended": a0 });
const _c7$2 = (a0, a1) => ({ "qsc-btn_qty-stepper-lb__disabled": a0, "qsc-btn_qty-stepper-lb__after": a1 });
function QuantityDropdownALV1Component_ng_container_0_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 9);
    i0.ɵɵlistener("click", function QuantityDropdownALV1Component_ng_container_0_div_4_Template_div_click_0_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.displayWeights($event)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵattributeInterpolate1("data-qty-id", "pc", ctx_r1.product.id, "Inpt");
    i0.ɵɵattributeInterpolate1("aria-label", "Sign In to Add weight ", ctx_r1.product.name, "");
    i0.ɵɵpropertyInterpolate1("id", "signIn-weight_", ctx_r1.product.id, "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.isAuthorized ? ctx_r1.selectedWeightText : ctx_r1.SIGNIN, " ");
} }
function QuantityDropdownALV1Component_ng_container_0_div_5_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 12);
    i0.ɵɵlistener("click", function QuantityDropdownALV1Component_ng_container_0_div_5_ng_container_1_Template_button_click_1_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.displayWeights($event)); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵattributeInterpolate1("aria-controls", "qtyDropdownContentList_", ctx_r1.product.id, "");
    i0.ɵɵattributeInterpolate1("aria-label", "select weight ", ctx_r1.product.name, "");
    i0.ɵɵpropertyInterpolate1("id", "qtyDropdownBtn_", ctx_r1.product.id, "");
    i0.ɵɵattribute("aria-expanded", ctx_r1.showWeights);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.selectedWeightText, " ");
} }
function QuantityDropdownALV1Component_ng_container_0_div_5_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 13);
    i0.ɵɵlistener("click", function QuantityDropdownALV1Component_ng_container_0_div_5_ng_template_2_Template_button_click_0_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.displayWeights($event)); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵattributeInterpolate1("aria-label", "select weight ", ctx_r1.product.name, "");
    i0.ɵɵpropertyInterpolate1("id", "qtyModalBtn_", ctx_r1.product.id, "");
    i0.ɵɵattribute("aria-expanded", ctx_r1.showModal);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.selectedWeightText, " ");
} }
function QuantityDropdownALV1Component_ng_container_0_div_5_div_4_li_2_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 23);
    i0.ɵɵlistener("click", function QuantityDropdownALV1Component_ng_container_0_div_5_div_4_li_2_Template_li_click_0_listener() { const i_r7 = i0.ɵɵrestoreView(_r6).index; const ctx_r1 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r1.selectWeight(i_r7)); })("mouseenter", function QuantityDropdownALV1Component_ng_container_0_div_5_div_4_li_2_Template_li_mouseenter_0_listener() { const i_r7 = i0.ɵɵrestoreView(_r6).index; const ctx_r1 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r1.mouseEnter(i_r7)); })("keypress", function QuantityDropdownALV1Component_ng_container_0_div_5_div_4_li_2_Template_li_keypress_0_listener() { const i_r7 = i0.ɵɵrestoreView(_r6).index; const ctx_r1 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r1.selectWeight(i_r7)); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "number");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r8 = ctx.$implicit;
    const i_r7 = ctx.index;
    i0.ɵɵpropertyInterpolate1("id", "dropdown-itm", i_r7, "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 3, item_r8.weight, "1.2"), " lb ");
} }
function QuantityDropdownALV1Component_ng_container_0_div_5_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 14)(1, "ul", 15);
    i0.ɵɵlistener("focusout", function QuantityDropdownALV1Component_ng_container_0_div_5_div_4_Template_ul_focusout_1_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.dropdownFocusout($event)); });
    i0.ɵɵtemplate(2, QuantityDropdownALV1Component_ng_container_0_div_5_div_4_li_2_Template, 3, 6, "li", 16);
    i0.ɵɵelementStart(3, "li", 17);
    i0.ɵɵlistener("click", function QuantityDropdownALV1Component_ng_container_0_div_5_div_4_Template_li_click_3_listener() { i0.ɵɵrestoreView(_r5); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.removeSelection()); })("keypress", function QuantityDropdownALV1Component_ng_container_0_div_5_div_4_Template_li_keypress_3_listener() { i0.ɵɵrestoreView(_r5); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.removeSelection()); })("mouseenter", function QuantityDropdownALV1Component_ng_container_0_div_5_div_4_Template_li_mouseenter_3_listener() { i0.ɵɵrestoreView(_r5); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.mouseEnterRemoveBtn()); });
    i0.ɵɵtext(4, " Remove ");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div")(6, "span", 18)(7, "span", 19)(8, "span", 20);
    i0.ɵɵtext(9, "Est. Total: \u00A0 ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "currency");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "span", 21);
    i0.ɵɵtext(13, "Estimated Total:");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "span", 21);
    i0.ɵɵtext(15);
    i0.ɵɵpipe(16, "currency");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(17, "div", 22);
    i0.ɵɵtext(18, "Final cost by weight");
    i0.ɵɵelementEnd()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(15, _c2$2, ctx_r1.showWeights));
    i0.ɵɵadvance();
    i0.ɵɵattributeInterpolate1("aria-labelledby", "qtyDropdownBtn_", ctx_r1.product.id, "");
    i0.ɵɵpropertyInterpolate1("id", "qtyDropdownContentList_", ctx_r1.product.id, "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.weightList);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(17, _c3$2, ctx_r1.selectedWeight == 0));
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(11, 9, ctx_r1.estimatedPrice, "USD"));
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(16, 12, ctx_r1.estimatedPrice, "USD"));
} }
function QuantityDropdownALV1Component_ng_container_0_div_5_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵtemplate(1, QuantityDropdownALV1Component_ng_container_0_div_5_ng_container_1_Template, 3, 8, "ng-container", 2)(2, QuantityDropdownALV1Component_ng_container_0_div_5_ng_template_2_Template, 2, 6, "ng-template", null, 1, i0.ɵɵtemplateRefExtractor)(4, QuantityDropdownALV1Component_ng_container_0_div_5_div_4_Template, 19, 19, "div", 11);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const selectWeightButton_r9 = i0.ɵɵreference(3);
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵpropertyInterpolate1("id", "select-weight_", ctx_r1.product.id, "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c1$2, ctx_r1.calledBy === "carousel"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.screenSize >= 1024 || ctx_r1.noWeightModal)("ngIfElse", selectWeightButton_r9);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngIf", ctx_r1.showWeights);
} }
function QuantityDropdownALV1Component_ng_container_0_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 3)(2, "div", 4)(3, "div", 5)(4, "div", 24)(5, "button", 25);
    i0.ɵɵlistener("click", function QuantityDropdownALV1Component_ng_container_0_ng_container_6_Template_button_click_5_listener() { i0.ɵɵrestoreView(_r10); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.decreaseWeight()); });
    i0.ɵɵelement(6, "span", 26);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(7, "span", 21);
    i0.ɵɵelementStart(8, "span", 27);
    i0.ɵɵlistener("click", function QuantityDropdownALV1Component_ng_container_0_ng_container_6_Template_span_click_8_listener($event) { i0.ɵɵrestoreView(_r10); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(!ctx_r1.noWeightModal && ctx_r1.displayModal($event)); });
    i0.ɵɵtext(9);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(10, "button", 28);
    i0.ɵɵlistener("click", function QuantityDropdownALV1Component_ng_container_0_ng_container_6_Template_button_click_10_listener() { i0.ɵɵrestoreView(_r10); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.increaseWeight()); });
    i0.ɵɵelement(11, "span", 29);
    i0.ɵɵelementEnd()()()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(17, _c4$2, (ctx_r1.configObj == null ? null : ctx_r1.configObj.programType) !== "mkp"));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(19, _c5$2, ctx_r1.loadingSpinner));
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "dec_qtyInfo_", ctx_r1.product.id, "");
    i0.ɵɵpropertyInterpolate1("id", "dec_qtyInfo_", ctx_r1.product.id, "");
    i0.ɵɵadvance(3);
    i0.ɵɵattributeInterpolate2("aria-label", "", ctx_r1.selectedWeight, " lb of ", ctx_r1.product.name, " in cart");
    i0.ɵɵpropertyInterpolate1("id", "qtyInfo_", ctx_r1.product.id, "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.selectedWeightText, " ");
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "inc_qtyInfo_", ctx_r1.product.id, "");
    i0.ɵɵpropertyInterpolate1("id", "inc_qtyInfo_", ctx_r1.product.id, "");
    i0.ɵɵproperty("disabled", ctx_r1.checkIncreaseButtonDisability());
} }
function QuantityDropdownALV1Component_ng_container_0_ng_container_7_option_39_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 57);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "number");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r12 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("value", item_r12.weight)("selected", item_r12.weight == ctx_r1.selectedItem());
    i0.ɵɵattribute("aria-label", ctx_r1.getAriaLabel(item_r12.weight));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind2(2, 4, item_r12.weight, "1.2"), " \u00A0 lb");
} }
function QuantityDropdownALV1Component_ng_container_0_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 3)(2, "div", 4)(3, "div", 30)(4, "div", 31)(5, "div", 32)(6, "div", 33)(7, "button", 34);
    i0.ɵɵlistener("click", function QuantityDropdownALV1Component_ng_container_0_ng_container_7_Template_button_click_7_listener() { i0.ɵɵrestoreView(_r11); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.closeModal()); })("keypress", function QuantityDropdownALV1Component_ng_container_0_ng_container_7_Template_button_keypress_7_listener() { i0.ɵɵrestoreView(_r11); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.closeModal()); });
    i0.ɵɵelement(8, "span", 35);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(9, "div", 36)(10, "div", 37)(11, "div", 38)(12, "picture");
    i0.ɵɵelement(13, "source", 39)(14, "source", 40)(15, "img", 41);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(16, "div", 42)(17, "p", 43);
    i0.ɵɵtext(18);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelement(19, "hr", 44);
    i0.ɵɵelementStart(20, "div", 45)(21, "p", 46);
    i0.ɵɵtext(22, "Final cost by weight");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(23, "div", 47)(24, "div", 48);
    i0.ɵɵtext(25);
    i0.ɵɵpipe(26, "currency");
    i0.ɵɵpipe(27, "lowercase");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(28, "div", 49)(29, "span", 50);
    i0.ɵɵtext(30);
    i0.ɵɵpipe(31, "currency");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(32, "div", 51);
    i0.ɵɵtext(33, "Est. total ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(34, "div", 52);
    i0.ɵɵtext(35);
    i0.ɵɵpipe(36, "currency");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(37, "div")(38, "select", 53);
    i0.ɵɵlistener("change", function QuantityDropdownALV1Component_ng_container_0_ng_container_7_Template_select_change_38_listener($event) { i0.ɵɵrestoreView(_r11); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.SelectWeightModal($event)); });
    i0.ɵɵtemplate(39, QuantityDropdownALV1Component_ng_container_0_ng_container_7_option_39_Template, 3, 7, "option", 54);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(40, "div", 55)(41, "button", 56);
    i0.ɵɵlistener("click", function QuantityDropdownALV1Component_ng_container_0_ng_container_7_Template_button_click_41_listener() { i0.ɵɵrestoreView(_r11); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.finalizeWeight()); })("keypress", function QuantityDropdownALV1Component_ng_container_0_ng_container_7_Template_button_keypress_41_listener() { i0.ɵɵrestoreView(_r11); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.finalizeWeight()); });
    i0.ɵɵtext(42, "Add ");
    i0.ɵɵelementEnd()()()()()()()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵattributeInterpolate1("aria-label", "Select weight for ", ctx_r1.product.name, "");
    i0.ɵɵadvance(10);
    i0.ɵɵattribute("srcset", ctx_r1.getImageUrl(ctx_r1.product.id, "mobile"));
    i0.ɵɵadvance();
    i0.ɵɵattribute("srcset", ctx_r1.getImageUrl(ctx_r1.product.id, "tablet"));
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("alt", ctx_r1.product.name);
    i0.ɵɵattribute("src", ctx_r1.getImageUrl(ctx_r1.product.id, "desktop"), i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.product.name);
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind2(26, 12, ctx_r1.product.pricePer, "USD"), " / ", i0.ɵɵpipeBind1(27, 15, ctx_r1.product.unitQuantity), "");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" Estimated Total ", i0.ɵɵpipeBind2(31, 17, ctx_r1.estimatedPrice, "USD"), " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(36, 20, ctx_r1.estimatedPrice, "USD"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", ctx_r1.weightList);
} }
function QuantityDropdownALV1Component_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 3)(2, "div", 4)(3, "div", 5);
    i0.ɵɵtemplate(4, QuantityDropdownALV1Component_ng_container_0_div_4_Template, 2, 7, "div", 6)(5, QuantityDropdownALV1Component_ng_container_0_div_5_Template, 5, 8, "div", 7);
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(6, QuantityDropdownALV1Component_ng_container_0_ng_container_6_Template, 12, 21, "ng-container", 8)(7, QuantityDropdownALV1Component_ng_container_0_ng_container_7_Template, 43, 23, "ng-container", 8);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(5, _c0$2, ctx_r1.isAnyProductHasAddlInfo, !ctx_r1.isAnyProductHasAddlInfo));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isAuthorized);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isAuthorized && !ctx_r1.isButtonenabled);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isButtonenabled);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showModal);
} }
function QuantityDropdownALV1Component_ng_template_1_div_5_li_2_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 70);
    i0.ɵɵlistener("mouseenter", function QuantityDropdownALV1Component_ng_template_1_div_5_li_2_Template_li_mouseenter_0_listener() { const i_r16 = i0.ɵɵrestoreView(_r15).index; const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.mouseEnter(i_r16)); })("click", function QuantityDropdownALV1Component_ng_template_1_div_5_li_2_Template_li_click_0_listener() { const i_r16 = i0.ɵɵrestoreView(_r15).index; const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.selectWeight(i_r16)); })("keypress", function QuantityDropdownALV1Component_ng_template_1_div_5_li_2_Template_li_keypress_0_listener() { const i_r16 = i0.ɵɵrestoreView(_r15).index; const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.selectWeight(i_r16)); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "number");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r17 = ctx.$implicit;
    const i_r16 = ctx.index;
    i0.ɵɵpropertyInterpolate1("id", "dropdown-itm", i_r16, "");
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 3, item_r17.weight, "1.2"), " lb ");
} }
function QuantityDropdownALV1Component_ng_template_1_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r14 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 62)(1, "ul", 63);
    i0.ɵɵlistener("focusout", function QuantityDropdownALV1Component_ng_template_1_div_5_Template_ul_focusout_1_listener($event) { i0.ɵɵrestoreView(_r14); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.dropdownFocusout($event)); });
    i0.ɵɵtemplate(2, QuantityDropdownALV1Component_ng_template_1_div_5_li_2_Template, 3, 6, "li", 64);
    i0.ɵɵelementStart(3, "li", 65);
    i0.ɵɵlistener("click", function QuantityDropdownALV1Component_ng_template_1_div_5_Template_li_click_3_listener() { i0.ɵɵrestoreView(_r14); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.qscV2RemoveSelection()); })("keypress", function QuantityDropdownALV1Component_ng_template_1_div_5_Template_li_keypress_3_listener() { i0.ɵɵrestoreView(_r14); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.qscV2RemoveSelection()); })("mouseenter", function QuantityDropdownALV1Component_ng_template_1_div_5_Template_li_mouseenter_3_listener() { i0.ɵɵrestoreView(_r14); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.mouseEnterRemoveBtn()); });
    i0.ɵɵtext(4, " Remove ");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div")(6, "span", 66)(7, "span", 67)(8, "span", 68);
    i0.ɵɵtext(9, "Est. Total: \u00A0 ");
    i0.ɵɵelementEnd();
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "currency");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "span", 21);
    i0.ɵɵtext(13, "Estimated Total:");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "span", 21);
    i0.ɵɵtext(15);
    i0.ɵɵpipe(16, "currency");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "div", 69);
    i0.ɵɵtext(18, "Final cost by weight");
    i0.ɵɵelementEnd()()()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(15, _c2$2, ctx_r1.showWeights));
    i0.ɵɵadvance();
    i0.ɵɵattributeInterpolate1("aria-labelledby", "qtyDropdownBtn_", ctx_r1.product.id, "");
    i0.ɵɵpropertyInterpolate1("id", "qtyDropdownContentList_", ctx_r1.product.id, "");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.weightList);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(17, _c3$2, ctx_r1.selectedWeight == 0));
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(11, 9, ctx_r1.estimatedPrice, "USD"), " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(16, 12, ctx_r1.estimatedPrice, "USD"));
} }
function QuantityDropdownALV1Component_ng_template_1_ng_container_6_option_39_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "option", 57);
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "number");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r19 = ctx.$implicit;
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("value", item_r19.weight)("selected", item_r19.weight == ctx_r1.selectedItem());
    i0.ɵɵattribute("aria-label", ctx_r1.getAriaLabel(item_r19.weight));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind2(2, 4, item_r19.weight, "1.2"), " \u00A0 lb");
} }
function QuantityDropdownALV1Component_ng_template_1_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    const _r18 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 3)(2, "div", 4)(3, "div", 30)(4, "div", 31)(5, "div", 32)(6, "div", 33)(7, "button", 34);
    i0.ɵɵlistener("click", function QuantityDropdownALV1Component_ng_template_1_ng_container_6_Template_button_click_7_listener() { i0.ɵɵrestoreView(_r18); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.closeModal()); })("keypress", function QuantityDropdownALV1Component_ng_template_1_ng_container_6_Template_button_keypress_7_listener() { i0.ɵɵrestoreView(_r18); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.closeModal()); });
    i0.ɵɵelement(8, "span", 35);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(9, "div", 36)(10, "div", 37)(11, "div", 38)(12, "picture");
    i0.ɵɵelement(13, "source", 39)(14, "source", 40)(15, "img", 41);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(16, "div", 42)(17, "p", 43);
    i0.ɵɵtext(18);
    i0.ɵɵelementEnd()()();
    i0.ɵɵelement(19, "hr", 44);
    i0.ɵɵelementStart(20, "div", 45)(21, "p", 46);
    i0.ɵɵtext(22, "Final cost by weight");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(23, "div", 47)(24, "div", 48);
    i0.ɵɵtext(25);
    i0.ɵɵpipe(26, "currency");
    i0.ɵɵpipe(27, "lowercase");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(28, "div", 49)(29, "span", 50);
    i0.ɵɵtext(30);
    i0.ɵɵpipe(31, "currency");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(32, "div", 51);
    i0.ɵɵtext(33, "Est. total ");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(34, "div", 52);
    i0.ɵɵtext(35);
    i0.ɵɵpipe(36, "currency");
    i0.ɵɵelementEnd()()();
    i0.ɵɵelementStart(37, "div")(38, "select", 53);
    i0.ɵɵlistener("change", function QuantityDropdownALV1Component_ng_template_1_ng_container_6_Template_select_change_38_listener($event) { i0.ɵɵrestoreView(_r18); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.SelectWeightModal($event)); });
    i0.ɵɵtemplate(39, QuantityDropdownALV1Component_ng_template_1_ng_container_6_option_39_Template, 3, 7, "option", 54);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(40, "div", 55)(41, "button", 56);
    i0.ɵɵlistener("click", function QuantityDropdownALV1Component_ng_template_1_ng_container_6_Template_button_click_41_listener() { i0.ɵɵrestoreView(_r18); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.finalizeWeight()); })("keypress", function QuantityDropdownALV1Component_ng_template_1_ng_container_6_Template_button_keypress_41_listener() { i0.ɵɵrestoreView(_r18); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.finalizeWeight()); });
    i0.ɵɵtext(42, "Add ");
    i0.ɵɵelementEnd()()()()()()()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵattributeInterpolate1("aria-label", "Select weight for ", ctx_r1.product.name, "");
    i0.ɵɵadvance(10);
    i0.ɵɵattribute("srcset", ctx_r1.getImageUrl(ctx_r1.product.id, "mobile"));
    i0.ɵɵadvance();
    i0.ɵɵattribute("srcset", ctx_r1.getImageUrl(ctx_r1.product.id, "tablet"));
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate("alt", ctx_r1.product.name);
    i0.ɵɵattribute("src", ctx_r1.getImageUrl(ctx_r1.product.id, "desktop"), i0.ɵɵsanitizeUrl);
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate(ctx_r1.product.name);
    i0.ɵɵadvance(7);
    i0.ɵɵtextInterpolate2("", i0.ɵɵpipeBind2(26, 12, ctx_r1.product.pricePer, "USD"), " / ", i0.ɵɵpipeBind1(27, 15, ctx_r1.product.unitQuantity), "");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate1(" Estimated Total ", i0.ɵɵpipeBind2(31, 17, ctx_r1.estimatedPrice, "USD"), " ");
    i0.ɵɵadvance(5);
    i0.ɵɵtextInterpolate(i0.ɵɵpipeBind2(36, 20, ctx_r1.estimatedPrice, "USD"));
    i0.ɵɵadvance(4);
    i0.ɵɵproperty("ngForOf", ctx_r1.weightList);
} }
function QuantityDropdownALV1Component_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r13 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 58)(1, "div", 4)(2, "div", 59)(3, "button", 60);
    i0.ɵɵlistener("click", function QuantityDropdownALV1Component_ng_template_1_Template_button_click_3_listener($event) { i0.ɵɵrestoreView(_r13); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.qscDisplayWeights($event)); });
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(5, QuantityDropdownALV1Component_ng_template_1_div_5_Template, 19, 19, "div", 61);
    i0.ɵɵelementEnd()()();
    i0.ɵɵtemplate(6, QuantityDropdownALV1Component_ng_template_1_ng_container_6_Template, 43, 23, "ng-container", 8);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(15, _c6$2, ctx_r1.isExtended));
    i0.ɵɵadvance(2);
    i0.ɵɵpropertyInterpolate1("id", "select-weight_", ctx_r1.product.id, "");
    i0.ɵɵadvance();
    i0.ɵɵattributeInterpolate1("aria-controls", "qtyDropdownContentList_", ctx_r1.product.id, "");
    i0.ɵɵattributeInterpolate1("aria-label", "select weight ", ctx_r1.product.name, "");
    i0.ɵɵpropertyInterpolate1("id", "qtyDropdownBtn_", ctx_r1.product.id, "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(17, _c7$2, !ctx_r1.isCheckboxChecked, ctx_r1.isExtended))("disabled", !ctx_r1.isCheckboxChecked);
    i0.ɵɵattribute("aria-expanded", ctx_r1.showWeights);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.selectedWeightText, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showWeights);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showModal);
} }
class QuantityDropdownALV1Component {
    constructor(_commonService, _userInfoService, _elementRef, toasterService, cartService, _http, cartV2Service, _aemService, _productUtilService, _utilService, _productSnsModalService, _quickAddBasketService) {
        this._commonService = _commonService;
        this._userInfoService = _userInfoService;
        this._elementRef = _elementRef;
        this.toasterService = toasterService;
        this.cartService = cartService;
        this._http = _http;
        this.cartV2Service = cartV2Service;
        this._aemService = _aemService;
        this._productUtilService = _productUtilService;
        this._utilService = _utilService;
        this._productSnsModalService = _productSnsModalService;
        this._quickAddBasketService = _quickAddBasketService;
        this.removeMiniCartEmitter = new EventEmitter();
        this.changeMiniCartEmitter = new EventEmitter();
        this.updateUnavailableCountEmitter = new EventEmitter();
        this.setLoadingSpinnerEmitter = new EventEmitter();
        this.updateCheckboxEmitter = new EventEmitter();
        this.updateQscQtyEmitter = new EventEmitter();
        this.config = EnviormentConfig;
        this.reservedTimeIntent = '';
        this.showWeights = false;
        this.showModal = false;
        this.previousSelectedWeight = false;
        this.weightList = [];
        this.estimatedPrice = 0;
        this.selectedWeight = 0;
        this.currentSelectedWeight = 0;
        this.isButtonenabled = false;
        this.addItemToCartAnalytics = false;
        this.increaseQuantityAnalytics = false;
        this.decreaseItemAnalytics = false;
        this.selectedWeightText = 'Select Weight';
        this.SIGNIN = 'Sign in to add';
        this.isAuthorized = false;
        this.isQuantityIncreased = false;
        this.imagePath = window['AB']['dMTProductCard'];
        this.modalTriggeredElement = null;
        this.modal = {
            closeBtn: '#modal-est .close',
            modalId: '#modal-est',
            lastFocusableElem: '.amount__add-qty-btn .btn-primary'
        };
        this.isExtended = false;
        this.loadingSpinner = false;
        this.isOnProductDetail = false;
        this.currentEnv = '';
        this.toastMessagePostion = '29vh';
        this.snsInfoChange = new Subject();
        this.snsInfoChange$ = this.snsInfoChange.asObservable();
        this.subscriptions = new Subscription();
        this.isAuthorized = this._userInfoService.isAuthorized();
        this.reservedTimeIntent = this._userInfoService.getUserChannel();
        this.currentEnv = this._commonService.getCurrentEnviorment();
        this.enableAdRelevanceTracking = !this._aemService.getFeatureFlagByNameDisable('disableAdRelevance');
    }
    ngOnChanges(changes) {
        if (changes.snsInfo && changes.snsInfo.currentValue.updateCart) {
            const qty = this.calledBy === 'minicart' ? this.product.qty : this.product.quantity;
            if (qty > 0) {
                this.snsInfoChange.next({ qty: qty, snsInfo: changes.snsInfo });
            }
        }
    }
    ;
    ngOnInit() {
        this.isOnProductDetail = this.calledBy === 'product-detail-item';
        this.screenSize = window.innerWidth;
        if (this.isQscV2) {
            this.selectedWeight = this.getSelectedWeight();
            this.selectedWeightText = Number(this.selectedWeight).toFixed(2) + ' lb';
            this.initializeWeightList();
            let cartObjSubscription = this._commonService.currentCartObj.subscribe((cartObj) => {
                const matchingItem = cartObj?.cartItems?.find(item => item.itemId == this.product.id);
                if (matchingItem) {
                    this.processChangesFromCart(matchingItem.selectedWeight);
                }
            });
            this.subscriptions.add(cartObjSubscription);
            return;
        }
        if (this.calledBy == 'minicart') {
            this.product['id'] = this.product.itemId;
            this.isButtonenabled = true;
            this.selectedWeight = this.product.selectedWeight ? this.product.selectedWeight : 0;
            this.weightList = this.product.incrementPriceList ? this.product.incrementPriceList : [];
            if (this.selectedWeight == this.weightList[this.weightList.length - 1].weight) {
                this.selectedWeightText = Number(this.selectedWeight) + ' lb';
            }
            else {
                this.selectedWeightText = Number(this.selectedWeight) + ' lb';
            }
        }
        if (this.calledBy !== 'minicart') {
            let obs = this._commonService.currentCartObj;
            const cartName = this.cartV2Service.getCartName(this.configObj?.programType, this.sellerId);
            obs = obs.pipe(map(objCart => this.cartV2Service.fetchCartDetailsFromResponse(objCart, cartName)));
            obs.subscribe(objCart => {
                this.hasCart = !!objCart.cartId;
                let qty = 0;
                let list = [];
                try {
                    let cartProduct = {};
                    cartProduct = objCart['cartItems'].find(item => item.itemId == this.product.id);
                    qty = cartProduct ? cartProduct.selectedWeight : 0;
                    list = cartProduct ? cartProduct.incrementPriceList : [];
                }
                catch (e) {
                    qty = 0;
                    list = [];
                }
                this.weightList = list;
                this.selectedWeight = qty;
                if (this.selectedWeight != 0) {
                    if (this.selectedWeight == this.weightList[this.weightList.length - 1].weight) {
                        this.selectedWeightText = Number(this.selectedWeight) + ' lb';
                    }
                    else {
                        this.selectedWeightText = Number(this.selectedWeight) + ' lb';
                    }
                }
                else {
                    this.selectedWeightText = 'Select Weight';
                }
            });
        }
        if (this.selectedWeight != 0 && this.screenSize < 1024) {
            this.isButtonenabled = true;
        }
        // Debounce 600ms before sending data to API.
        this.snsInfoChange$.pipe(debounceTime(600))
            .subscribe(snsInfoObj => {
            this._cartAPICallV2(snsInfoObj.qty, snsInfoObj.snsInfo);
        });
    }
    onResize(event) {
        this.screenSize = window.innerWidth;
    }
    displayWeights(event) {
        if (this.isAuthorized) {
            const preference = this._userInfoService.getPreference()
                ? this._userInfoService.getPreference().toUpperCase()
                : undefined;
            if (preference === 'J4U') {
                window['storeFulfillmentModal'].component.setModalDisplayData(2);
            }
            else {
                if (this.screenSize >= 1024 || this.noWeightModal) {
                    this.showModal = false;
                    if (this.showWeights) {
                        this.showWeights = false;
                        if (this.selectedWeight !== 0) {
                            this.selectedWeightText = Number(this.selectedWeight).toFixed(2) + ' lb';
                        }
                    }
                    else {
                        if (this.weightList && this.weightList.length > 0) {
                            this.showWeights = true;
                            if (this.selectedWeight !== 0) {
                                this.selectedWeightText = Number(this.selectedWeight).toFixed(2) + ' lb';
                            }
                            this.setADANavigation();
                        }
                        else {
                            this.initializeWeightList();
                            this.setADANavigation();
                        }
                    }
                }
                else {
                    this.displayModal(event);
                }
            }
        }
        else {
            if (window['eddlLoadComplete']) {
                window['AB']['DATALAYER'].setATCFlag(true);
            }
            this._showSignInModal(this.configObj);
        }
    }
    qscDisplayWeights(event) {
        if (this._userInfoService.getUserChannel() == 'instore') {
            event.preventDefault();
            window['rightDrawerComp'].closeDrawer();
            window['storeFulfillmentModal'].component.setModalDisplayData(2);
            return;
        }
        if (this.screenSize >= 1024) {
            this.showWeights = true;
            this.isExtended = true;
            this.setADANavigation();
        }
        else {
            this.previousSelectedWeight = true;
            this.selectedWeight = this.getSelectedWeight();
            this.displayModal(event);
        }
    }
    /**
    * Show sign in modal to unregistered users.
    */
    _showSignInModal(configObj) {
        const redirectPath = encodeURIComponent(window.location.href);
        this._aemService.setDomainCookie('ECommRedirectURL', redirectPath, 0);
        if (configObj && configObj?.appName === 'weeklyAd') {
            const bannerDomainUrl = this._productUtilService.getBannerDomainUrl(this.configObj);
            window.location.assign(bannerDomainUrl + window['AB'].signInLinkPath);
        }
        else {
            window['AB']['COMMON'].showSignInModal_OTP(window.location.href);
        }
    }
    qscV2UpdateWeight() {
        this._quickAddBasketService.setQuickAddBasketItemWeight(this.product.id, Number(this.selectedWeight));
    }
    // Logic for modifying quickAddBasket localStorage item and component data on 
    // changes from cart. 
    processChangesFromCart(weightFromCart) {
        this.selectedWeight = weightFromCart;
        this.selectedWeightText = this.normalizeWeightText(this.selectedWeight);
        // If modal is showing, need to update state using this method. 
        if (this.showModal) {
            this.SelectWeightModal({ target: {
                    value: weightFromCart
                } });
        }
        this.qscV2UpdateWeight();
    }
    showPriceChangeToast(isQuantityIncreased, cart) {
        const isOrderAmendDisabled = this._aemService.getFeatureFlagByNameDisable('isOrderAmendDisabled');
        if (!isOrderAmendDisabled && isQuantityIncreased && this._commonService.checkPendingOrder()) {
            const orderedProduct = cart['cartItems']?.find(item => item.itemId === this.product.id);
            const price = this._commonService.getValidProductPrice(this.product);
            const orderedItemPrice = orderedProduct?.price < orderedProduct?.basePrice ? orderedProduct?.price : orderedProduct?.basePrice;
            if (orderedProduct && orderedItemPrice !== price) {
                let msg = `Great news—your price for this item is still $${orderedItemPrice}, based on when you placed your order. `;
                if (orderedItemPrice > price) {
                    msg = `The price for ${this.product.name} has changed, but your price is still $${orderedItemPrice} based on its price on the day your order was placed. `;
                }
                this.toasterService.show({
                    title: 'OK',
                    message: msg,
                    type: ToasterType.Info,
                    interactiveElement: 'See Policy',
                    interactiveElementLink: 'https://www.albertsonscompanies.com/policies-and-disclosures/terms-of-use/default.aspx',
                }, { class: 'popup--toaster--right' });
            }
        }
    }
    selectWeight(i) {
        if (this.selectedWeight < this.weightList[i].weight) {
            this.isQuantityIncreased = true;
        }
        this.showWeights = false;
        this.selectedWeight = this.weightList[i].weight;
        this.selectedWeightText = this.isQscV2 ? Number(this.selectedWeight).toFixed(2) + ' lb' : Number(this.selectedWeight) + ' lb';
        this.refocusSelectBtn();
        this.isQscV2 ? this.qscV2UpdateWeight() : this.updateWeight(this.selectedWeight);
        if (this.isQscV2) {
            this.isExtended = false;
        }
    }
    removeSelection() {
        this._removeProductV2();
        this.refocusSelectBtn();
    }
    qscV2RemoveSelection() {
        this.qscV2RemoveProduct();
        this.showWeights = false;
        this.isExtended = false;
        this.qscV2RefocusSelectBtn();
    }
    qscV2RemoveProduct() {
        this._quickAddBasketService.setQuickAddBasketSelectedProperty(this.product.id, false);
        this.updateCheckboxEmitter.emit();
    }
    mouseEnter(i) {
        this.estimatedPrice = this.weightList[i].price;
        setTimeout(() => {
            $('#dropdown-itm' + i).focus();
        }, 0);
    }
    mouseEnterRemoveBtn() {
        this.estimatedPrice = 0;
    }
    mouseLeave() {
        this.estimatedPrice = 0;
    }
    refocusSelectBtn() {
        setTimeout(() => {
            $(`.pid${this.product.id} .quantity-dropdown__btn`).focus();
        }, 0);
    }
    qscV2RefocusSelectBtn() {
        setTimeout(() => {
            $(this._elementRef.nativeElement).children().find("span#qtyDropdownBtn_" + this.product.id).focus();
        }, 0);
    }
    displayModal(event) {
        this.modalTriggeredElement = event.target;
        this.showWeights = false;
        this.showModal = true;
        this.setModalADA();
        this.productDetailPath = this._commonService.getProductDetailPath();
        if (this.productDetailPath) {
            this.productDetailPath = this.productDetailPath.replace('(bpn)', this.product.id);
        }
        if (this.weightList.length > 0) {
            if (this.selectedWeight == 0) {
                this.estimatedPrice = this.weightList[0].price;
            }
            else {
                const preWeight = this.selectedWeight;
                this.estimatedPrice = this.weightList.find(item => item.weight == preWeight).price;
            }
        }
        else {
            this.initializeWeightList();
        }
    }
    setModalADA() {
        // Set ADA for weighted item modal
        setTimeout(() => {
            const lbvsEach = this;
            $(this.modal.modalId).modal({
                backdrop: 'static',
                keyboard: false,
                show: true
            });
            $(this.modal.modalId).on('shown.bs.modal', function () {
                lbvsEach.modalADA();
            });
            $(this.modal.modalId).on('hidden.bs.modal', function () {
                lbvsEach.modalHideADA();
            });
        }, 0);
    }
    // Sets text to follow format from Figma for Quick Add Web Enhancements
    normalizeWeightText(weight) {
        return Number(weight).toFixed(2) + ' lb';
    }
    modalADA() {
        const closeBtn = this.modal.closeBtn;
        const modalId = this.modal.modalId;
        const last = this.modal.lastFocusableElem;
        $(modalId).removeAttr('aria-modal');
        let currentElement = $(modalId);
        while (currentElement.length && currentElement.prop("tagName") != "BODY") {
            // Store off the current aria-hidden state, if attribute doesn't exist, use "none"
            let ariaHiddenState = currentElement.attr("aria-hidden");
            if (!ariaHiddenState)
                ariaHiddenState = 'none';
            currentElement.attr("data-aria-state", ariaHiddenState);
            // Set aria-hidden to false (for elements up the parent chain)
            currentElement.attr("aria-hidden", 'false');
            // Iterate over all of the siblings, storing their state and setting aria-hidden to true
            // so that they will not be accessible while the modal is displayed
            currentElement.siblings().each(function () {
                let siblingAriaHiddenState = $(this).attr("aria-hidden");
                if (!siblingAriaHiddenState)
                    siblingAriaHiddenState = 'none';
                $(this).attr("data-aria-state", siblingAriaHiddenState);
                $(this).attr("aria-hidden", 'true');
            });
            currentElement = currentElement.parent();
        }
        $(last).on('keydown keypress', function (e) {
            if ($('this:focus') && e.which === 9) {
                if (closeBtn === last) {
                    e.preventDefault();
                }
                else if (!e.shiftKey) {
                    $(closeBtn).focus();
                    e.preventDefault();
                }
            }
        });
        $(closeBtn).on('keydown keypress', function (e) {
            if ($('this:focus') && e.which === 9) {
                if (e.shiftKey) {
                    $(last).focus();
                    e.preventDefault();
                }
            }
        });
        // Close modal when ESC is pressed
        const that = this;
        $(modalId).on('keydown', function (e) {
            if (e.which == 27 && $(modalId).is(':visible')) {
                that.closeModal();
            }
        });
        //Set focus on the close button of the Modal.
        setTimeout(() => {
            $(closeBtn).focus();
        }, 400);
    }
    modalHideADA() {
        // Find all of the previously saved aria-hidden states and put back
        $("[data-aria-state]").each(function () {
            // Get the saved state and remove the property
            let ariaHiddenState = $(this).attr("data-aria-state");
            $(this).removeAttr('data-aria-state');
            // If the state is set to none, it means it didn't exist so remove it
            if (ariaHiddenState == 'none')
                $(this).removeAttr('aria-hidden');
            else
                $(this).attr('aria-hidden', ariaHiddenState);
        });
        const element = $('#dec_qtyInfo_' + this.product.id);
        if (element.length > 0) {
            element.focus();
        }
        else {
            $('#select-weight_' + this.product.id).focus();
        }
    }
    SelectWeightModal(event) {
        this.currentSelectedWeight = event.target.value;
        this.estimatedPrice = this.weightList.find(item => item.weight == event.target.value).price;
    }
    selectedItem() {
        if (!this.previousSelectedWeight) {
            return this.weightList[0].weight;
        }
        return this.selectedWeight;
    }
    finalizeWeight() {
        this.showModal = false;
        this.isButtonenabled = true;
        this.previousSelectedWeight = true;
        if (this.currentSelectedWeight == 0) {
            this.selectedWeight = this.weightList[0].weight;
        }
        else {
            this.selectedWeight = this.currentSelectedWeight;
        }
        this.currentSelectedWeight = 0;
        this.selectedWeightText = this.isQscV2 ? Number(this.selectedWeight).toFixed(2) + ' lb' : Number(this.selectedWeight) + ' lb';
        this.isQscV2 ? this._quickAddBasketService.setQuickAddBasketItemWeight(this.product.id, Number(this.selectedWeight)) : this.updateWeight(this.selectedWeight);
        $('#modal-est').modal('hide');
    }
    decreaseWeight() {
        if (this.selectedWeight == this.weightList[0].weight) {
            if (this.calledBy !== 'minicart') {
                this._removeProductV2();
            }
            else {
                this._removeMinicart();
            }
        }
        else {
            const currentWeight = this.selectedWeight;
            const index = this.weightList.findIndex(item => item.weight == currentWeight);
            this.selectedWeight = this.weightList[index - 1].weight;
            this.selectedWeightText = Number(this.selectedWeight) + ' lb';
            this.loadingSpinner = true;
            this.updateWeight(this.selectedWeight);
        }
    }
    _removeMinicart() {
        this.removeMiniCartEmitter.emit(this.product.id);
    }
    resetToSelectWeight() {
        this.isButtonenabled = false;
        this.showWeights = false;
        this.selectedWeight = 0;
        this.selectedWeightText = 'Select Weight';
        this.previousSelectedWeight = false;
    }
    increaseWeight() {
        const currentWeight = this.selectedWeight;
        const index = this.weightList.findIndex(item => item.weight == currentWeight);
        this.selectedWeight = this.weightList[index + 1].weight;
        if (this.selectedWeight == this.weightList[this.weightList.length - 1].weight) {
            this.selectedWeightText = Number(this.selectedWeight) + ' lb';
        }
        else {
            this.selectedWeightText = Number(this.selectedWeight) + ' lb';
        }
        this.loadingSpinner = true;
        this.updateWeight(this.selectedWeight);
    }
    checkIncreaseButtonDisability() {
        if (this.weightList.length > 0) {
            return this.selectedWeight == this.weightList[this.weightList.length - 1].weight;
        }
        return false;
    }
    /**
     * ADA: Sets focus inside quantity stepper with info about in cart quantity.
    */
    _setFocusInsideQty() {
        if (this.calledBy === 'minicart') {
            setTimeout(() => $(this._elementRef.nativeElement).children().find("span#qtyInfo_" + this.product.id).focus(), 0);
        }
    }
    closeModal() {
        const that = this;
        this.showModal = false;
        $('#modal-est').modal('hide');
        // Set focus back to the stored element that caused the modal to appear
        setTimeout(() => {
            if (that.modalTriggeredElement !== null) {
                that.modalTriggeredElement.focus();
                that.modalTriggeredElement = null;
            }
        }, 100);
    }
    getImageUrl(id, viewport) {
        const modifiedImagePath = this.imagePath;
        return modifiedImagePath ? modifiedImagePath.replace('${product.id}', id).replace('${viewport}', viewport) : '';
    }
    setADANavigation() {
        //ADA for down arrow navigation
        if (this.weightList && this.weightList.length > 0) {
            setTimeout(() => {
                const firstItem = "#dropdown-itm0";
                const listItem = ".dropdown-item.est__dropdown--menu--item";
                const removeBtn = ".est__dropdown--menu--item-remove";
                $(firstItem).focus();
                this.estimatedPrice = this.weightList[0].price;
                const that = this;
                $(listItem).on('keydown keypress', function (e) {
                    if ($('this:focus')) {
                        let nextFocusableElement;
                        if (e.which === 40) {
                            nextFocusableElement = $(this).next();
                        }
                        else if (e.which === 38) {
                            nextFocusableElement = $(this).prev();
                        }
                        if (nextFocusableElement && nextFocusableElement.length && nextFocusableElement.length > 0) {
                            if (!nextFocusableElement.get(0).className.includes("est__dropdown--menu--item-remove")) {
                                const nextIndex = nextFocusableElement.get(0).id.replace("dropdown-itm", "");
                                that.estimatedPrice = that.weightList[nextIndex].price;
                            }
                            else if (nextFocusableElement.get(0).className.includes("est__dropdown--menu--item-remove") &&
                                !nextFocusableElement.get(0).className.includes("est__dropdown--menu--item-remove--disabled")) {
                                that.estimatedPrice = 0;
                            }
                            if (!nextFocusableElement.get(0).className.includes("est__dropdown--menu--item-remove--disabled")) {
                                nextFocusableElement.focus();
                            }
                        }
                    }
                });
                $(removeBtn).on('keydown keypress', function (e) {
                    if ($('this:focus')) {
                        if (e.which === 38) {
                            const element = $(this).prev();
                            element.focus();
                        }
                    }
                });
            }, 500);
        }
    }
    dropdownFocusout(event) {
        let selectWeightBtn = document.getElementById('select-weight_' + this.product.id);
        if (selectWeightBtn) {
            if (!selectWeightBtn.contains(event.relatedTarget)) {
                if (this.selectedWeight !== 0) {
                    this.selectedWeightText = this.isQscV2 ? Number(this.selectedWeight).toFixed(2) + ' lb' : Number(this.selectedWeight) + ' lb';
                }
                this.showWeights = false;
                $(this._elementRef.nativeElement).children().find("span#qtyDropdownBtn_" + this.product.id).focus();
                if (this.isQscV2) {
                    this.isExtended = false;
                }
            }
        }
    }
    updateWeight(quantity) {
        this._cartAPICallV2(quantity);
    }
    _cartAPICallV2(quantity, snsInfoChangeObj) {
        const isCartCreated = !this.hasCart;
        const analyticsProductID = this.product.id || this.product.itemId;
        if (!window['AB']['DATALAYER'].isProductInAnalyticsCart(analyticsProductID)) {
            this.addItemToCartAnalytics = true;
        }
        if (this.calledBy !== 'minicart') {
            this.setLoadingSpinnerEmitter.emit(true);
        }
        this.cartV2Service.addOrUpdateProductQuantity(this.product, this.calledBy === 'minicart' ? this.product.itemId : this.product.id, quantity, false, this.sellerId, true, this.snsInfo, this.configObj?.programType ? this.configObj?.programType : this.configObj?.appName)
            .subscribe(response => {
            if (response) {
                if (this.isQuantityIncreased) {
                    this.showPriceChangeToast(this.isQuantityIncreased, response);
                    this.isQuantityIncreased = false;
                }
                this.cartService.refreshCart(response);
                this.loadingSpinner = false;
                const cartName = this.cartV2Service.getCartName(this.configObj?.programType, this.sellerId);
                let singleCartresponse = this.cartV2Service.fetchCartDetailsFromResponse(response, cartName);
                if (singleCartresponse && singleCartresponse['cartId']) {
                    if (this.calledBy !== 'minicart') {
                        this.setLoadingSpinnerEmitter.emit(false);
                    }
                    if (singleCartresponse['cartItems']) {
                        this._commonService.sendSponsoredProductClickEvent(this.product, 'quantityDropdown', 'qtyChange');
                        //call relevance call only if product added for first time
                        if (this.enableAdRelevanceTracking) {
                            this._commonService.recordRelevanceImpression(this.product, 'quantityDropdown', 'qtyChange');
                        }
                        singleCartresponse = this.cartV2Service.handleResponseForPendingOrder(singleCartresponse);
                        this.cartId = singleCartresponse['cartId'];
                        setTimeout(() => {
                            this._setFocusInsideQty();
                        }, 1000);
                        this._setFocusInsideQty();
                        this.product.quantity = quantity;
                        // Emit new cart summary to minicart
                        if (this.calledBy === 'minicart') {
                            this.changeMiniCartEmitter.emit(singleCartresponse['summary']);
                            this.updateUnavailableCountEmitter.emit(singleCartresponse['mfcUnavailableProductsCount']);
                        }
                        this.isWYSIWYGEnabled = singleCartresponse['isWYSIWYGEnabled'];
                        if (this.isOnProductDetail && snsInfoChangeObj &&
                            (snsInfoChangeObj?.currentValue?.isChecked !== snsInfoChangeObj?.previousValue?.isChecked) &&
                            snsInfoChangeObj?.currentValue?.isChecked === false) {
                            this.toasterService.show({
                                title: 'OK',
                                message: `You've unsubscribed to this item.`,
                                type: ToasterType.Info,
                                interactiveElement: 'Undo'
                            }, { top: this.toastMessagePostion });
                        }
                        if (window['AB']['DATALAYER']) {
                            const sellerId = this.sellerId ? this.sellerId : singleCartresponse['cartCategory'] === '1P_WINE' ? '22222222' : window['AB']['DATALAYER'].getBannerSellerId();
                            window['AB']['DATALAYER'].updateCartType(this.calledBy === 'minicart' ? 'mini_cart' : '');
                            window['AB']['DATALAYER'].updateCart(response, this.product, response['isWYSIWYGEnabled']);
                            if (!this.addItemToCartAnalytics) {
                                if (window['AB']['DATALAYER'].weightSelectionActionType(analyticsProductID, this.product.quantity) === 'increase') {
                                    this.increaseQuantityAnalytics = true;
                                }
                                else if (window['AB']['DATALAYER'].weightSelectionActionType(analyticsProductID, this.product.quantity) === 'decrease') {
                                    this.decreaseItemAnalytics = true;
                                }
                            }
                            this._updateAnalyticsProductInfo(this.product.quantity, sellerId);
                            if (this.addItemToCartAnalytics) {
                                window['AB']['DATALAYER'].addItemToCart();
                                this.addItemToCartAnalytics = false;
                            }
                            else if (this.increaseQuantityAnalytics) {
                                window['AB']['DATALAYER'].increaseItemQuantity();
                                this.increaseQuantityAnalytics = false;
                            }
                            else if (this.decreaseItemAnalytics) {
                                window['AB']['DATALAYER'].decreaseItemQuantity();
                                this.decreaseItemAnalytics = false;
                            }
                        }
                    }
                }
            }
        }, err => {
            console.error('Error while calling Cart API: ' + err.message);
            if (this.isOnProductDetail && snsInfoChangeObj &&
                (snsInfoChangeObj?.currentValue?.isChecked !== snsInfoChangeObj?.previousValue?.isChecked)) {
                let modalDataConfig = {
                    modal: 'errorModal',
                    showModal: true,
                    prevIdToFocus: '',
                    errModalType: snsInfoChangeObj.currentValue.isChecked ? 'subscribe' : 'unsubscribe',
                    selectedFrequency: this.snsInfo.selectedFrequency
                };
                this._productSnsModalService.show(modalDataConfig);
            }
            this.loadingSpinner = false;
            this.isQuantityIncreased = false;
        });
    }
    _removeProductV2() {
        this.setLoadingSpinnerEmitter.emit(true);
        this.cartV2Service.removeProduct(this.product, this.calledBy === 'minicart' ? this.product.itemId : this.product.id, this.sellerId, this.configObj?.programType ? this.configObj?.programType : this.configObj?.appName).subscribe((response) => {
            if (response) {
                this.cartService.refreshCart(response);
                const cartName = this.cartV2Service.getCartName(this.configObj?.programType, this.sellerId);
                let singleCartresponse = this.cartV2Service.fetchCartDetailsFromResponse(response, cartName);
                this.loadingSpinner = false;
                this.setLoadingSpinnerEmitter.emit(false);
                this._commonService.sendSponsoredProductClickEvent(this.product, 'quantityDropdown', 'removeProduct');
                if (this._commonService.checkPendingOrder() && !this._aemService.getEditOrderOldVersion()) {
                    const order = {
                        ...singleCartresponse
                    };
                    if (order.hasOwnProperty('orderSummary')) {
                        delete order['orderSummary'];
                    }
                    singleCartresponse = {
                        ...order,
                        totalAmount: singleCartresponse['orderSummary'] ? singleCartresponse['orderSummary']['totalEstimatedPrice'] : null,
                        subscriptionDetails: singleCartresponse['orderSummary'] ? singleCartresponse['orderSummary']['subscriptionDetails'] : null,
                        totalOfferSavings: singleCartresponse['orderSummary'] ? singleCartresponse['orderSummary']['totalSavings'] : null,
                        payments: singleCartresponse['payments'] && singleCartresponse['payments'].length ? order['payments'].map(payment => {
                            // subType needs to change the key name to subtype
                            const subtype = payment.subType;
                            delete payment.subType;
                            return {
                                ...payment,
                                subtype
                            };
                        }) : singleCartresponse['payments'],
                        orderSummary: {
                            ...singleCartresponse['orderSummary']
                        },
                        isWYSIWYGEnabled: singleCartresponse['isWYSIWYGEnabled'],
                        wysiwygOrderSummary: {
                            ...singleCartresponse['wysiwygOrderSummary']
                        }
                    };
                }
                singleCartresponse = this.cartV2Service.handleResponseForPendingOrder(singleCartresponse);
                this.isWYSIWYGEnabled = singleCartresponse['isWYSIWYGEnabled'];
                if (window['AB']['DATALAYER']) {
                    const sellerId = this.sellerId ? this.sellerId : singleCartresponse['cartCategory'] === '1P_WINE' || cartName === '1P_WINE' ? '22222222' : window['AB']['DATALAYER'].getBannerSellerId();
                    window['AB']['DATALAYER'].updateCartType(this.calledBy === 'minicart' ? 'mini_cart' : '');
                    window['AB']['DATALAYER'].updateCart(response, null, response['isWYSIWYGEnabled']);
                    this._updateAnalyticsProductInfo(0, sellerId);
                    window['AB']['DATALAYER'].removeItemFromCart();
                }
                console.error('Cart API is succesful with no response');
                this.resetToSelectWeight();
                this.loadingSpinner = false;
            }
        }, err => {
            console.error('Error while calling Cart API: ' + err.message);
            this.loadingSpinner = false;
        });
    }
    initializeWeightList() {
        const catalogConfig = this.config[this.currentEnv]?.catalogConfig;
        this.httpOptions = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'ocp-apim-subscription-key': catalogConfig['apim.api.brand.index.service.key']
            })
        };
        let incrementPriceList = catalogConfig['apim.api.catalog.path']
            + catalogConfig['apim.api.catalog.increment.price.list.endpoint']
            + `?upcIds=${this.product.upc}&storeId=${this._userInfoService.getShopStoreId()}`;
        this._http.get(incrementPriceList, this.httpOptions)
            .pipe(retry(1))
            .subscribe(response => {
            if (response) {
                const priceAndPromoResponse = response['priceAndPromoResponse'];
                if (priceAndPromoResponse && priceAndPromoResponse.length > 0) {
                    if (this.showModal) {
                        this.weightList = priceAndPromoResponse[0]['incrementPriceList'];
                        this.selectedWeight = this.weightList[0].weight;
                        this.estimatedPrice = this.weightList[0].price;
                    }
                    else {
                        this.weightList = priceAndPromoResponse[0]['incrementPriceList'];
                        if (this.weightList && this.weightList.length > 0) {
                            this.showWeights = true;
                        }
                    }
                }
                if (this.isQscV2) {
                    this.showWeights = false;
                }
            }
        }, err => {
            this.showWeights = false;
            this.loadingSpinner = false;
        });
    }
    /**
    * Update analytics product info.
    */
    _updateAnalyticsProductInfo(selectedWeight, sellerId) {
        // check for datalayer availability, in case component is loaded on pages without the AEM datalayer
        if (window['AB']?.DATALAYER) {
            let productInfoObj;
            let carouselTitle = '';
            const isCrossSell = false;
            const isBIACrossSell = this._elementRef.nativeElement.closest('.slick-product-carousel')?.querySelectorAll('[data-carousel-behaviour="bia-crossSell"]')?.length;
            const isBIASpaCarousel = this._elementRef.nativeElement.closest('.slick-product-carousel')?.querySelectorAll('[data-carousel-behaviour="bia-spaCarousel"]')?.length;
            if (isBIACrossSell) {
                carouselTitle = this._elementRef.nativeElement.closest('cross-sell')?.querySelector('.cross-sell__header .cross-sell__title')?.textContent;
            }
            else if (isBIASpaCarousel) {
                carouselTitle = this._elementRef.nativeElement.closest('.bia-spa-carousel-container')?.querySelector('.bia-spa-carousel-container-header')?.textContent?.trim();
            }
            else if (this._elementRef.nativeElement.closest('.master-product-carousel')) {
                carouselTitle = this._elementRef.nativeElement.closest('.master-product-carousel').querySelector('[data-carousel-title]')?.getAttribute('data-carousel-title');
            }
            else if (window['AB'].DATALAYER.isDFTAPage()) {
                carouselTitle = this._elementRef.nativeElement.closest('.slick-product-carousel')?.previousElementSibling?.textContent?.trim() || '';
            }
            else {
                carouselTitle = this._elementRef.nativeElement.closest('.slick-product-carousel')?.querySelector('lazy-wrapper')?.getAttribute('data-carousel-title') ||
                    this._elementRef.nativeElement.closest('.slick-product-carousel')?.querySelector('.carousel-header-text')?.textContent?.trim();
            }
            productInfoObj = {
                id: this.product.id || this.product.itemId,
                adobeMetricA: this.product['adobeMetrics']?.metricA,
                adobeMetricC: this.product['adobeMetrics']?.metricC,
                fullName: this.product.fullName,
                name: this.product.name,
                units: window['AB'].COMMON.checkPendingOrder() ? this.product.quantity : this.product.qty,
                unitType: this.product.unitQuantity,
                lbs: '0',
                each: '0',
                pricePerUnit: this.product.pricePer,
                listPrice: this.product.price ? this.product.price.toString() : '',
                carouselSection: carouselTitle,
                basePrice: this.product.basePrice ? this.product.basePrice.toString() : '',
                pricingType: this.product.promoType,
                couponFlag: '0',
                couponClipped: '0',
                couponID: '',
                aisleId: this.product.aisleId,
                upc: this.product.upc,
                isMTO: this.product.isMtoProduct,
                departmentName: this.product.departmentName,
                sellerId: sellerId ? sellerId : this.product.sellerId,
                sellerName: this.product.sellerName,
                editOrderFlow: this._commonService.checkPendingOrder() ? true : false,
                snapEligible: this.product.snapEligible,
                isProductTrackingDisabled: this.product.isProductTrackingDisabled ? true : false,
                isP13nGrid: this._elementRef.nativeElement.closest('#p13nProductGrid') ? true : false,
                quantity: this.product.quantity
            };
            if (this.product.unitQuantity == 'LB') {
                productInfoObj.lbs = selectedWeight;
            }
            else if (this.product.unitQuantity == 'EACH') {
                productInfoObj.each = this.product.quantity ? this.product.quantity : this.product.qty;
            }
            const coupons = this._commonService.getCouponByUpc(this.product.upc);
            // If there are coupons present on the product, filters the information and adds it to the productInfo object
            if (coupons.length > 0) {
                const couponsClipped = coupons.filter(x => x.status === 'C').length;
                const couponsCount = coupons.length;
                const couponIds = coupons.filter(x => x.status === 'C').map(x => x.offerId).toString();
                productInfoObj.couponFlag = couponsCount.toString();
                productInfoObj.couponClipped = couponsClipped.toString();
                productInfoObj.couponID = couponIds;
            }
            // For items that are not on the minicart, set the recommendation type to be used in analytics code
            if (this.calledBy !== 'minicart') {
                let isBuyItAgain;
                let isBrPathway;
                let isPicksForYou = false;
                let isP13nGeneric = false;
                if (carouselTitle) {
                    const parentCarousel = $(this._elementRef.nativeElement).closest('.slick-product-carousel');
                    const buyItAgainCarousel = parentCarousel.find('[data-carousel-behaviour=buy-it-again]').length;
                    const brPathwayCarousel = parentCarousel.find('[data-carousel-driven=pathway-search]').length;
                    const p13nGenericCarousel = parentCarousel.find('[data-carousel-driven=p13n-generic]').length;
                    productInfoObj.isBIACarousalProduct = parentCarousel.find('[data-carousel-behaviour=bia-spaCarousel]').length ? true : false;
                    isBuyItAgain = buyItAgainCarousel ? true : false;
                    isBrPathway = brPathwayCarousel ? true : false;
                    isPicksForYou = carouselTitle.search(/picks for you|picked for you|picks-for-you|picked-for-you/i) !== -1;
                    isP13nGeneric = p13nGenericCarousel ? true : false;
                    // set placement value for carousel items
                    productInfoObj.placement = window['AB'].DATALAYER.setPlacementInfoCarouselItems(this._elementRef.nativeElement);
                }
                let recommendationObj = {
                    isCrossSell: isCrossSell,
                    isRecommended: this.isRecommended || isPicksForYou || isP13nGeneric,
                    isSponsored: this.product['featured'],
                    isPastPurchased: isBuyItAgain || this.product['pastPurchased'],
                    isBrPathway: isBrPathway
                };
                if (this.product['adId'] || this.product.eventTracking) {
                    recommendationObj.isSponsored = true;
                }
                window['AB'].DATALAYER.recommendationInfo(recommendationObj);
            }
            window['AB'].DATALAYER.productInfo(productInfoObj);
            /**
             * update pageFilter with:
             * cart type (when a user performs a product action in mini cart)
             * carousel title (when a user performs any action related to a carousel)
             */
            if (this.calledBy === 'minicart') {
                window['AB'].DATALAYER.setCarouselName('shop|mini_cart');
            }
            else if (carouselTitle) {
                window['AB'].DATALAYER.isRecipesPage()
                    ? window['AB'].DATALAYER.setCarouselName(`recipes|${carouselTitle}`)
                    : window['AB'].DATALAYER.setCarouselName(`shop|${carouselTitle}`);
            }
            else {
                window['AB'].DATALAYER.setCarouselName('');
            }
            /**
             * for products that are not in the minicart or in a carousel
             * set metaInfo(number of images clicked on pdp before the user performs a product action)
             */
            if (window['AB'].DATALAYER.isPdp()) {
                if (this.calledBy === 'minicart' || carouselTitle) {
                    window['AB'].DATALAYER.setPageFilterMetaInfo(false);
                }
                else {
                    window['AB'].DATALAYER.setPageFilterMetaInfo(true);
                }
            }
        }
    }
    /**
     * Generate Dynamic aria-lable for accessibility
     */
    getAriaLabel(weight) {
        return `Estimated Total $${this.estimatedPrice}. Weight selected is ${Math.round(weight * 100) / 100} lb`;
    }
    /**
     * Returns the selected weight property of the matching item in quickAddBasket.
     */
    getSelectedWeight() {
        return parseFloat(this._quickAddBasketService.getQuickAddBasketItemWeight(this.product.id));
    }
    ngOnDestroy() {
        this.subscriptions.unsubscribe();
    }
    static { this.ɵfac = function QuantityDropdownALV1Component_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || QuantityDropdownALV1Component)(i0.ɵɵdirectiveInject(i1.CommonService), i0.ɵɵdirectiveInject(i1.UserInfoService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i2.ToasterALV1Service), i0.ɵɵdirectiveInject(i1.CartService), i0.ɵɵdirectiveInject(i3.HttpClient), i0.ɵɵdirectiveInject(i1.CartV2Service), i0.ɵɵdirectiveInject(i1.AemService), i0.ɵɵdirectiveInject(i1.ProductUtilService), i0.ɵɵdirectiveInject(i1.UtilService), i0.ɵɵdirectiveInject(ProductSNSModalALService), i0.ɵɵdirectiveInject(i1.QuickAddBasketV1Service)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: QuantityDropdownALV1Component, selectors: [["quantity-dropdown-al-v1"]], hostBindings: function QuantityDropdownALV1Component_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("resize", function QuantityDropdownALV1Component_resize_HostBindingHandler($event) { return ctx.onResize($event); }, false, i0.ɵɵresolveWindow);
        } }, inputs: { product: "product", sellerId: "sellerId", calledBy: "calledBy", isAnyProductHasAddlInfo: "isAnyProductHasAddlInfo", noWeightModal: "noWeightModal", isRecommended: "isRecommended", isQscV2: "isQscV2", isCheckboxChecked: "isCheckboxChecked", snsInfo: "snsInfo", isMkpSellerTagDisabled: "isMkpSellerTagDisabled", configObj: "configObj" }, outputs: { removeMiniCartEmitter: "removeMiniCartEmitter", changeMiniCartEmitter: "changeMiniCartEmitter", updateUnavailableCountEmitter: "updateUnavailableCountEmitter", setLoadingSpinnerEmitter: "setLoadingSpinnerEmitter", updateCheckboxEmitter: "updateCheckboxEmitter", updateQscQtyEmitter: "updateQscQtyEmitter" }, features: [i0.ɵɵNgOnChangesFeature], decls: 3, vars: 2, consts: [["qscDropdown", ""], ["selectWeightButton", ""], [4, "ngIf", "ngIfElse"], [1, "quantity-stepper-v3"], [1, "quantity-stepper-container"], [1, "product-btn", 3, "ngClass"], ["data-qa", "addbutton", "role", "button", "tabindex", "0", "class", "btn product-btn__add product-btn--signin", 3, "id", "click", 4, "ngIf"], ["class", "dropdown est__dropdown", 3, "ngClass", "id", 4, "ngIf"], [4, "ngIf"], ["data-qa", "addbutton", "role", "button", "tabindex", "0", 1, "btn", "product-btn__add", "product-btn--signin", 3, "click", "id"], [1, "dropdown", "est__dropdown", 3, "ngClass", "id"], ["class", "dropdown-menu  est__dropdown--menu", 3, "ngClass", 4, "ngIf"], ["aria-haspopup", "true", 1, "est__dropdown--button", "btn", "btn_qty-stepper", 3, "click", "id"], [1, "btn", "product-btn__add", "product-btn--signin", 3, "click", "id"], [1, "dropdown-menu", "est__dropdown--menu", 3, "ngClass"], ["tabindex", "-1", "role", "menu", 1, "est__dropdown--menu--item--container", 3, "focusout", "id"], ["class", "dropdown-item est__dropdown--menu--item", "role", "menuitem", "tabindex", "0", 3, "id", "click", "mouseenter", "keypress", 4, "ngFor", "ngForOf"], ["role", "menuitem", "tabindex", "0", 1, "dropdown-item", "est__dropdown--menu--item-remove", 3, "click", "keypress", "mouseenter", "ngClass"], ["aria-live", "polite"], ["aria-hidden", "true", 1, "dropdown-item", "est__dropdown--selected--price"], [1, "quantity-dropdown__est-total--label"], [1, "sr-only"], [1, "dropdown-item", "est__dropdown--selected--price--helper"], ["role", "menuitem", "tabindex", "0", 1, "dropdown-item", "est__dropdown--menu--item", 3, "click", "mouseenter", "keypress", "id"], ["role", "group", "aria-describedby", "123pg960161868", 3, "ngClass"], ["aria-label", "Decrement quantity", "data-qa", "prdctdcrmntr", "role", "button", "tabindex", "0", 1, "product-btn__qty-step__decrease", 3, "click", "id"], ["aria-hidden", "true", 1, "svg-qty-stepper-decrease", "product-btn__qty-step__decrease--icon"], ["data-qa", "prd-qty-stppr-qtymsg", "role", "button", "tabindex", "0", 1, "product-btn__qty-step__amt", "product-btn__qty-step__amt__amt-text", 3, "click", "id"], ["aria-label", "Increment quantity", "data-qa", "prdctincrmntr", "role", "button", "tabindex", "0", 1, "product-btn__qty-step__increase", 3, "click", "id", "disabled"], ["aria-hidden", "true", 1, "svg-qty-stepper-increase", "product-btn__qty-step__increase--icon"], ["id", "modal-est", "role", "dialog", "tabindex", "-1", 1, "modal", "qty-modal", "fade"], [1, "modal-dialog"], [1, "modal-content"], [1, "modal-header"], ["aria-label", "Close", 1, "close", 3, "click", "keypress"], ["aria-hidden", "true", 1, "svg-icon", "svg-close"], [1, "modal-body"], [1, "product"], ["aria-hidden", "true", 1, "product__image-container"], ["media", "(max-width: 575px)"], ["media", "(max-width: 768px)"], ["data-qa", "prd-itm-img", 1, "ab-lazy", 3, "alt"], [1, "product__title"], [1, "title-md", "mb-4"], ["aria-hidden", "true", 1, "gray-darker"], [1, "amount"], [1, "amount__label", "body-text-sm"], [1, "row", "amount__info"], [1, "amount__info__per-unit", "title-sm-bold"], ["tabindex", "0", 1, "amount__info__est"], ["aria-live", "polite", 1, "sr-only", "amount__info__est"], ["aria-hidden", "true", 1, "amount__info__est--label", "body-text-sm"], ["aria-hidden", "true", 1, "amount__info__est--price", "title-sm-bold"], [1, "amount__select", 3, "change"], ["class", "options", 3, "value", "selected", 4, "ngFor", "ngForOf"], [1, "amount__add-qty-btn"], [1, "btn", "btn-primary", 3, "click", "keypress"], [1, "options", 3, "value", "selected"], [1, "quantity-stepper-v3", "qsc-dropdown-v2-default", 3, "ngClass"], [1, "dropdown", "est__dropdown", 3, "id"], ["aria-haspopup", "true", 1, "est__dropdown--button", "btn", "btn_qty-stepper-lb", "qsc-btn_qty-stepper-lb", 3, "click", "ngClass", "id", "disabled"], ["class", "dropdown-menu est__dropdown--menu qsc-dropdown-menu", 3, "ngClass", 4, "ngIf"], [1, "dropdown-menu", "est__dropdown--menu", "qsc-dropdown-menu", 3, "ngClass"], ["tabindex", "-1", "role", "menu", "tabindex", "-1", 1, "est__dropdown--menu--item--container", "qsc-dropdown-menu-item-container", 3, "focusout", "id"], ["class", "dropdown-item est__dropdown--menu--item qsc-dropdown-item", "role", "menuitem", "tabindex", "0", 3, "id", "mouseenter", "click", "keypress", 4, "ngFor", "ngForOf"], ["role", "menuitem", "tabindex", "0", 1, "dropdown-item", "est__dropdown--menu--item-remove", "qsc-dropdown-item", 3, "click", "keypress", "mouseenter", "ngClass"], ["aria-live", "polite", 1, "qsc-dropdown-selected-container"], ["aria-hidden", "true", 1, "dropdown-item", "est__dropdown--selected--price", "qsc-dropdown-selected-price"], [1, "quantity-dropdown__est-total--label", "qsc-dropdown-total-label"], [1, "dropdown-item", "est__dropdown--selected--price--helper", "qsc-dropdown-selected-price-helper"], ["role", "menuitem", "tabindex", "0", 1, "dropdown-item", "est__dropdown--menu--item", "qsc-dropdown-item", 3, "mouseenter", "click", "keypress", "id"]], template: function QuantityDropdownALV1Component_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, QuantityDropdownALV1Component_ng_container_0_Template, 8, 8, "ng-container", 2)(1, QuantityDropdownALV1Component_ng_template_1_Template, 7, 20, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor);
        } if (rf & 2) {
            const qscDropdown_r20 = i0.ɵɵreference(2);
            i0.ɵɵproperty("ngIf", !ctx.isQscV2)("ngIfElse", qscDropdown_r20);
        } }, dependencies: [i5.NgClass, i5.NgForOf, i5.NgIf, i2$1.NgSelectOption, i2$1.ɵNgSelectMultipleOption, i5.LowerCasePipe, i5.DecimalPipe, i5.CurrencyPipe], encapsulation: 2 }); }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: QuantityDropdownALV1Component, factory: QuantityDropdownALV1Component.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(QuantityDropdownALV1Component, [{
        type: Component,
        args: [{ selector: 'quantity-dropdown-al-v1', template: "<ng-container *ngIf=\"!isQscV2; else qscDropdown\">\n<div class=\"quantity-stepper-v3\">\n    <div class=\"quantity-stepper-container\">\n        <div class=\"product-btn\" [ngClass]=\"{'product-btn--with-addl-info': isAnyProductHasAddlInfo,'product-btn--without-ar': !isAnyProductHasAddlInfo}\">\n            <div data-qa=\"addbutton\" role=\"button\" tabindex=\"0\"\n                class=\"btn product-btn__add product-btn--signin\" id=\"signIn-weight_{{product.id}}\"\n                attr.data-qty-id=\"pc{{product.id}}Inpt\"\n                attr.aria-label=\"Sign In to Add weight {{product.name}}\"\n                (click)=\"displayWeights($event)\" *ngIf=\"!isAuthorized\">\n                {{ isAuthorized ? selectedWeightText : SIGNIN }}\n            </div>\n            <div class=\"dropdown est__dropdown\" [ngClass]=\"{'dropup' : calledBy === 'carousel'}\" *ngIf=\"isAuthorized && !isButtonenabled\"  id=\"select-weight_{{product.id}}\">\n                <ng-container *ngIf=\"(screenSize >= 1024 || noWeightModal) else selectWeightButton\">\n                    <button class=\"est__dropdown--button btn btn_qty-stepper\" id=\"qtyDropdownBtn_{{product.id}}\"\n                     aria-haspopup=\"true\" attr.aria-controls=\"qtyDropdownContentList_{{product.id}}\"\n                     (click)=\"displayWeights($event)\" attr.aria-expanded=\"{{showWeights}}\"\n                    attr.aria-label=\"select weight {{product.name}}\">\n                    {{ selectedWeightText }}\n                    </button>\n                </ng-container>\n                <ng-template #selectWeightButton>\n                    <button class=\"btn product-btn__add product-btn--signin\" id=\"qtyModalBtn_{{product.id}}\"\n                      (click)=\"displayWeights($event)\" attr.aria-expanded=\"{{showModal}}\"\n                      attr.aria-label=\"select weight {{product.name}}\">\n                    {{ selectedWeightText }}\n                    </button>\n                </ng-template>\n                <div class=\"dropdown-menu  est__dropdown--menu\" [ngClass]=\"{'est__dropdown--menu--display' : showWeights}\" *ngIf=\"showWeights\">\n                    <ul class=\"est__dropdown--menu--item--container\" (focusout)=\"dropdownFocusout($event)\"\n                    tabindex=\"-1\" id=\"qtyDropdownContentList_{{product.id}}\" role=\"menu\" attr.aria-labelledby=\"qtyDropdownBtn_{{product.id}}\">\n                        <li *ngFor=\"let item of weightList; let i=index\"\n                        class=\"dropdown-item est__dropdown--menu--item\"\n                        id=\"dropdown-itm{{i}}\"\n                        (click)=\"selectWeight(i)\"\n                        (mouseenter)=\"mouseEnter(i)\"\n                        (keypress)=\"selectWeight(i)\"\n                        role=\"menuitem\"\n                        tabindex=\"0\">\n                        {{ item.weight | number:'1.2' }} lb\n                        </li>\n                        <li class=\"dropdown-item est__dropdown--menu--item-remove\" [ngClass]=\"{'est__dropdown--menu--item-remove--disabled' : selectedWeight == 0}\"\n                        (click)=\"removeSelection()\"\n                        (keypress)=\"removeSelection()\"\n                        (mouseenter)=\"mouseEnterRemoveBtn()\"\n                        role=\"menuitem\"\n                        tabindex=\"0\">\n                          Remove\n                        </li>\n                    </ul>\n                    <div>\n                      <span aria-live=\"polite\">\n                        <span class=\"dropdown-item est__dropdown--selected--price\" aria-hidden=\"true\"><span class=\"quantity-dropdown__est-total--label\">Est. Total: &nbsp; </span>{{ estimatedPrice | currency: 'USD' }}</span>\n                        <span class=\"sr-only\">Estimated Total:</span>\n                        <span class=\"sr-only\">{{ estimatedPrice | currency: 'USD' }}</span>\n                      </span>\n                      <div class=\"dropdown-item est__dropdown--selected--price--helper\">Final cost by weight</div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n<ng-container *ngIf=\"isButtonenabled\">\n    <div class=\"quantity-stepper-v3\">\n        <div class=\"quantity-stepper-container\">\n            <div class=\"product-btn\" [ngClass]=\"{'product-btn--without-ar': configObj?.programType !== 'mkp'}\">\n                <div [ngClass]=\"{'btn':true, 'product-btn__qty-step': true, 'product-btn__qty-step--loading':loadingSpinner}\"\n                  role=\"group\" aria-describedby=\"123pg960161868\">\n                    <button aria-label=\"Decrement quantity\" class=\"product-btn__qty-step__decrease\"\n                        id=\"dec_qtyInfo_{{product.id}}\" (click)=decreaseWeight() data-qa=\"prdctdcrmntr\" role=\"button\" tabindex=\"0\" id=\"dec_qtyInfo_{{product.id}}\">\n                        <span aria-hidden=\"true\"\n                            class=\"svg-qty-stepper-decrease product-btn__qty-step__decrease--icon\"></span>\n                    </button>\n                    <span class=\"sr-only\"></span>\n                    <span class=\"product-btn__qty-step__amt product-btn__qty-step__amt__amt-text\"\n                        data-qa=\"prd-qty-stppr-qtymsg\" role=\"button\" tabindex=\"0\" id=\"qtyInfo_{{product.id}}\"\n                        attr.aria-label=\"{{selectedWeight}} lb of {{product.name}} in cart\" (click) = \"!noWeightModal && displayModal($event)\">\n                        {{ selectedWeightText }} </span>\n                    <button aria-label=\"Increment quantity\" class=\"product-btn__qty-step__increase\"\n                        data-qa=\"prdctincrmntr\" role=\"button\" tabindex=\"0\" id=\"inc_qtyInfo_{{product.id}}\"\n                        id=\"inc_qtyInfo_{{product.id}}\" (click)=\"increaseWeight()\" [disabled]=\"checkIncreaseButtonDisability()\">\n                        <span aria-hidden=\"true\"\n                            class=\"svg-qty-stepper-increase product-btn__qty-step__increase--icon\"></span>\n                    </button>\n                </div>\n            </div>\n        </div>\n    </div>\n</ng-container>\n<ng-container *ngIf=\"showModal\">\n    <div class=\"quantity-stepper-v3\">\n      <div class=\"quantity-stepper-container\">\n        <div class=\"modal qty-modal fade\" id=\"modal-est\" attr.aria-label=\"Select weight for {{product.name}}\" role=\"dialog\" tabindex=\"-1\">\n          <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n          <div class=\"modal-header\">\n            <button class=\"close\"\n              (click)=\"closeModal()\"\n              (keypress)=\"closeModal()\"\n              aria-label=\"Close\">\n              <span class=\"svg-icon svg-close\" aria-hidden=\"true\"></span>\n            </button>\n          </div>\n          <div class=\"modal-body\">\n            <div class=\"product\">\n              <div class=\"product__image-container\" aria-hidden=\"true\">\n                  <picture>\n                    <source media=\"(max-width: 575px)\" [attr.srcset]=\"getImageUrl(product.id,'mobile')\">\n                    <source media=\"(max-width: 768px)\" [attr.srcset]=\"getImageUrl(product.id,'tablet')\">\n                    <img class=\"ab-lazy\" [attr.src]=\"getImageUrl(product.id,'desktop')\" alt=\"{{ product.name }}\" data-qa=\"prd-itm-img\" />\n                  </picture>\n              </div>\n              <div class=\"product__title\">\n                <p class=\"title-md mb-4\">{{product.name}}</p>\n              </div>\n            </div>\n            <hr class=\"gray-darker\" aria-hidden=\"true\">\n            <div class=\"amount\">\n              <p class=\"amount__label body-text-sm\">Final cost by weight</p>\n              <div class=\"row amount__info\">\n                <div class=\"amount__info__per-unit title-sm-bold\">{{ product.pricePer | currency: 'USD' }} / {{ product.unitQuantity | lowercase}}</div>\n                <div tabindex=\"0\" class=\"amount__info__est\">\n                  <!-- Announce Estimated Total -->\n                  <span class=\"sr-only amount__info__est\" aria-live=\"polite\">\n                    Estimated Total {{ estimatedPrice | currency: 'USD' }}\n                  </span>\n                  <div aria-hidden=\"true\" class=\"amount__info__est--label body-text-sm\">Est. total\n                  </div>\n                  <div aria-hidden=\"true\" class=\"amount__info__est--price title-sm-bold\">{{ estimatedPrice | currency: 'USD' }}</div>\n                </div>\n              </div>\n              <div>\n                <select class=\"amount__select\" (change)=\"SelectWeightModal($event)\">\n                    <option *ngFor=\"let item of weightList; let i=index\" class=\"options\" [value]=\"item.weight\" [selected]=\"item.weight==selectedItem()\" [attr.aria-label]=\"getAriaLabel(item.weight)\">{{ item.weight | number:'1.2' }} &nbsp; lb</option>\n                </select>\n              </div>\n              <div class=\"amount__add-qty-btn\">\n                <button class=\"btn btn-primary\"\n                (click)=\"finalizeWeight()\"\n                (keypress)=\"finalizeWeight()\">Add\n              </button>\n              </div>\n            </div>\n          </div>\n        </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </ng-container>\n</ng-container>\n\n<ng-template #qscDropdown>\n  <div class=\"quantity-stepper-v3 qsc-dropdown-v2-default\" [ngClass]=\"{'qsc-dropdown-v2-extended' : isExtended}\">\n    <div class=\"quantity-stepper-container\">\n      <div class=\"dropdown est__dropdown\" id=\"select-weight_{{product.id}}\">\n        <button class=\"est__dropdown--button btn btn_qty-stepper-lb qsc-btn_qty-stepper-lb\" [ngClass]=\"{'qsc-btn_qty-stepper-lb__disabled' : !isCheckboxChecked, 'qsc-btn_qty-stepper-lb__after' : isExtended}\" id=\"qtyDropdownBtn_{{product.id}}\"\n          (click)=\"qscDisplayWeights($event)\" aria-haspopup=\"true\" attr.aria-controls=\"qtyDropdownContentList_{{product.id}}\"\n          attr.aria-expanded=\"{{showWeights}}\" attr.aria-label=\"select weight {{product.name}}\" [disabled]=\"!isCheckboxChecked\">\n          {{ selectedWeightText }}\n        </button>\n        <div class=\"dropdown-menu est__dropdown--menu qsc-dropdown-menu\" [ngClass]=\"{'est__dropdown--menu--display' : showWeights}\" *ngIf=\"showWeights\">\n          <ul class=\"est__dropdown--menu--item--container qsc-dropdown-menu-item-container\" tabindex=\"-1\"\n            id=\"qtyDropdownContentList_{{product.id}}\" role=\"menu\" attr.aria-labelledby=\"qtyDropdownBtn_{{product.id}}\"\n            tabindex=\"-1\" (focusout)=\"dropdownFocusout($event)\">\n            <li *ngFor=\"let item of weightList; let i = index\" class=\"dropdown-item est__dropdown--menu--item qsc-dropdown-item\"\n              id=\"dropdown-itm{{i}}\" role=\"menuitem\" (mouseenter)=\"mouseEnter(i)\" (click)=\"selectWeight(i)\" (keypress)=\"selectWeight(i)\" tabindex=\"0\">\n              {{ item.weight | number:'1.2' }} lb\n            </li>\n            <li class=\"dropdown-item est__dropdown--menu--item-remove qsc-dropdown-item\"\n              [ngClass]=\"{'est__dropdown--menu--item-remove--disabled' : selectedWeight == 0}\" (click)=\"qscV2RemoveSelection()\"\n              (keypress)=\"qscV2RemoveSelection()\" (mouseenter)=\"mouseEnterRemoveBtn()\" role=\"menuitem\" tabindex=\"0\">\n              Remove\n            </li>\n          </ul>\n          <div>\n            <span aria-live=\"polite\" class=\"qsc-dropdown-selected-container\">\n              <span class=\"dropdown-item est__dropdown--selected--price qsc-dropdown-selected-price\" aria-hidden=\"true\">\n                <span class=\"quantity-dropdown__est-total--label qsc-dropdown-total-label\">Est. Total: &nbsp; </span>\n                {{ estimatedPrice | currency: 'USD' }}\n              </span>\n              <span class=\"sr-only\">Estimated Total:</span>\n              <span class=\"sr-only\">{{ estimatedPrice | currency: 'USD' }}</span>\n              <div class=\"dropdown-item est__dropdown--selected--price--helper qsc-dropdown-selected-price-helper\">Final cost by weight</div>\n            </span>\n          </div>\n        </div>\n      </div>\n    </div>\n  </div>\n  <ng-container *ngIf=\"showModal\">\n    <div class=\"quantity-stepper-v3\">\n      <div class=\"quantity-stepper-container\">\n        <div class=\"modal qty-modal fade\" id=\"modal-est\" attr.aria-label=\"Select weight for {{product.name}}\" role=\"dialog\" tabindex=\"-1\">\n          <div class=\"modal-dialog\">\n        <div class=\"modal-content\">\n          <div class=\"modal-header\">\n            <button class=\"close\"\n              (click)=\"closeModal()\"\n              (keypress)=\"closeModal()\"\n              aria-label=\"Close\">\n              <span class=\"svg-icon svg-close\" aria-hidden=\"true\"></span>\n            </button>\n          </div>\n          <div class=\"modal-body\">\n            <div class=\"product\">\n              <div class=\"product__image-container\" aria-hidden=\"true\">\n                  <picture>\n                    <source media=\"(max-width: 575px)\" [attr.srcset]=\"getImageUrl(product.id,'mobile')\">\n                    <source media=\"(max-width: 768px)\" [attr.srcset]=\"getImageUrl(product.id,'tablet')\">\n                    <img class=\"ab-lazy\" [attr.src]=\"getImageUrl(product.id,'desktop')\" alt=\"{{ product.name }}\" data-qa=\"prd-itm-img\" />\n                  </picture>\n              </div>\n              <div class=\"product__title\">\n                <p class=\"title-md mb-4\">{{product.name}}</p>\n              </div>\n            </div>\n            <hr class=\"gray-darker\" aria-hidden=\"true\">\n            <div class=\"amount\">\n              <p class=\"amount__label body-text-sm\">Final cost by weight</p>\n              <div class=\"row amount__info\">\n                <div class=\"amount__info__per-unit title-sm-bold\">{{ product.pricePer | currency: 'USD' }} / {{ product.unitQuantity | lowercase}}</div>\n                <div tabindex=\"0\" class=\"amount__info__est\">\n                  <!-- Announce Estimated Total -->\n                  <span class=\"sr-only amount__info__est\" aria-live=\"polite\">\n                    Estimated Total {{ estimatedPrice | currency: 'USD' }}\n                  </span>\n                  <div aria-hidden=\"true\" class=\"amount__info__est--label body-text-sm\">Est. total\n                  </div>\n                  <div aria-hidden=\"true\" class=\"amount__info__est--price title-sm-bold\">{{ estimatedPrice | currency: 'USD' }}</div>\n                </div>\n              </div>\n              <div>\n                <select class=\"amount__select\" (change)=\"SelectWeightModal($event)\">\n                    <option *ngFor=\"let item of weightList; let i=index\" class=\"options\" [value]=\"item.weight\" [selected]=\"item.weight==selectedItem()\" [attr.aria-label]=\"getAriaLabel(item.weight)\">{{ item.weight | number:'1.2' }} &nbsp; lb</option>\n                </select>\n              </div>\n              <div class=\"amount__add-qty-btn\">\n                <button class=\"btn btn-primary\"\n                (click)=\"finalizeWeight()\"\n                (keypress)=\"finalizeWeight()\">Add\n              </button>\n              </div>\n            </div>\n          </div>\n        </div>\n          </div>\n        </div>\n      </div>\n    </div>\n  </ng-container>\n</ng-template>" }]
    }, {
        type: Injectable
    }], () => [{ type: i1.CommonService }, { type: i1.UserInfoService }, { type: i0.ElementRef }, { type: i2.ToasterALV1Service }, { type: i1.CartService }, { type: i3.HttpClient }, { type: i1.CartV2Service }, { type: i1.AemService }, { type: i1.ProductUtilService }, { type: i1.UtilService }, { type: ProductSNSModalALService }, { type: i1.QuickAddBasketV1Service }], { product: [{
            type: Input
        }], sellerId: [{
            type: Input
        }], calledBy: [{
            type: Input
        }], isAnyProductHasAddlInfo: [{
            type: Input
        }], noWeightModal: [{
            type: Input
        }], isRecommended: [{
            type: Input
        }], isQscV2: [{
            type: Input
        }], isCheckboxChecked: [{
            type: Input
        }], snsInfo: [{
            type: Input
        }], isMkpSellerTagDisabled: [{
            type: Input
        }], removeMiniCartEmitter: [{
            type: Output
        }], changeMiniCartEmitter: [{
            type: Output
        }], updateUnavailableCountEmitter: [{
            type: Output
        }], setLoadingSpinnerEmitter: [{
            type: Output
        }], updateCheckboxEmitter: [{
            type: Output
        }], updateQscQtyEmitter: [{
            type: Output
        }], configObj: [{
            type: Input
        }], onResize: [{
            type: HostListener,
            args: ['window:resize', ['$event']]
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(QuantityDropdownALV1Component, { className: "QuantityDropdownALV1Component", filePath: "components/quantity-dropdown-al-v1/quantity-dropdown-al-v1.component.ts", lineNumber: 29 }); })();

/**
 * Quantity Stepper - Product Card ADD button and quantity steppers.
 *
 * @template <quantity-stepper>
 */
const _c0$1 = a0 => ({ "product-btn--signin": a0 });
const _c1$1 = a0 => ({ "product-btn__qty-step__increase": true, "product-btn__qty-step__increase--max-amt qsc-step__increase--max-amt": a0 });
const _c2$1 = (a0, a1, a2) => ({ "qsc-step-default": a0, "qsc-step": a1, "qsc-step-disabled": a2 });
const _c3$1 = (a0, a1, a2, a3, a4, a5) => ({ "product-btn": true, "product-btn--with-addl-info": a0, "product-btn--without-ar": a1, "full-loading": a2, "remove-loading": a3, "add-product-checkmark": a4, "product-btn--light": a5 });
const _c4$1 = (a0, a1) => ({ "product-btn--signin": a0, "d-flex align-items-center justify-content-center": a1 });
const _c5$1 = a0 => ({ "btn": true, "product-btn__qty-step": true, "product-btn__qty-step--loading": a0 });
const _c6$1 = a0 => ({ "product-btn__qty-step__decrease--min-amt": a0 });
const _c7$1 = a0 => ({ "product-btn__qty-step__increase": true, "product-btn__qty-step__increase--max-amt": a0 });
function QuantityStepperALV1Component_ng_template_0_div_0_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 9);
    i0.ɵɵlistener("click", function QuantityStepperALV1Component_ng_template_0_div_0_button_1_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.qscDecrease()); });
    i0.ɵɵelement(1, "span", 10);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵattributeInterpolate1("aria-label", "Decrease Quantity ", ctx_r1.getProductFullName(), "");
    i0.ɵɵpropertyInterpolate1("id", "dec_qtyInfo_", ctx_r1.product.id, "");
    i0.ɵɵproperty("disabled", ctx_r1.showQtyUpdateBtn || ctx_r1.updateState.input > ctx_r1.product.inventoryQty);
} }
function QuantityStepperALV1Component_ng_template_0_div_0_button_4_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 11);
    i0.ɵɵlistener("click", function QuantityStepperALV1Component_ng_template_0_div_0_button_4_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.qscIncrease()); });
    i0.ɵɵelement(1, "span", 12);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵattributeInterpolate1("aria-label", "Increase Quantity ", ctx_r1.getProductFullName(), "");
    i0.ɵɵpropertyInterpolate1("id", "inc_qtyInfo_", ctx_r1.product.id, "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(6, _c1$1, ctx_r1.qscQuantity >= ctx_r1.product.inventoryQty || ctx_r1.qscQuantity >= ctx_r1.product.maxPurchaseQty));
    i0.ɵɵattribute("aria-disabled", ctx_r1.product.quantity >= ctx_r1.product.inventoryQty || ctx_r1.product.quantity >= ctx_r1.product.maxPurchaseQty ? "true" : "false");
} }
function QuantityStepperALV1Component_ng_template_0_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 5);
    i0.ɵɵlistener("click", function QuantityStepperALV1Component_ng_template_0_div_0_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.onQscStepperClick()); })("keydown.enter", function QuantityStepperALV1Component_ng_template_0_div_0_Template_div_keydown_enter_0_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.onQscStepperClick()); });
    i0.ɵɵtemplate(1, QuantityStepperALV1Component_ng_template_0_div_0_button_1_Template, 2, 5, "button", 6);
    i0.ɵɵelementStart(2, "span", 7);
    i0.ɵɵlistener("click", function QuantityStepperALV1Component_ng_template_0_div_0_Template_span_click_2_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.onQscAmtClick()); })("keydown.enter", function QuantityStepperALV1Component_ng_template_0_div_0_Template_span_keydown_enter_2_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.onQscAmtClick()); });
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, QuantityStepperALV1Component_ng_template_0_div_0_button_4_Template, 2, 8, "button", 8);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵattributeInterpolate1("data-qty-id", "pc", ctx_r1.product.id, "Inpt");
    i0.ɵɵpropertyInterpolate1("id", "addButton_", ctx_r1.product.id, "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c0$1, !ctx_r1.isAuthorized));
    i0.ɵɵattribute("aria-label", ctx_r1.isAuthorized ? ctx_r1.ADD + " 1 unit of " + ctx_r1.getProductFullName() : ctx_r1.SIGNIN + " 1 unit of " + ctx_r1.getProductFullName());
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isQuantityStepperExtended);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "qtyInfo_", ctx_r1.product.id, "");
    i0.ɵɵattribute("aria-label", ctx_r1.quantityAriaLabelMessage);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.qscQuantity, " ");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isQuantityStepperExtended);
} }
function QuantityStepperALV1Component_ng_template_0_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13)(1, "input", 14);
    i0.ɵɵlistener("keydown.enter", function QuantityStepperALV1Component_ng_template_0_div_1_Template_input_keydown_enter_1_listener() { i0.ɵɵrestoreView(_r5); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.qscEnterTabKeyDown()); })("keydown", function QuantityStepperALV1Component_ng_template_0_div_1_Template_input_keydown_1_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.inputKeydown($event)); })("keyup", function QuantityStepperALV1Component_ng_template_0_div_1_Template_input_keyup_1_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.inputKeyup($event)); });
    i0.ɵɵtwoWayListener("ngModelChange", function QuantityStepperALV1Component_ng_template_0_div_1_Template_input_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r5); const ctx_r1 = i0.ɵɵnextContext(2); i0.ɵɵtwoWayBindingSet(ctx_r1.updateState.input, $event) || (ctx_r1.updateState.input = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "button", 15);
    i0.ɵɵlistener("click", function QuantityStepperALV1Component_ng_template_0_div_1_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r5); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.qscUpdateAmt()); });
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵattributeInterpolate2("aria-describedby", "", ctx_r1.carouselId, "pg", ctx_r1.product.id, "");
    i0.ɵɵpropertyInterpolate1("id", "qtyInfoControl_", ctx_r1.product.id, "");
    i0.ɵɵpropertyInterpolate("max", ctx_r1.product.maxPurchaseQty);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.updateState.input);
    i0.ɵɵadvance();
    i0.ɵɵattributeInterpolate2("aria-describedby", "", ctx_r1.carouselId, "pg", ctx_r1.product.id, "");
    i0.ɵɵproperty("disabled", ctx_r1.showQtyUpdateBtn || ctx_r1.updateState.input > ctx_r1.product.inventoryQty);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.updateState.button, " ");
} }
function QuantityStepperALV1Component_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵtemplate(0, QuantityStepperALV1Component_ng_template_0_div_0_Template, 5, 14, "div", 3)(1, QuantityStepperALV1Component_ng_template_0_div_1_Template, 4, 12, "div", 4);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngIf", !ctx_r1.updateState.show && ctx_r1.calledBy != "editpastpurchases" && ctx_r1.product.price > 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.updateState.show);
} }
function QuantityStepperALV1Component_div_2_ng_container_2_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 23);
    i0.ɵɵlistener("click", function QuantityStepperALV1Component_div_2_ng_container_2_div_4_Template_div_click_0_listener() { i0.ɵɵrestoreView(_r7); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.addToCart()); });
    i0.ɵɵtext(1);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵattributeInterpolate1("data-qty-id", "pc", ctx_r1.product.id, "Inpt");
    i0.ɵɵpropertyInterpolate1("id", "addButton_", ctx_r1.product.id, "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(7, _c4$1, !ctx_r1.isAuthorized, ctx_r1.isLightWeightProduct));
    i0.ɵɵattribute("aria-label", ctx_r1.isAuthorized ? (ctx_r1.isOnProductDetail && ctx_r1.changeLabel ? ctx_r1.changeLabel : ctx_r1.ADD) + " 1 unit of " + ctx_r1.getProductFullName() : ctx_r1.SIGNIN + " 1 unit of " + ctx_r1.getProductFullName());
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.isAuthorized ? ctx_r1.isOnProductDetail && ctx_r1.changeLabel ? ctx_r1.changeLabel : ctx_r1.ADD : ctx_r1.isLightWeightProduct ? ctx_r1.SIGNIN_LIGHT : ctx_r1.SIGNIN, " ");
} }
function QuantityStepperALV1Component_div_2_ng_container_2_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 24)(1, "button", 25);
    i0.ɵɵlistener("click", function QuantityStepperALV1Component_div_2_ng_container_2_div_5_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r8); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.decreaseCart()); });
    i0.ɵɵelement(2, "span", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "span", 26);
    i0.ɵɵelementStart(4, "span", 27);
    i0.ɵɵlistener("click", function QuantityStepperALV1Component_div_2_ng_container_2_div_5_Template_span_click_4_listener() { i0.ɵɵrestoreView(_r8); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.calledBy != "snsCheckoutFlowModal" && ctx_r1.showUpdate()); });
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "button", 11);
    i0.ɵɵlistener("click", function QuantityStepperALV1Component_div_2_ng_container_2_div_5_Template_button_click_6_listener() { i0.ɵɵrestoreView(_r8); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.beforeIncreaseCart(false)); });
    i0.ɵɵelement(7, "span", 12);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵattributeInterpolate2("aria-describedby", "", ctx_r1.carouselId, "pg", ctx_r1.product.id, "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(20, _c5$1, ctx_r1.loadingSpinner));
    i0.ɵɵadvance();
    i0.ɵɵattributeInterpolate1("aria-label", "Decrease Quantity ", ctx_r1.getProductFullName(), "");
    i0.ɵɵpropertyInterpolate1("id", "dec_qtyInfo_", ctx_r1.product.id, "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(22, _c6$1, ctx_r1.calledBy === "snsCheckoutFlowModal" && ctx_r1.qscQuantity <= 1))("disabled", ctx_r1.showQtyUpdateBtn || ctx_r1.updateState.input > ctx_r1.product.inventoryQty && ctx_r1.calledBy !== "snsCheckoutFlowModal" || ctx_r1.calledBy === "snsCheckoutFlowModal" && ctx_r1.qscQuantity <= 1);
    i0.ɵɵadvance(3);
    i0.ɵɵpropertyInterpolate1("id", "qtyInfo_", ctx_r1.product.id, "");
    i0.ɵɵattribute("aria-label", ctx_r1.quantityAriaLabelMessage);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.quantityMessage);
    i0.ɵɵadvance();
    i0.ɵɵattributeInterpolate1("aria-label", "Increase Quantity ", ctx_r1.getProductFullName(), "");
    i0.ɵɵpropertyInterpolate1("id", "inc_qtyInfo_", ctx_r1.product.id, "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(24, _c7$1, ctx_r1.product.quantity >= ctx_r1.product.inventoryQty || ctx_r1.product.quantity >= ctx_r1.product.maxPurchaseQty && ctx_r1.calledBy !== "snsCheckoutFlowModal" || ctx_r1.calledBy === "snsCheckoutFlowModal" && ctx_r1.qscQuantity >= ctx_r1.product.maxPurchaseQty));
    i0.ɵɵattribute("aria-disabled", ctx_r1.product.quantity >= ctx_r1.product.inventoryQty || ctx_r1.product.quantity >= ctx_r1.product.maxPurchaseQty ? "true" : "false");
} }
function QuantityStepperALV1Component_div_2_ng_container_2_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 13)(1, "input", 28);
    i0.ɵɵlistener("keydown.enter", function QuantityStepperALV1Component_div_2_ng_container_2_div_6_Template_input_keydown_enter_1_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.enterTabKeyDown($event)); })("keydown", function QuantityStepperALV1Component_div_2_ng_container_2_div_6_Template_input_keydown_1_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.inputKeydown($event)); })("keyup", function QuantityStepperALV1Component_div_2_ng_container_2_div_6_Template_input_keyup_1_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.inputKeyup($event)); });
    i0.ɵɵtwoWayListener("ngModelChange", function QuantityStepperALV1Component_div_2_ng_container_2_div_6_Template_input_ngModelChange_1_listener($event) { i0.ɵɵrestoreView(_r9); const ctx_r1 = i0.ɵɵnextContext(3); i0.ɵɵtwoWayBindingSet(ctx_r1.updateState.input, $event) || (ctx_r1.updateState.input = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(2, "button", 29);
    i0.ɵɵlistener("click", function QuantityStepperALV1Component_div_2_ng_container_2_div_6_Template_button_click_2_listener() { i0.ɵɵrestoreView(_r9); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.updateCart()); });
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵattributeInterpolate2("aria-describedby", "", ctx_r1.carouselId, "pg", ctx_r1.product.id, "");
    i0.ɵɵpropertyInterpolate1("id", "qtyInfoControl_", ctx_r1.product.id, "");
    i0.ɵɵpropertyInterpolate("max", ctx_r1.product.maxPurchaseQty);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.updateState.input);
    i0.ɵɵadvance();
    i0.ɵɵattributeInterpolate2("aria-describedby", "", ctx_r1.carouselId, "pg", ctx_r1.product.id, "");
    i0.ɵɵproperty("disabled", ctx_r1.showQtyUpdateBtn || ctx_r1.updateState.input > ctx_r1.product.inventoryQty);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", ctx_r1.updateState.button, " ");
} }
function QuantityStepperALV1Component_div_2_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 19);
    i0.ɵɵlistener("keyup", function QuantityStepperALV1Component_div_2_ng_container_2_Template_div_keyup_1_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.qtyStepperKeyup($event)); });
    i0.ɵɵelementStart(2, "span", 20);
    i0.ɵɵtext(3);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(4, QuantityStepperALV1Component_div_2_ng_container_2_div_4_Template, 2, 10, "div", 21)(5, QuantityStepperALV1Component_div_2_ng_container_2_div_5_Template, 8, 26, "div", 22)(6, QuantityStepperALV1Component_div_2_ng_container_2_div_6_Template, 4, 12, "div", 4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction6(5, _c3$1, !ctx_r1.isMarketPlaceEnabled && ctx_r1.isAnyProductHasAddlInfo && !ctx_r1.isLightWeightProduct, !ctx_r1.isAnyProductHasAddlInfo && !ctx_r1.isLightWeightProduct, ctx_r1.calledBy != "snsCheckoutFlowModal" && (ctx_r1.product.quantity == 0 || ctx_r1.updateState.show), ctx_r1.calledBy == "editpastpurchases", ctx_r1.checkMark, ctx_r1.isLightWeightProduct));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.stepperAnnouncement);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.calledBy != "snsCheckoutFlowModal" && (ctx_r1.product.quantity == null || ctx_r1.product.quantity == 0 && !ctx_r1.updateState.show && ctx_r1.calledBy != "editpastpurchases" && ctx_r1.product.price > 0));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.calledBy == "snsCheckoutFlowModal" || ctx_r1.product.quantity > 0 && !ctx_r1.updateState.show && ctx_r1.calledBy != "editpastpurchases");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.updateState.show && ctx_r1.calledBy != "snsCheckoutFlowModal");
} }
function QuantityStepperALV1Component_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 16)(1, "div", 17);
    i0.ɵɵtemplate(2, QuantityStepperALV1Component_div_2_ng_container_2_Template, 7, 12, "ng-container", 18);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    const qscV2_r10 = i0.ɵɵreference(1);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(3, _c2$1, ctx_r1.isQscV2, ctx_r1.isQuantityStepperExtended && ctx_r1.isQscV2, !ctx_r1._isCheckboxChecked && ctx_r1.isQscV2));
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", !ctx_r1.isQscV2)("ngIfElse", qscV2_r10);
} }
function QuantityStepperALV1Component_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 30)(2, "div", 31)(3, "div", 32)(4, "div", 33)(5, "button", 34);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(6, "svg", 35);
    i0.ɵɵelement(7, "path", 36);
    i0.ɵɵelementEnd()();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(8, "p", 37);
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "titlecase");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(11, "p", 38);
    i0.ɵɵtext(12);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(13, "button", 39);
    i0.ɵɵlistener("click", function QuantityStepperALV1Component_ng_container_3_Template_button_click_13_listener() { i0.ɵɵrestoreView(_r11); const ctx_r1 = i0.ɵɵnextContext(); ctx_r1.reserveNewTime(); return i0.ɵɵresetView(ctx_r1.analyticsMTOClicks("reserve-new-time")); });
    i0.ɵɵtext(14, "Reserve new time");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "button", 40);
    i0.ɵɵlistener("click", function QuantityStepperALV1Component_ng_container_3_Template_button_click_15_listener() { i0.ɵɵrestoreView(_r11); const ctx_r1 = i0.ɵɵnextContext(); ctx_r1.chooseTimeLater(); return i0.ɵɵresetView(ctx_r1.analyticsMTOClicks("choose-time-later")); });
    i0.ɵɵtext(16, "Choose time later");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(17, "button", 41);
    i0.ɵɵlistener("click", function QuantityStepperALV1Component_ng_container_3_Template_button_click_17_listener() { i0.ɵɵrestoreView(_r11); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.analyticsMTOClicks("dont-add-item")); });
    i0.ɵɵtext(18, "Don't add item");
    i0.ɵɵelementEnd()()()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassMapInterpolate1("mto-popup p-", ctx_r1.product.id, " modal fade");
    i0.ɵɵadvance(8);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(10, 6, ctx_r1.reservedTimeIntent), " time will change");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2("This item requires ", ctx_r1.getMtoPopupText(), " to prepare. Please select a new time for ", ctx_r1.reservedTimeIntent, "");
} }
function QuantityStepperALV1Component_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 42)(2, "div", 43)(3, "div", 44)(4, "div", 45)(5, "div", 46)(6, "button", 47);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(7, "svg", 48);
    i0.ɵɵelement(8, "path", 36);
    i0.ɵɵelementEnd()();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(9, "div", 49)(10, "p", 50)(11, "span", 51);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(12, "svg", 52);
    i0.ɵɵelement(13, "path", 53);
    i0.ɵɵelementEnd()();
    i0.ɵɵtext(14, " Item can't be added to cart ");
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(15, "p", 54);
    i0.ɵɵtext(16);
    i0.ɵɵelementEnd()()()()()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵclassMapInterpolate1("mto-popup-error p-", ctx_r1.product.id, " modal fade");
    i0.ɵɵadvance(15);
    i0.ɵɵtextInterpolate2("Made to order items require ", ctx_r1.getMtoPopupText(), " to prepare and won\u2019t be ready in time for ", ctx_r1.reservedTimeIntent, ".");
} }
class QuantityStepperALV1Component {
    onQscClick(event) {
        if (!this.isQscV2 || !this.isQuantityStepperExtended) {
            return;
        }
        // if(!document.querySelector(`#addButton_${this.product.id}`)?.contains(event.currentTarget)) {
        //     this.isQuantityStepperExtended = false;
        //     if (this.updateState.show) {
        //         this.updateState.show = false;
        //     }
        // }
        // Close stepper only if clicking on element not in stepper.
        if (!event.target.closest(`#addButton_${this.product.id}`)) {
            if (!event.target.closest(`div.product-btn__update`)) {
                this.isQuantityStepperExtended = false;
                if (this.updateState.show) {
                    this.updateState.show = false;
                }
            }
        }
    }
    set isCheckboxChecked(state) {
        this._isCheckboxChecked = state;
        if (!this._isCheckboxChecked) {
            this.isQuantityStepperExtended = false;
            this.updateState.show = false;
        }
    }
    constructor(_zone, _abTestService, _commonService, _userInfoService, _elementRef, toasterService, cartService, _http, _utilService, cartV2Service, _productUtilService, _aemService, _productSnsModalService, _quickAddBasketService) {
        this._zone = _zone;
        this._abTestService = _abTestService;
        this._commonService = _commonService;
        this._userInfoService = _userInfoService;
        this._elementRef = _elementRef;
        this.toasterService = toasterService;
        this.cartService = cartService;
        this._http = _http;
        this._utilService = _utilService;
        this.cartV2Service = cartV2Service;
        this._productUtilService = _productUtilService;
        this._aemService = _aemService;
        this._productSnsModalService = _productSnsModalService;
        this._quickAddBasketService = _quickAddBasketService;
        this.isMarketPlaceEnabled = false;
        this.isWineShopEnabled = false;
        this.onQtyUpdate = new EventEmitter();
        this.removePastPurchasesEmitter = new EventEmitter();
        this.removeMiniCartEmitter = new EventEmitter();
        this.changeMiniCartEmitter = new EventEmitter();
        this.updateUnavailableCountEmitter = new EventEmitter();
        this.updateCheckboxEmitter = new EventEmitter();
        // Used to trigger recalculating quick add basket total qty on BiaGrid.
        this.updateQscQtyEmitter = new EventEmitter();
        // DFTA - wcax env config
        this.config = EnviormentConfig;
        this.quantityChange = new Subject();
        this.quantityChange$ = this.quantityChange.asObservable();
        this.snsInfoChange = new Subject();
        this.snsInfoChange$ = this.snsInfoChange.asObservable();
        this.cartLSname = 'abCart';
        this.addToCartEndpoint = window['AB']['addToCartPath'];
        this.ADD = 'Add';
        this.SIGNIN = 'Sign in to add';
        this.SIGNIN_LIGHT = 'Sign in';
        this.subscriptions = new Subscription();
        //private _isPromiseServiceEnabled = window['SWY']['CONFIGSERVICE']['featureToggleConfig']['isPromiseServiceEnabled'];
        this._isPromiseServiceEnabled = true;
        this._disableSubPromptFlag = window['SWY']['CONFIGSERVICE']
            && window['SWY']['CONFIGSERVICE'].featureToggleConfig
            && window['SWY']['CONFIGSERVICE'].featureToggleConfig.hasOwnProperty('disableSubPromptFlag')
            ? window['SWY']['CONFIGSERVICE'].featureToggleConfig.disableSubPromptFlag
            : true;
        this.statusAriaLive = 'off';
        this.statusAddAriaMessage = '';
        this.statusQuantityUpdate = '';
        this.quantityMessage = '';
        this.quantityAriaLabelMessage = '';
        this.quantityAdaMessage = '';
        this.loadingSpinner = false;
        this.checkMark = false;
        this.isArEnable = false;
        this.updateState = {
            show: false,
            input: null,
            button: 'Update'
        };
        this._cartIdCreated = new Subject();
        this.cartIdCreated$ = this._cartIdCreated.asObservable();
        this.showQtyUpdateBtn = false;
        this.isAuthorized = false;
        this.isV2CarouselItem = false;
        this.isV2ProductItem = false;
        this.isCrossSellProductItem = false;
        this.isBiaAddAll = '';
        this.disableAddAll = false;
        this.reservedTimeIntent = '';
        this.mto = {
            popup: {
                show: false,
                closeBtn: '.mto-popup__close-btn',
                modalId: '#mtoModal',
                firstFocusableElem: '.mto-popup__close-btn',
                lastFocusableElem: '.mto-popup__dont-add-btn'
            },
            error: {
                show: false,
                closeBtn: '.mto-popup-error__close-btn',
                modalId: '#mtoModalError',
                firstFocusableElem: '.mto-popup-error__close-btn',
                lastFocusableElem: '.mto-popup-error__close-btn'
            }
        };
        this.toastMessagePostion = '20vh';
        this.addAllProductsMessage = '';
        this.currentEnv = '';
        this.baseDomainUrl = '';
        this.isOnProductDetail = false;
        // Extends when user clicks on the quantity stepper.
        this.isQuantityStepperExtended = false;
        // @@TODO - how to handle ?
        //private isMarketPlaceR2Disabled = window['SWY']['CONFIGSERVICE']['featureToggleConfig']['isMarketPlaceR2Disabled'] === false ? false : true;
        this.isMarketPlaceR2Disabled = true;
        this.isLightWeightProduct = false;
        this.isQuantityIncreased = false;
        this.isAuthorized = this._userInfoService.isAuthorized();
        this.reservedTimeIntent = this._userInfoService.getUserChannel();
        this.currentEnv = this._commonService.getCurrentEnviorment();
        this.baseDomainUrl = this.config[this.currentEnv]?.baseURL?.replace("{banner}", this._userInfoService.getBanner());
        this.enableAdRelevanceTracking = !this._aemService.getFeatureFlagByNameDisable('disableAdRelevance');
    }
    ngOnInit() {
        this.isOnProductDetail = this.calledBy === 'product-detail-item';
        this.isLightWeightProduct = this.calledBy === 'light-weight';
        const productCarouselItemV2Wrapper = $(this._elementRef.nativeElement).closest('product-carousel-item-al-v1');
        this.isV2CarouselItem = productCarouselItemV2Wrapper.length ? true : false;
        const productItemV2Wrapper = $(this._elementRef.nativeElement).closest('product-item-al-v1');
        this.isV2ProductItem = productItemV2Wrapper.length ? true : false;
        const crossSellproductItem = $(this._elementRef.nativeElement).closest('.cross-sell__product');
        this.isCrossSellProductItem = crossSellproductItem.length ? true : false;
        this.isBiaAddAll = this.calledBy === 'biaAddAllBtn';
        this.orderNumber = this._aemService.getOrderNumberCookie();
        if (this.isQscV2) {
            this.quantityStepperState = this._isCheckboxChecked ? 'default' : 'disabled';
            this.qscQuantity = JSON.parse(localStorage.getItem('quickAddBasket')).cartItemsList.find((item) => (item.itemId == this.product.id)).qty;
            // Watch the cart for any changes, keeping the state constant between localStorage quickAddBasket and user's cart.
            let cartObjSubscription = this._commonService.currentCartObj.subscribe((cartObj) => {
                // If the cart has the same item as an item in localStorage, then update it to the val in cart.
                const matchingItem = cartObj?.cartItems?.find(item => item.itemId == this.product.id);
                if (matchingItem) {
                    this.qscQuantity = matchingItem.qty;
                    this.setLocalStorageQscQuantity(this.qscQuantity);
                }
            });
            this.subscriptions.add(cartObjSubscription);
        }
        if (this.calledBy === 'biaAddAllBtn') {
            this.updateBiaAddAllBtnContext();
            /**
             * Subscription to update bia add all button. This will determine how many products
             * need to be added to the cart if the user decides to add some items individually
             * then later decides to use the add all button
             **/
            this.updateBiaAddAllSubscription = this._commonService.updateBiaAddAllBtn$.subscribe((update) => {
                if (update) {
                    this.updateBiaAddAllBtnContext();
                }
            });
        }
        if (this._isRegistered()) {
            if (this._commonService.checkCartId('cartId')) {
                this.cartId = this._commonService.getCartId('cartId');
            }
        }
        else {
            if (this._commonService.checkCartId('guestCartId')) {
                this.cartId = this._commonService.getCartId('guestCartId');
            }
        }
        if (this._isRegistered()) {
            this.httpOptions = {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Authorization': 'Bearer ' + this._userInfoService.getSWY_SHOP_TOKEN(),
                    'Sort-Order': 'date',
                    'ocp-apim-subscription-key': this.config[this.currentEnv].cartAPIDetails.subscriptionKey.value,
                    //'ocp-apim-trace': window['AB']['cartapimtrace']
                    'ocp-apim-trace': 'true'
                })
            };
        }
        else {
            this.httpOptions = {
                headers: new HttpHeaders({
                    'Content-Type': 'application/json',
                    'Sort-Order': 'date',
                    'ocp-apim-subscription-key': this.config[this.currentEnv].cartAPIDetails.subscriptionKey.value,
                    'ocp-apim-trace': 'true'
                })
            };
        }
        if (!this.isBiaAddAll) {
            // DNF page does not redirect to PDP page
            //this.productDetailPath = this._appConfigService.getProductDetailPath();
            if (this.productDetailPath) {
                this.productDetailPath = this.productDetailPath.replace('(bpn)', (this.product.id !== undefined)
                    ? this.product.id
                    : this.product.itemId);
            }
            this.product['originalQuantity'] = this.product.quantity;
        }
        if (this.calledBy === 'lastorder') {
            this.product.quantityOrder = this.product.previousPurchaseQty ? this.product.previousPurchaseQty : this.product.quantity;
        }
        if (this.calledBy !== 'minicart' && !this.isBiaAddAll) {
            let obs = this._commonService.currentCartObj;
            const cartName = this.cartV2Service.getCartName(this.configObj?.programType, this.product.sellerId);
            obs = obs.pipe(map(objCart => this.cartV2Service.fetchCartDetailsFromResponse(objCart, cartName)));
            obs.subscribe(objCart => {
                this.hasCart = !!objCart.cartId;
                let qty = 0;
                try {
                    let cartProduct = {};
                    if (!this._commonService.checkPendingOrder()) {
                        cartProduct = objCart['cartItems'].find(item => item.itemId == this.product.id);
                        qty = cartProduct ? cartProduct.qty : 0;
                    }
                    else {
                        cartProduct = objCart['cartItems'].find(item => item.itemId == this.product.id);
                        qty = cartProduct ? cartProduct.quantity : 0;
                    }
                    this.product.maxPurchaseQty = cartProduct.maxPurchaseQty;
                    qty = (qty > 0) ? qty : 0;
                }
                catch (e) {
                    qty = 0;
                }
                this.product.quantity = qty;
                this.quantityMessage = this._getQuantityMessage();
                if (this.calledBy == 'snsCheckoutFlowModal') {
                    this.qscQuantity = 1;
                    this.quantityMessage = this.qscQuantity.toString();
                    this.quantityAriaLabelMessage = '1' + ' units of ' + this.product.name;
                }
                // product from last order carousel/page which is in current cart
                if (this.calledBy === 'lastorder' && this.product.quantityOrder > 0 && this.product.quantity > 0) {
                    this.updateState = {
                        show: false,
                        input: null,
                        button: 'Update'
                    };
                }
            });
        }
        // Product from last order carousel/page which is not in current cart.
        if (this.calledBy === 'lastorder' && this.product.quantityOrder > 0 && this.product.quantity < 1) {
            const inputQuantity = this.product.hasOwnProperty('maxPurchaseQty')
                && this.product.maxPurchaseQty
                && this.product.quantityOrder > this.product.maxPurchaseQty
                ? this.product.maxPurchaseQty : this.product.quantityOrder;
            this.product.quantityOrder = inputQuantity;
            if (inputQuantity > 0) {
                this.updateState = {
                    show: true,
                    input: this.product.quantityOrder,
                    button: 'Add'
                };
            }
        }
        // Debounce 600ms before sending data to API.
        this.quantityChange$
            .pipe(tap((qty) => this.updateLoadingMessage(qty)), debounceTime(600))
            .subscribe(qty => {
            if (!this.isBiaAddAll) {
                this.loadingSpinner = true;
                this.addCart(qty);
            }
            else {
                this.addAllItemsToCart(qty);
            }
        });
        // Debounce 600ms before sending data to API.
        this.snsInfoChange$.pipe(debounceTime(600)).subscribe(snsInfoObj => {
            this._cartAPICallV2(snsInfoObj.qty, snsInfoObj.snsInfo);
        });
        if (this._commonService.checkPendingOrder()) {
            this.reservedTimeIntent = JSON.parse(localStorage.getItem('abSlotEditOrder'))?.serviceType;
        }
        else {
            this.reservedTimeIntent = JSON.parse(localStorage.getItem('abSlot'))?.userChannel;
        }
        // add first time cart modal listeners
        this.addFirstTimeCartModalListeners();
    }
    ngOnChanges(changes) {
        if (this.isOnProductDetail && this.snsInfo.isChecked) {
            this.contents = this._productSnsModalService.getDynamicContents();
            this.changeLabel = this.contents?.snsSubscribedCTAText;
        }
        else {
            this.changeLabel = 'Add';
        }
        this.isBiaAddAll = this.calledBy === 'biaAddAllBtn';
        /*
         * README: Update quantity message when the product data change is triggered from an external source.
         * eg. This gets triggered when the product is swapped in meals-product-grid.
         */
        if (!this.isBiaAddAll) {
            if (this.calledBy === 'minicart') {
                this.quantityMessage = this._getQuantityMessage(this.product.qty);
            }
            else {
                this.quantityMessage = this._getQuantityMessage(this.product.quantity);
            }
        }
        if (changes.snsInfo && changes.snsInfo.currentValue.updateCart) {
            const qty = this.calledBy === 'minicart' ? this.product.qty : this.product.quantity;
            if (qty > 0) {
                this.snsInfoChange.next({ qty: qty, snsInfo: changes.snsInfo });
            }
        }
    }
    /**
     * Add current product in cart.
     *
     * @param {any} quantity New stepper's quantity.
     */
    addCart(quantity) {
        quantity = (quantity >= 0) ? quantity : 0;
        if (this.product.maxPurchaseQty && quantity > this.product.maxPurchaseQty) {
            quantity = this.product.maxPurchaseQty;
        }
        if (quantity === 0 && this.calledBy === 'minicart') {
            // Remove product from minicart
            this._removeMiniCart();
            this.statusAriaLive = 'polite';
        }
        else {
            if (quantity === 0) {
                this._removeProductV2();
            }
            else {
                // Send data to API to sync mini cart
                this.showQtyUpdateBtn = true;
                this.quantityMessage = this._getQuantityMessage(quantity);
                this._cartAPICallV2(quantity);
                if (this.statusQuantityUpdate === 'increase') {
                    this.isQuantityIncreased = true;
                    this.statusAddAriaMessage = '1 item added to cart';
                }
                else if (this.statusQuantityUpdate === 'decrease') {
                    this.statusAddAriaMessage = '1 item removed from cart';
                }
                else if (this.statusQuantityUpdate === 'update') {
                    this.statusAddAriaMessage = 'cart updated';
                }
                else {
                    this.statusAddAriaMessage = '';
                }
            }
        }
    }
    showPriceChangeToast(isQuantityIncreased, cart) {
        const isOrderAmendDisabled = this._aemService.getFeatureFlagByNameDisable('isOrderAmendDisabled');
        if (!isOrderAmendDisabled && isQuantityIncreased && this._commonService.checkPendingOrder()) {
            const orderedProduct = cart['cartItems']?.find(item => item.itemId === this.product.id);
            const price = this._commonService.getValidProductPrice(this.product);
            const orderedItemPrice = orderedProduct?.price < orderedProduct?.basePrice ? orderedProduct?.price : orderedProduct?.basePrice;
            if (orderedProduct && orderedItemPrice !== price) {
                let msg = `Great news—your price for this item is still $${orderedItemPrice}, based on when you placed your order. `;
                if (orderedItemPrice > price) {
                    msg = `The price for ${this.product.name} has changed, but your price is still $${orderedItemPrice} based on its price on the day your order was placed. `;
                }
                this.toasterService.show({
                    title: 'OK',
                    message: msg,
                    type: ToasterType.Info,
                    interactiveElement: 'See Policy',
                    interactiveElementLink: 'https://www.albertsonscompanies.com/policies-and-disclosures/terms-of-use/default.aspx',
                }, { class: 'popup--toaster--right' });
            }
        }
    }
    beforeIncreaseCart(crossSell, redirectToPrebook) {
        console.warn('beforeIncreaseCart()');
        let bpn;
        this.isPrebookRedirect = redirectToPrebook ? redirectToPrebook : false;
        if (!this.isBiaAddAll) {
            bpn = (this.product.id !== undefined) ? this.product.id : this.product.itemId;
        }
        const preference = this._userInfoService.getPreference()
            ? this._userInfoService.getPreference().toUpperCase()
            : undefined;
        if (this.isAuthorized) {
            // README: wrapping the entire code as anonymous function to pass it as a callback Function
            const increaseCartIfSessionValid = () => {
                console.warn('increaseCartIfSessionValid()');
                if (preference === 'DELIVERY' || preference === 'DUG') {
                    if (this.calledBy != 'snsCheckoutFlowModal') {
                        this.increaseCart();
                    }
                    if (crossSell && this.calledBy !== 'crosssell') {
                        if (localStorage.getItem('abCart')) {
                            const productIds = this.cartService._get()['cartItems'].map(product => product.itemId);
                            this._commonService.showCrossSell(bpn, this.product.aisleId, productIds, this.crossSellType);
                        }
                        else {
                            this._commonService.showCrossSell(bpn, this.product.aisleId, [], this.crossSellType);
                        }
                    }
                }
                else {
                    if (preference === 'J4U') {
                        if (this.configObj?.appName === 'weeklyAd') {
                            this.navigateBannerDomainToOpenStoreSlctChange();
                        }
                        else {
                            window['rightDrawerComp'].closeDrawer();
                            window['storeFulfillmentModal'].component.setModalDisplayData(2);
                        }
                    }
                }
                if (this.calledBy != 'snsCheckoutFlowModal') {
                    $('.delivery-content__button, .pickup-content .card-store-btn').click(() => {
                        this.increaseCart();
                    });
                }
                else {
                    if (this.qscQuantity < Number(this.product.maxPurchaseQty)) {
                        this.qscQuantity += 1;
                        this.quantityAriaLabelMessage = this.qscQuantity.toString() + ' units of ' + this.product.name;
                        this.quantityMessage = this.qscQuantity.toString();
                        setTimeout(() => $(this._elementRef.nativeElement).children().find("span#qtyInfo_" + this.product.id).focus(), 0);
                        this.updateQscQtyEmitter.emit(this.quantityMessage);
                    }
                }
            };
            // README: calling validateSession with a callback function (i.e increaseCartIfSessionValid) which does check for
            // a valid session and increase the cart
            if (this._commonService.isGuestUser()) {
                increaseCartIfSessionValid();
            }
            else {
                this._commonService.validateSession(increaseCartIfSessionValid);
            }
        }
        else {
            if (window['eddlLoadComplete']) {
                window['AB']['DATALAYER'].setATCFlag(true);
            }
            this._showSignInModal(this.configObj);
        }
    }
    /**
     * Increase current product quantity in cart.
     */
    increaseCart() {
        console.warn('increaseCart()');
        const refocusButton = event ? event.currentTarget : null;
        const preference = this._userInfoService.getPreference()
            ? this._userInfoService.getPreference().toUpperCase()
            : undefined;
        if (preference === 'J4U') {
            if (this.configObj.appName === 'weeklyAd') {
                this.navigateBannerDomainToOpenStoreSlctChange();
            }
            else {
                window['storeFulfillmentModal'].component.setModalDisplayData(2);
            }
        }
        else {
            let isAddedToCart = false;
            if (this.calledBy === 'minicart') {
                this.product.qty = this.product.qty + 1;
                if (this.product.qty === 1) {
                    this.loadingSpinner = true;
                    isAddedToCart = true;
                }
                this.quantityMessage = this._getQuantityMessage(this.product.qty);
                this.quantityChange.next(this.product.qty);
            }
            else if (!this.isBiaAddAll) {
                this.product.quantity = this.product.quantity ? this.product.quantity + 1 : 1;
                if (this.product.quantity === 1) {
                    this.loadingSpinner = true;
                    isAddedToCart = true;
                }
                this.quantityMessage = this._getQuantityMessage(this.product.quantity);
                this.quantityChange.next(this.product.quantity);
            }
            else {
                console.warn('isBiaAddAll');
                isAddedToCart = true;
                this.quantityChange.next(this.addAllItemsMap());
            }
            this.statusAriaLive = 'polite';
            this.statusQuantityUpdate = 'increase';
            if (!this.isBiaAddAll) {
                if (isAddedToCart) {
                    this.addItemToCartAnalytics = true;
                    this.setAnalyticsSNSProdAction('add-item');
                }
                else {
                    this.increaseQuantityAnalytics = true;
                    this.setAnalyticsSNSProdAction('quantity-increase');
                    this.setFocusBackOnButton(refocusButton);
                }
            }
        }
    }
    /**
     * Decrease current product quantity in cart.
     */
    decreaseCart() {
        const preference = this._userInfoService.getPreference()
            ? this._userInfoService.getPreference().toUpperCase()
            : undefined;
        if (preference === 'J4U') {
            if (this.configObj.appName === 'weeklyAd') {
                this.navigateBannerDomainToOpenStoreSlctChange();
            }
            else {
                window['storeFulfillmentModal'].component.setModalDisplayData(2);
            }
        }
        else {
            if (this.isAuthorized) {
                // README: wrapping the entire code as anonymous function to pass it as a callback Function
                const decreaseCartIfSessionValid = () => {
                    if (this.calledBy === 'minicart') {
                        this.product.qty = this.product.qty - 1;
                        if (this.product.qty === 0) {
                            this.loadingSpinner = true;
                            this._commonService.closeCrossSell(this.product.id);
                        }
                        this.quantityMessage = this._getQuantityMessage(this.product.qty);
                        this.quantityChange.next(this.product.qty);
                    }
                    else if (this.calledBy === 'snsCheckoutFlowModal') {
                        if (this.qscQuantity == 1) {
                            this.quantityAriaLabelMessage = '1' + ' units of ' + this.product.name;
                            return;
                        }
                        else {
                            this.qscQuantity -= 1;
                            this.quantityAriaLabelMessage = this.qscQuantity.toString() + ' units of ' + this.product.name;
                            this.quantityMessage = this.qscQuantity.toString();
                            setTimeout(() => $(this._elementRef.nativeElement).children().find("span#qtyInfo_" + this.product.id).focus(), 0);
                            this.updateQscQtyEmitter.emit(this.quantityMessage);
                        }
                    }
                    else {
                        this.product.quantity = this.product.quantity - 1;
                        if (this.product.quantity === 0) {
                            this.loadingSpinner = true;
                            setTimeout(() => {
                                $('#addButton_' + this.product.id).focus();
                            }, 150);
                            this._commonService.closeCrossSell(this.product.id);
                        }
                        this.quantityMessage = this._getQuantityMessage(this.product.quantity);
                        this.quantityChange.next(this.product.quantity);
                    }
                    const refocusButton = event ? event.currentTarget : null;
                    this.statusAriaLive = 'polite';
                    this.statusQuantityUpdate = 'decrease';
                    if ((this.product.quantity === 0) || (this.product.qty === 0)) {
                        if (this.calledBy !== 'minicart' && window['AB']['DATALAYER']) {
                            this.removeItemFromCartAnalytics = true;
                            this.setAnalyticsSNSProdAction('remove-item');
                        }
                    }
                    else {
                        this.decreaseQuantityAnalytics = true;
                        this.setAnalyticsSNSProdAction('quantity-decrease');
                        this.setFocusBackOnButton(refocusButton);
                    }
                };
                // README: calling validateSession with a callback function (i.e decreaseCartIfSessionValid) which does check for
                // a valid session and decrease the cart
                if (this._commonService.isGuestUser()) {
                    decreaseCartIfSessionValid();
                }
                else {
                    this._commonService.validateSession(decreaseCartIfSessionValid);
                }
            }
            else {
                this._showSignInModal();
            }
        }
    }
    setFocusBackOnButton(refocusButton) {
        setTimeout(() => {
            $(refocusButton).focus();
        }, 8500);
    }
    getProductFullName() {
        let fullName = '';
        if (this.product)
            fullName = this.product.fullName && this.product.fullName.length ? this.product.fullName : this.product.name;
        return fullName;
    }
    /**
     * Update analytics product info.
     */
    _updateAnalyticsProductInfo(sellerId) {
        // check for datalayer availability, in case component is loaded on pages without the AEM datalayer
        if (window['AB']?.DATALAYER) {
            let productInfoObj;
            // determine whether the current stepper is on a product that is part of the cross-sell component
            const isCrossSell = this._elementRef.nativeElement.closest('cross-sell') ? true : false;
            const isBIACrossSell = this._elementRef.nativeElement.closest('.slick-product-carousel')?.querySelectorAll('[data-carousel-behaviour="bia-crossSell"]')?.length;
            const isBIASpaCarousel = this._elementRef.nativeElement.closest('.slick-product-carousel')?.querySelectorAll('[data-carousel-behaviour="bia-spaCarousel"]')?.length;
            let carouselTitle = '';
            if (this.carouselTitle) {
                carouselTitle = this.carouselTitle;
            }
            else if (isBIACrossSell) {
                carouselTitle = this._elementRef.nativeElement.closest('cross-sell')?.querySelector('.cross-sell__header .cross-sell__title')?.textContent;
            }
            else if (isBIASpaCarousel) {
                carouselTitle = this._elementRef.nativeElement.closest('.bia-spa-carousel-container')?.querySelector('.bia-spa-carousel-container-header')?.textContent?.trim();
            }
            else if (this._elementRef.nativeElement.closest('.master-product-carousel')) {
                carouselTitle = this._elementRef.nativeElement.closest('.master-product-carousel').querySelector('[data-carousel-title]')?.getAttribute('data-carousel-title');
            }
            else if (window['AB'].DATALAYER.isDFTAPage()) {
                carouselTitle = this._elementRef.nativeElement.closest('.slick-product-carousel')?.previousElementSibling?.textContent?.trim() || '';
            }
            else {
                carouselTitle = this._elementRef.nativeElement.closest('.slick-product-carousel')?.querySelector('lazy-wrapper')?.getAttribute('data-carousel-title') ||
                    this._elementRef.nativeElement.closest('.slick-product-carousel')?.querySelector('.carousel-header-text')?.textContent?.trim();
            }
            productInfoObj = {
                id: this.product.id || this.product.itemId,
                adobeMetricA: this.product['adobeMetrics']?.metricA,
                adobeMetricC: this.product['adobeMetrics']?.metricC,
                fullName: this.product.fullName,
                name: this.product.name,
                units: this._commonService.checkPendingOrder() ? this.product.quantity : this.product.qty,
                unitType: this.product.unitQuantity,
                lbs: '0',
                each: '0',
                pricePerUnit: this.product.pricePer,
                listPrice: this.product.price ? this.product.price.toString() : '',
                carouselSection: carouselTitle,
                basePrice: this.product.basePrice ? this.product.basePrice.toString() : '',
                pricingType: this.product.promoType,
                couponFlag: '0',
                couponClipped: '0',
                couponID: '',
                aisleId: this.product.aisleId,
                upc: this.product.upc,
                isCrossSell: isCrossSell,
                isMTO: this.product.isMtoProduct,
                departmentName: this.product.departmentName,
                pathwaysWidget: this.pathwaysWidget,
                sellerId: sellerId ? sellerId : this.product.sellerId,
                sellerName: this.product['sellerName'],
                editOrderFlow: this._commonService.checkPendingOrder() ? true : false,
                snapEligible: this.product.snapEligible,
                isProductTrackingDisabled: this.product.isProductTrackingDisabled ? true : false,
                isP13nGrid: this._elementRef.nativeElement.closest('#p13nProductGrid') ? true : false,
                quantity: this.product.quantity
            };
            if (this.product.unitQuantity == 'EACH') {
                productInfoObj.each = this.product.quantity ? this.product.quantity.toString() : this.product.qty?.toString();
            }
            const coupons = this._commonService.getCouponByUpc(this.product.upc);
            // If there are coupons present on the product, filters the information and adds it to the productInfo object
            if (coupons.length > 0) {
                const couponsClipped = coupons.filter(x => x.status === 'C').length;
                const couponsCount = coupons.length;
                const couponIds = coupons.filter(x => x.status === 'C').map(x => x.offerId).toString();
                productInfoObj.couponFlag = couponsCount.toString();
                productInfoObj.couponClipped = couponsClipped.toString();
                productInfoObj.couponID = couponIds;
            }
            // For items that are not on the minicart, set the recommendation type to be used in analytics code
            if (this.calledBy !== 'minicart') {
                let isBuyItAgain;
                let isBrPathway;
                let isPicksForYou = false;
                let isP13nGeneric = false;
                if (carouselTitle) {
                    const parentCarousel = $(this._elementRef.nativeElement).closest('.slick-product-carousel');
                    const buyItAgainCarousel = parentCarousel.find('[data-carousel-behaviour=buy-it-again]').length;
                    const brPathwayCarousel = parentCarousel.find('[data-carousel-driven=pathway-search]').length;
                    const p13nGenericCarousel = parentCarousel.find('[data-carousel-driven=p13n-generic]').length;
                    productInfoObj.isBIACarousalProduct = parentCarousel.find('[data-carousel-behaviour=bia-spaCarousel]').length ? true : false;
                    isBuyItAgain = buyItAgainCarousel ? true : false;
                    isBrPathway = brPathwayCarousel ? true : false;
                    isPicksForYou = carouselTitle.search(/picks for you|picked for you|picks-for-you|picked-for-you/i) !== -1;
                    isP13nGeneric = p13nGenericCarousel ? true : false;
                    // set placement value for carousel items
                    productInfoObj.placement = window['AB'].DATALAYER.setPlacementInfoCarouselItems(this._elementRef.nativeElement);
                }
                let recommendationObj = {
                    isCrossSell: isCrossSell,
                    isRecommended: this.isRecommended || isPicksForYou || isP13nGeneric,
                    isSponsored: this.product['featured'],
                    isPastPurchased: isBuyItAgain || this.product['pastPurchased'],
                    isBrPathway: isBrPathway
                };
                if (this.product['adId'] || this.product.eventTracking) {
                    recommendationObj.isSponsored = true;
                }
                window['AB'].DATALAYER.recommendationInfo(recommendationObj);
            }
            window['AB'].DATALAYER.productInfo(productInfoObj);
            /**
             * update pageFilter with:
             * cart type (when a user performs a product action in mini cart)
             * carousel title (when a user performs any action related to a carousel)
             */
            if (this.calledBy === 'minicart') {
                window['AB'].DATALAYER.setCarouselName('shop|mini_cart');
            }
            else if (carouselTitle) {
                window['AB'].DATALAYER.isRecipesPage()
                    ? window['AB'].DATALAYER.setCarouselName(`recipes|${carouselTitle}`)
                    : window['AB'].DATALAYER.setCarouselName(`shop|${carouselTitle}`);
            }
            else {
                window['AB'].DATALAYER.setCarouselName('');
            }
            /**
             * for products that are not in the minicart or in a carousel
             * set metaInfo(number of images clicked on pdp before the user performs a product action)
             */
            if (window['AB'].DATALAYER.isPdp()) {
                if (this.calledBy === 'minicart' || carouselTitle) {
                    window['AB'].DATALAYER.setPageFilterMetaInfo(false);
                }
                else {
                    window['AB'].DATALAYER.setPageFilterMetaInfo(true);
                }
            }
        }
    }
    setAnalyticsSNSProdAction(action) {
        if (this.configObj?.programType === '1P_SNS') {
            localStorage.setItem('analyticsSNSProdAction', action);
        }
    }
    /**
     * Update cart with input's quantity.
     */
    updateCart() {
        if (this.updateState.input === null) {
            this.updateState.input = 0;
        }
        const preference = this._userInfoService.getPreference()
            ? this._userInfoService.getPreference().toUpperCase()
            : undefined;
        if (preference === 'J4U') {
            if (this.configObj?.appName === 'weeklyAd') {
                this.navigateBannerDomainToOpenStoreSlctChange();
            }
            else {
                window['storeFulfillmentModal'].component.setModalDisplayData(2);
            }
        }
        else {
            // README: wrapping the entire code as anonymous function to pass it as a callback Function
            const updateCartIfSessionValid = () => {
                this.loadingSpinner = true;
                let isAddedToCart = false;
                let isQuantityIncreased = false;
                let isRemovedFromCart = false;
                let isQuantityDecreased = false;
                if (this.calledBy === 'minicart') {
                    if (this.updateState.input > this.product.qty) {
                        if (this.product.qty === 0) {
                            isAddedToCart = true;
                        }
                        else {
                            isQuantityIncreased = true;
                        }
                    }
                    else if (this.updateState.input < this.product.qty) {
                        if (this.updateState.input === 0) {
                            isRemovedFromCart = true;
                        }
                        else {
                            isQuantityDecreased = true;
                        }
                    }
                    this.product.qty = this.updateState.input;
                }
                else {
                    if (this.updateState.input > this.product.quantity) {
                        if (this.product.quantity === 0) {
                            isAddedToCart = true;
                        }
                        else {
                            isQuantityIncreased = true;
                        }
                    }
                    else if (this.updateState.input < this.product.quantity) {
                        if (this.updateState.input === 0) {
                            isRemovedFromCart = true;
                        }
                        else {
                            isQuantityDecreased = true;
                        }
                    }
                    this.product.quantity = this.updateState.input;
                }
                this.addCart(this.updateState.input);
                // updata analytics data layer
                if (this.calledBy !== 'minicart' || this.updateState.input > 0) {
                    if (window['AB']['DATALAYER']) {
                        if (isAddedToCart) {
                            this.addItemToCartAnalytics = true;
                            this.setAnalyticsSNSProdAction('add-item');
                        }
                        else if (isQuantityIncreased) {
                            this.increaseQuantityAnalytics = true;
                            this.setAnalyticsSNSProdAction('quantity-increase');
                        }
                        else if (isRemovedFromCart) {
                            this.removeItemFromCartAnalytics = true;
                            this.setAnalyticsSNSProdAction('remove-item');
                        }
                        else if (isQuantityDecreased) {
                            this.decreaseQuantityAnalytics = true;
                            this.setAnalyticsSNSProdAction('quantity-decrease');
                        }
                    }
                }
                this.statusAriaLive = 'polite';
                this.statusQuantityUpdate = 'update';
            };
            // README: calling validateSession with a callback function (i.e decreaseCartIfSessionValid) which does check for
            // a valid session and decrease the cart
            if (this._commonService.isGuestUser()) {
                updateCartIfSessionValid();
            }
            else {
                this._commonService.validateSession(updateCartIfSessionValid);
            }
        }
    }
    /**
     * Show update button with numeric input and hide steppers.
     */
    showUpdate() {
        const preference = this._userInfoService.getPreference()
            ? this._userInfoService.getPreference().toUpperCase()
            : undefined;
        if (preference === 'J4U') {
            if (this.configObj?.appName === 'weeklyAd') {
                this.navigateBannerDomainToOpenStoreSlctChange();
            }
            else {
                window['storeFulfillmentModal'].component.setModalDisplayData(2);
            }
        }
        else {
            if (this.calledBy === 'minicart') {
                this.updateState.input = this.product.qty;
            }
            else {
                this.updateState.input = this.product.quantity;
            }
            this.updateState.show = true;
            this.statusAriaLive = 'polite';
            this.setFocusInsideQtyControl();
        }
    }
    /**
     * Remove product from Past Purchases and send emitter to grid.
     */
    removePastPurchases(event) {
        this.loadingSpinner = true;
        this.removePastPurchasesEmitter.emit(event);
        this.statusAriaLive = 'polite';
    }
    /**
     * Update quantity on tab or enter.
     */
    enterTabKeyDown(event) {
        const e = event;
        const keyCode = !e.which ? e.keyCode : e.which;
        if (this.updateState.button === 'Update') {
            e.preventDefault();
        }
        if (!(this.updateState.button === 'Add' && keyCode === 9)) {
            this.updateCart();
        }
        this.statusAriaLive = 'polite';
    }
    qscEnterTabKeyDown() {
        this.qscUpdateAmt();
    }
    qscUpdateAmt() {
        let currentAmt = document.querySelector(`#qtyInfoControl_${this.product.id}`).valueAsNumber;
        if (isNaN(currentAmt)) {
            currentAmt = this.qscQuantity;
        }
        if (currentAmt == 0) {
            this.updateCheckboxEmitter.emit();
            this._isCheckboxChecked = false;
            currentAmt = 1;
        }
        if (this.product.maxPurchaseQty && currentAmt > this.product.maxPurchaseQty) {
            currentAmt = this.product.maxPurchaseQty;
        }
        this.qscQuantity = currentAmt;
        this.setLocalStorageQscQuantity(this.qscQuantity);
        this.statusAriaLive = 'polite';
        this.updateState.show = false;
    }
    /**
     * Input Keydown event. Used to remove e,+,- and period from quantity input.
     */
    inputKeydown(event) {
        const e = event;
        const keyCode = !e.which ? e.keyCode : e.which;
        const actionsToAllow = [8, 9, 13, 37, 38, 39, 40, 46]; // backspace, tab, enter, arrows and delete
        const keysToAllow = '0123456789'; // had to do this because firefox sees 1 as ! and ¡ etc if we use keyCodes
        // Prevent all but numbers, backspace, delete, tab and enter
        if (!(actionsToAllow.includes(keyCode) || keysToAllow.includes(e.key))) {
            e.preventDefault();
        }
        // Prevent double space keystroke adding a decimal/. to input
        if (event.key == ' ') {
            let inputField = document.querySelector(`#qtyInfoControl_${this.product.id}`);
            inputField.value = inputField.value.replace(/[^0-9]*/g, '');
        }
    }
    /**
     * Input Keyup event. Used to prevent numbers greater than maxPurchaseQty value.
     */
    inputKeyup(event) {
        if (this.product.maxPurchaseQty && event.target.value > this.product.maxPurchaseQty) {
            event.preventDefault();
            event.target.value = this.product.maxPurchaseQty;
        }
    }
    /**
     * Quantity Stepper Wrapper Keyup event. Used to show update on Tab.
     */
    qtyStepperKeyup(event) {
        const e = event;
        const keyCode = !e.which ? e.keyCode : e.which;
        if (keyCode === 13) {
            if (this._isRegistered()) {
                this.showUpdate();
                this.statusAriaLive = 'polite';
                this.setFocusInsideQtyControl();
            }
            else {
                this._showSignInModal(this.configObj);
            }
        }
    }
    /**
     * Remove product from miniCart.
     */
    _removeMiniCart() {
        if (this.orderNumber !== '' && this.orderNumber != 0) {
            this.removeMiniCartEmitter.emit(this.product.id);
        }
        else {
            this.removeMiniCartEmitter.emit(this.product.itemId);
        }
        this.statusAriaLive = 'polite';
    }
    _cartAPICallV2(quantity, snsInfoChangeObj) {
        const isCartCreated = !this.hasCart;
        const oldCartIdLs = JSON.parse(localStorage.getItem('cartId'));
        this.cartV2Service.addOrUpdateProductQuantity(this.product, 
        // Added extra ternary for biaAddAllBtn to avoid checking id property on undefined product.
        this.calledBy == 'biaAddAllBtn' ? '' : this.calledBy === 'minicart' ? this.product.itemId : this.product.id, quantity, this.isBiaAddAll, this.product.sellerId, false, this.snsInfo, this.configObj?.programType ? this.configObj?.programType : this.configObj?.appName)
            .subscribe((response) => {
            if (response) {
                if (this.isQuantityIncreased) {
                    this.showPriceChangeToast(this.isQuantityIncreased, response);
                    this.isQuantityIncreased = false;
                }
                if (this.configObj?.programType === '1P_SNS') {
                    this.callSNSSuccessDispatch();
                }
                else {
                    this.cartService.refreshCart(response);
                }
                const cartName = this.cartV2Service.getCartName(this.configObj?.programType, this.product.sellerId);
                let singleCartresponse = this.cartV2Service.fetchCartDetailsFromResponse(response, cartName);
                if (singleCartresponse && singleCartresponse['cartId']) {
                    if (singleCartresponse['cartItems']) {
                        if (window['AB']['DATALAYER']) {
                            window['AB']['DATALAYER'].updateCartType(this.calledBy === 'minicart' ? 'mini_cart' : '');
                            window['AB']['DATALAYER'].updateCart(response, this.product, response['isWYSIWYGEnabled']);
                        }
                        this.isWYSIWYGEnabled = singleCartresponse['isWYSIWYGEnabled'];
                        // track product impression
                        this.calledBy == 'biaAddAllBtn'
                            ? this.products.forEach(product => this._commonService.sendSponsoredProductClickEvent(product, 'quantityStepper', 'addToCart'))
                            : this._commonService.sendSponsoredProductClickEvent(this.product, 'quantityStepper', 'addToCart');
                        // make ad relevance call for all products on search page only
                        if (!this.isCrossSellProductItem && this.enableAdRelevanceTracking) {
                            this._commonService.recordRelevanceImpression(this.product, 'quantityStepper', 'addToCart');
                        }
                        if (this.isPrebookRedirect) {
                            this.redirectToPrebookPage();
                        }
                        this.loadingSpinner = false;
                        const isAdd = isCartCreated, isEdit = !isCartCreated;
                        this.cartId = singleCartresponse['cartId'];
                        if (isAdd) {
                            this._cartIdCreated.next(this.cartId);
                        }
                        singleCartresponse = this.cartV2Service.handleResponseForPendingOrder(singleCartresponse);
                        if (!this.isBiaAddAll) {
                            // Add and Remove checkMark after 1 second
                            this.checkMark = true;
                            setTimeout(() => {
                                this.checkMark = false;
                                this.showQtyUpdateBtn = false;
                                this._setFocusInsideQty();
                                this._clearStatusAriaMessage();
                            }, 1000);
                            this.updateState = {
                                show: false,
                                button: 'Update'
                            };
                            this._setFocusInsideQty();
                            this.product.quantity = quantity;
                            this.quantityMessage = this._getQuantityMessage();
                            if (this.calledBy === 'minicart') {
                                this.changeMiniCartEmitter.emit(singleCartresponse['summary']);
                                this.updateUnavailableCountEmitter.emit(singleCartresponse['mfcUnavailableProductsCount']);
                                if (isEdit) {
                                    this.onQtyUpdate.emit(this.product);
                                }
                            }
                            if (this.product.sellerId && this.configObj?.programType !== 'mkp-carousel') {
                                this.showMkpAddToCartModal(this.product.sellerId, this.product.sellerName, this.product.price, oldCartIdLs);
                            }
                            else if (this.configObj?.programType === 'wineshop') {
                                this.showStaticFirstTimeCartModal('1P_WINE', oldCartIdLs);
                            }
                            if (this.isOnProductDetail && snsInfoChangeObj &&
                                (snsInfoChangeObj?.currentValue?.isChecked !== snsInfoChangeObj?.previousValue?.isChecked) &&
                                snsInfoChangeObj?.currentValue?.isChecked === false) {
                                this.preventFocusOnQty = true;
                                this.toasterService.show({
                                    title: 'OK',
                                    message: `You've unsubscribed to this item.`,
                                    type: ToasterType.Info,
                                    interactiveElement: 'Undo',
                                    autoCloseTime: 30000,
                                    isSnsCheckbox: !(snsInfoChangeObj?.currentValue?.isChecked),
                                    prevIdToFocus: '.checkbox__input'
                                }, { top: this.toastMessagePostion });
                            }
                        }
                        else {
                            this.disableAddAll = true;
                            // this.toasterService.show({
                            //     title: 'OK',
                            //     message: this.addAllProductsMessage,
                            //     type: ToasterType.Success,
                            //     calledBy: 'quantity-stepper-v3'
                            // }, {top: this.toastMessagePostion});
                        }
                        // Need to check if called by biaAddAllBtn, or else will result accessing undefined product var.
                        // Analytics already updated by addAllItemsMap
                        if (this.calledBy != 'biaAddAllBtn') {
                            if (window['AB']['DATALAYER']) {
                                const sellerId = this.product.sellerId ? this.product.sellerId : singleCartresponse['cartCategory'] === '1P_WINE' ? '22222222' : window['AB']['DATALAYER'].getBannerSellerId();
                                this._updateAnalyticsProductInfo(sellerId);
                                if (this.addItemToCartAnalytics) {
                                    window['AB']['DATALAYER'].addItemToCart();
                                    this.addItemToCartAnalytics = false;
                                }
                                else if (this.increaseQuantityAnalytics) {
                                    window['AB']['DATALAYER'].increaseItemQuantity();
                                    this.increaseQuantityAnalytics = false;
                                }
                                else if (this.decreaseQuantityAnalytics) {
                                    window['AB']['DATALAYER'].decreaseItemQuantity();
                                    this.decreaseQuantityAnalytics = false;
                                }
                            }
                        }
                        //<-- we dont need to update store id here, so commenting this for now -->
                        // if (isEdit) {
                        // @todo verify if this is needed cart and checkout
                        // this.cartV2Service.checkAndUpdateStoreId(singleCartresponse, this.sellerId);
                        // }
                    }
                }
            }
        }, err => {
            console.error('Error while calling Cart API: ' + err.message);
            if (this.isOnProductDetail && snsInfoChangeObj &&
                (snsInfoChangeObj?.currentValue?.isChecked !== snsInfoChangeObj?.previousValue?.isChecked)) {
                let modalDataConfig = {
                    modal: 'errorModal',
                    showModal: true,
                    prevIdToFocus: '',
                    errModalType: snsInfoChangeObj.currentValue.isChecked ? 'subscribe' : 'unsubscribe',
                    selectedFrequency: this.snsInfo.selectedFrequency
                };
                this._productSnsModalService.show(modalDataConfig);
            }
            this.showQtyUpdateBtn = false;
            this.loadingSpinner = false;
            this.isQuantityIncreased = false;
            if (!this.isBiaAddAll) {
                this.quantityMessage = this._getQuantityMessage(this.product['originalQuantity']);
            }
        });
    }
    /**
     * Change quantity message with new product quantity.
     *
     * @returns {string} New quantity message to be bind in quantity input's value.
     */
    _getQuantityMessage(quantity) {
        this.product.qty = this.product.maxPurchaseQty && quantity > this.product.maxPurchaseQty
            ? this.product.maxPurchaseQty : quantity > 0
            ? quantity : this.product.qty;
        if (this.calledBy === 'minicart') {
            if (this.product.maxPurchaseQty && this.product.qty >= this.product.maxPurchaseQty) {
                return this.isV2CarouselItem || this.isV2ProductItem ? this.product.qty : this.product.qty + ' max';
            }
            // README: set aria label for specify-quantity-counter
            this.quantityAriaLabelMessage = this.product.qty > 1
                ? this.product.qty + ' units of ' + this.product.name + '  in cart. Click to update'
                : this.product.qty + ' unit of ' + this.product.name + '  in cart. Click to update';
            this.adaCartUpdateMessage('Cart updated. ' + this.product.qty + ' in cart');
            return this.isV2CarouselItem || this.isV2ProductItem ? this.product.qty : this.product.qty + ' in Cart';
        }
        else {
            if (this.product.maxPurchaseQty && this.product.quantity >= this.product.maxPurchaseQty) {
                return this.isV2CarouselItem || this.isV2ProductItem ? this.product.quantity : this.product.quantity + ' max';
            }
            // README: set aria label for specify-quantity-counter
            this.quantityAriaLabelMessage =
                this.product.quantity > 1
                    ? this.product.quantity + ' units of ' + this.product.name + '  in cart. Click to update'
                    : this.product.quantity + ' unit of ' + this.product.name + '  in cart. Click to update';
            this.adaCartUpdateMessage('Cart updated. ' + this.product.qty + ' in cart');
            let message = this.isBIA ? '' : ' in Cart';
            return this.isV2CarouselItem || this.isV2ProductItem || this.componentInfo === 'sticky-pdp'
                ? this.product.quantity : this.product.quantity + message;
        }
    }
    /**
     * Gets desired product in cart quantity from Localstorage.
     *
     * @param {string} productBPN Product unique BPN.
     */
    _getQuantityInCart(productBPN) {
        try {
            const Cart = JSON.parse(localStorage.getItem(this.cartLSname));
            const qty = Cart.cartItems.find(item => item.id == productBPN).quantity;
            return (qty > 0) ? qty : 0;
        }
        catch (e) {
            return 0;
        }
    }
    /**
     * Check if user is registered and may add products in cart.
     */
    _isRegistered() {
        return (this._utilService.isTokenActive() && this._userInfoService.isAuthorized());
    }
    /**
     * Show sign in modal to unregistered users.
     */
    _showSignInModal(configObj) {
        const redirectPath = encodeURIComponent(window.location.href);
        window['SWY'].CONFIGSERVICE.setCookie('ECommRedirectURL', redirectPath, 0);
        if (configObj && configObj?.appName === 'weeklyAd') {
            const bannerDomainUrl = this._productUtilService.getBannerDomainUrl(this.configObj);
            const navPath = bannerDomainUrl + window['AB'].signInLinkPath;
            const analyticsIcmpid = window['AB'] && window['AB']['DATALAYER'] && window['AB']['DATALAYER'].trackWeeklyAdIcmpid && window['AB']['DATALAYER'].trackWeeklyAdIcmpid('sign-in-to-add', navPath) || '';
            window.location.assign(navPath + `${analyticsIcmpid}`);
        }
        else {
            window['AB']['COMMON'].showSignInModal_OTP(window.location.href);
        }
    }
    /**
     * Removes text from aria-live announcement.
     */
    _clearStatusAriaMessage() {
        this.statusAddAriaMessage = '';
    }
    /**
     * ADA: Sets focus inside quantity stepper with info about in cart quantity.
     */
    _setFocusInsideQty() {
        if (this.calledBy === 'minicart') {
            setTimeout(() => $('#qtyMiniCartInfo_' + this.product.itemId).focus(), 0);
        }
        else if (this.calledBy === 'minicart') {
            setTimeout(() => $('#qtyMiniCartInfo_' + this.product.id).focus(), 0);
        }
        else {
            if (!this.preventFocusOnQty) {
                setTimeout(() => $(this._elementRef.nativeElement).children().find("span#qtyInfo_" + this.product.id).focus(), 0);
            }
        }
    }
    setFocusInsideQtyControl() {
        setTimeout(() => {
            if (this.calledBy === 'minicart') {
                $('#qtyInfoControl_' + this.product.itemId).focus();
                $('#qtyInfoControl_' + this.product.itemId).select();
            }
            else {
                $('#qtyInfoControl_' + this.product.id).focus();
                $('#qtyInfoControl_' + this.product.id).select();
            }
        }, 150);
    }
    _removeProductV2() {
        this.cartV2Service.removeProduct(this.product, this.calledBy === 'minicart' ? this.product.itemId : this.product.id, this.product.sellerId, this.configObj?.programType ? this.configObj?.programType : this.configObj?.appName).subscribe((response) => {
            if (response) {
                if (this.configObj?.programType === '1P_SNS') {
                    this.callSNSSuccessDispatch();
                }
                else {
                    this.cartService.refreshCart(response);
                }
                const cartName = this.cartV2Service.getCartName(this.configObj?.programType, this.product.sellerId);
                let singleCartresponse = this.cartV2Service.fetchCartDetailsFromResponse(response, cartName);
                if (window['AB']['DATALAYER']) {
                    const sellerId = this.product.sellerId ? this.product.sellerId : singleCartresponse['cartCategory'] === '1P_WINE' || cartName === '1P_WINE' ? '22222222' : window['AB']['DATALAYER'].getBannerSellerId();
                    this._updateAnalyticsProductInfo(sellerId);
                    window['AB']['DATALAYER'].updateCartType(this.calledBy === 'minicart' ? 'mini_cart' : '');
                    window['AB']['DATALAYER'].updateCart(response, null, response['isWYSIWYGEnabled']);
                    if (this.removeItemFromCartAnalytics) {
                        window['AB']['DATALAYER'].removeItemFromCart();
                        this.removeItemFromCartAnalytics = false;
                    }
                }
                if (!this.isBiaAddAll) {
                    this._commonService.sendSponsoredProductClickEvent(this.product, 'quantityStepper', 'removeProduct');
                }
                singleCartresponse = this.cartV2Service.handleResponseForPendingOrder(singleCartresponse);
                this.loadingSpinner = false;
                // Add and Remove checkMark after 1 second
                this.checkMark = true;
                setTimeout(() => {
                    this.checkMark = false;
                    this.showQtyUpdateBtn = false;
                    this._setFocusInsideQty();
                    this._clearStatusAriaMessage();
                }, 1000);
                this.updateState = {
                    show: false,
                    button: 'Update'
                };
                this._setFocusInsideQty();
                // Emit new cart summary to minicart
                if (this.calledBy === 'minicart') {
                    this.changeMiniCartEmitter.emit(singleCartresponse['summary']);
                    this.updateUnavailableCountEmitter.emit(singleCartresponse['mfcUnavailableProductsCount']);
                }
                this.isWYSIWYGEnabled = singleCartresponse['isWYSIWYGEnabled'];
            }
        }, err => {
            console.error('Error while calling Cart API: ' + err.message);
            this.showQtyUpdateBtn = false;
            this.loadingSpinner = false;
            this.quantityMessage = this._getQuantityMessage(this.product['originalQuantity']);
        });
    }
    /**
     * Updates products to be added to cart when customer uses the buy it again
     * add all items to cart button
     **/
    updateBiaAddAllBtnContext() {
        this.allProductsToAdd = this.calcAddAllProducts(this.products);
        //README: Sets this.noOfProductsToAdd to original products length if all products have been added. Disables add all button while displaying
        //original products length to inform customer all items have been added to cart.
        this.noOfProductsToAdd = this.allProductsToAdd.length === 0 ? this.products.length : this.allProductsToAdd.length;
        this.disableAddAll = this.allProductsToAdd.length === 0 ? true : false;
    }
    //Returns array of objects. The objects containing itemId and qty
    addAllItemsMap() {
        console.warn('addAllItemsMap()');
        this.addAllProductsMessage = this.noOfProductsToAdd == 1 ? `1 item added to cart` : `${this.noOfProductsToAdd} items added to cart`;
        this.analyticsAddAllItems(this.allProductsToAdd);
        return this.allProductsToAdd.map(product => {
            return {
                itemId: product.id,
                qty: 1
            };
        });
    }
    //Returns array of all products to be added to cart after filtering for products already in cart
    calcAddAllProducts(products) {
        const cartObj = this.cartService._get();
        const cartItemsMap = cartObj['cartItems'] ? cartObj['cartItems'].map(cartItem => {
            return cartItem.itemId;
        }) : [];
        //check if the product has price > 0 & is not in cart already
        function shouldAddProduct(prod) {
            let isInCart = false;
            for (const cartItem in cartItemsMap) {
                if (cartItemsMap[cartItem] == prod.id) {
                    isInCart = true;
                }
            }
            return (prod.price > 0 && isInCart == false);
        }
        return products.filter(shouldAddProduct);
    }
    addAllItemsToCart(items) {
        console.warn('addAllItemsToCart()');
        this._cartAPICallV2(items);
    }
    /**
     * ADA message for announcing cart update
     *
     */
    adaCartUpdateMessage(message) {
        this.quantityAdaMessage = message;
        setTimeout(() => {
            this.quantityAdaMessage = '';
        }, 100);
    }
    updateLoadingMessage(qty) {
        this.stepperAnnouncement = `quantity content ${qty} loading`;
    }
    /**
     * Adds a product to cart
     *
     */
    addToCart() {
        if (this.isAuthorized) {
            const showMTOModalIfSessionValid = () => {
                if (this.product.isMtoProduct) {
                    if (window['AB']['COMMON'].checkPendingOrder()) {
                        const abSlotEditOrder = 'abSlotEditOrder';
                        const error = 'error';
                        if (localStorage.getItem(abSlotEditOrder)) {
                            if (this._commonService.preparationTimeExceedsPrebook(this.product, abSlotEditOrder)) {
                                this._displayMtoModal(error, '#mtoModalError', { show: true, backdrop: false });
                            }
                            else {
                                this.beforeIncreaseCart(this.crossSellEnabled);
                            }
                        }
                        else {
                            this._displayMtoModal(error, '#mtoModalError', { show: true, backdrop: false });
                        }
                    }
                    else {
                        const abSlot = 'abSlot';
                        if (localStorage.getItem(abSlot)) {
                            if (this._commonService.preparationTimeExceedsPrebook(this.product, abSlot)) {
                                this._displayMtoModal('popup', '#mtoModal', { show: true });
                            }
                            else {
                                this.beforeIncreaseCart(this.crossSellEnabled);
                            }
                        }
                        else {
                            this.beforeIncreaseCart(this.crossSellEnabled);
                        }
                    }
                }
                else {
                    this.beforeIncreaseCart(this.crossSellEnabled);
                }
            };
            this._commonService.validateSession(showMTOModalIfSessionValid);
        }
        else {
            this.beforeIncreaseCart(this.crossSellEnabled);
        }
    }
    /**
     * Analytics method for tracking link clicks on MTO modal
     *
     */
    analyticsMTOClicks(linkClicked) {
        if (window['AB'] && window['AB']['DATALAYER']) {
            window['AB']['DATALAYER'].setModalClickEvents(`mto-pickup|${linkClicked}`);
        }
    }
    /**
     * Triggers a separate analytics call for each of the products added to cart
     * @param items  - items added to cart in bulk
     */
    analyticsAddAllItems(items) {
        if (window['AB'] && window['AB']['DATALAYER']) {
            window['AB']['DATALAYER'].addAllBIAItemsToCart(items, 'qs-component', this.cartId, this.calledBy);
        }
    }
    /**
     * Reserve new time button handle for MTO modal
     *
     */
    reserveNewTime() {
        if (window['AB']['COMMON'].isLSCompatible()) {
            let abSlot = JSON.parse(localStorage.getItem('abSlot'));
            const slotId = abSlot?.slotId;
            const slotType = abSlot?.type;
            if (slotId) {
                const delRequest = this._deleteSlotRequest(slotId, slotType);
                const selectorModal = '#mtoModal';
                // README: Delete current prebooked slot
                this._http.delete(delRequest.url, { headers: new HttpHeaders(delRequest.headers), responseType: 'text' }).subscribe((data) => {
                    if (this._aemService.isLSCompatible()) {
                        localStorage.removeItem('abSlot');
                    }
                    // README: Resets reserve nav messsage after the slot is deleted
                    this._resetReserveNavText();
                    // README: Add item to cart
                    this.beforeIncreaseCart(this.crossSellEnabled, true);
                }, (err) => {
                    // README: Close MTO modal
                    $(selectorModal).modal('hide');
                });
            }
        }
    }
    /**
     * Redirect to prebook page
     */
    redirectToPrebookPage() {
        const prebookPageRedirect = `${document.location.origin}/erums/store/prebook`;
        window.location.href = prebookPageRedirect;
    }
    /**
     * Choose time later button handle for MTO modal
     *
     */
    chooseTimeLater() {
        if (window['AB']['COMMON'].isLSCompatible()) {
            let abSlot = JSON.parse(localStorage.getItem('abSlot'));
            const slotId = abSlot?.slotId;
            const slotType = abSlot?.type;
            if (slotId) {
                const delRequest = this._deleteSlotRequest(slotId, slotType);
                const selectorModal = '#mtoModal';
                // README: Delete current prebooked slot
                this._http.delete(delRequest.url, { headers: new HttpHeaders(delRequest.headers), responseType: 'text' }).subscribe((data) => {
                    if (window['AB'].COMMON.isLSCompatible()) {
                        localStorage.removeItem('abSlot');
                    }
                    // README: Resets reserve nav messsage after the slot is deleted
                    this._resetReserveNavText();
                    // README: Add item to cart
                    this.beforeIncreaseCart(this.crossSellEnabled, false);
                    // README: Close MTO modal
                    $(selectorModal).modal('hide');
                }, (err) => {
                    // README: Close MTO modal
                    $(selectorModal).modal('hide');
                });
            }
        }
    }
    /**
     * Constructs the request for prebook delete slot
     *
     */
    _deleteSlotRequest(slotId, slotType) {
        const origin = window.location.origin;
        const storeId = window['AB'].userInfo.branchId;
        const userChannel = this._userInfoService.getUserChannel() ? this._userInfoService.getUserChannel().toUpperCase() : '';
        let path = window['SWY'].CONFIGSERVICE.osdpConfig['osdp.slot.promise.service.endpoint'];
        let headers = window['AB'].ecommHttpOptionsOsdp;
        headers.clientId = 'CC';
        headers.storeId = storeId;
        // update path if mockinator is requested
        const wiremockAPIDetails = this.config[this.currentEnv].wiremockAPIDetails;
        // check if wiremock service is enabled
        if (wiremockAPIDetails?.allowWiremockService) {
            const mode = this._utilService.getParams('mode');
            // check mode coming from request parameter
            if (mode === 'record') {
                // prepend record base url to virtual shelf api endpoint
                path = `${wiremockAPIDetails?.recorderBaseUrl}${path}`;
            }
            else if (mode === 'playback') {
                // prepend playback base url to virtual shelf api endpoint
                path = `${wiremockAPIDetails?.playbackBaseUrl}${path}`;
            }
            // update subscription key with mockinator subscription key if mode is either playback or record
            headers['ocp-apim-subscription-key'] = (mode === 'record' || mode === 'playback') ? wiremockAPIDetails?.subscriptionKey : headers['ocp-apim-subscription-key'];
        }
        if (userChannel && (userChannel === 'DELIVERY' || userChannel === 'PICKUP')) {
            if (userChannel === 'PICKUP') {
                headers['serviceType'] = 'DUG';
            }
            else {
                headers['serviceType'] = userChannel;
            }
        }
        let slotTypeParameter = '';
        if (slotType === 'FLASH')
            slotTypeParameter = '?type=FLASH';
        return {
            url: `${origin}${path}/reserve/${storeId}/${slotId}${slotTypeParameter}`,
            headers: headers
        };
    }
    /**
     * Resets reserve nav text after the slot has been deleted
     */
    _resetReserveNavText() {
        if (window['AB'].userInfo.preferenceMode.toLowerCase() === 'dug') {
            const reserveNav = document.querySelector('.reserve-nav__text_pickup');
            if (reserveNav) {
                reserveNav.textContent = 'Reserve a pickup time';
            }
        }
        else if (window['AB'].userInfo.preferenceMode.toLowerCase() === 'delivery') {
            const reserveNav = document.querySelector('.reserve-nav__text_delivery');
            if (reserveNav) {
                reserveNav.textContent = 'Reserve a delivery time';
            }
        }
    }
    /**
     * Dispalys the MTO Modal
     *
     * @param modalType - can be popup or error modal
     *
     * @param modalId - id of the modal
     *
     * @param modalOptions - options for jQuery modal()
     *
     */
    _displayMtoModal(modalType, modalId, modalOptions) {
        this.mto[modalType].show = true;
        setTimeout(() => {
            $(modalId).modal(modalOptions);
            $(modalId).appendTo('.unified-footer');
            const qtyStepper = this;
            $(modalId).on('shown.bs.modal', function () {
                qtyStepper.mtoShowADA(modalType);
            });
            $(modalId).on('hidden.bs.modal', function () {
                qtyStepper.mto[modalType].show = false;
                $(modalId).remove();
                qtyStepper.mtoHideADA(modalType);
            });
            window['AB']?.DATALAYER?.setModalViewEvents('mto-pickup|view');
        }, 100);
    }
    /**
     * Sets ADA functionality when showing MTO modal
     *
     * @param modalType the type of the modal: popup or error
     */
    mtoShowADA(modalType) {
        const closeBtn = this.mto[modalType].closeBtn;
        const modalId = this.mto[modalType].modalId;
        const first = this.mto[modalType].firstFocusableElem;
        const last = this.mto[modalType].lastFocusableElem;
        $(closeBtn).focus();
        $('.root').children().children(':nth-child(1)').attr('aria-hidden', true);
        $('.root').children().children(':nth-child(2)').attr('aria-hidden', true);
        $('.unified-footer').siblings().attr('aria-hidden', true);
        $('.unified-footer').children().attr('aria-hidden', true);
        $(modalId).attr('aria-hidden', false);
        $(last).on('keydown keypress', function (e) {
            if ($('this:focus') && e.which === 9) {
                if (first === last) {
                    e.preventDefault();
                }
                else if (!e.shiftKey) {
                    $(first).focus();
                }
            }
        });
    }
    /**
     * Sets ADA functionality when hidding MTO modal
     *
     * @param modalType the type of the modal: popup or error
     */
    mtoHideADA(modalType) {
        const closeBtn = this.mto[modalType].closeBtn;
        const qtyStepper = this;
        $(closeBtn).focus();
        $('.root').children().children(':nth-child(1)').removeAttr('aria-hidden');
        $('.root').children().children(':nth-child(2)').removeAttr('aria-hidden');
        $('.unified-footer').siblings().removeAttr('aria-hidden');
        $('.unified-footer').children().removeAttr('aria-hidden');
        $(`#addButton_${qtyStepper.product.id}`).focus();
    }
    /**
     * Triggers MKP Add to cart Modal when user adding seller Product for first time
     * Checks cartId local storage to determine the cart seller cart activity
     * Replaces modal placeholders with order min and product price
     * **/
    showMkpAddToCartModal(sellerId, sellerName, productPrice, cartIdLs) {
        if (cartIdLs && cartIdLs[sellerId]) {
            return;
        }
        else {
            this.showDynamicFirstTimeCartModal(sellerId, sellerName, productPrice);
        }
    }
    /**
    * This function shows the first time cart modal authored version (static).
    */
    showStaticFirstTimeCartModal(cartId, cartIdLs) {
        const cartModalId = '#addToCartModal-' + this.configObj?.programType;
        if (cartIdLs && cartIdLs[cartId]) {
            return;
        }
        else {
            window['ErrorStateModalComp'].triggerEmptyStateModal(cartModalId, true);
            if (window['AB'] && window['AB'].DATALAYER) {
                window['AB'].DATALAYER.addedToSellerTypeModalTracking('wineshop');
            }
        }
    }
    /**
    * This function shows the first time cart modal api driven version (dynamic).
    */
    showDynamicFirstTimeCartModal(sellerId, sellerName, productPrice) {
        // generate add to cart modal based on program type
        const cartModalId = '#addToCartModal-' + this.configObj?.programType;
        const cartModal = $(cartModalId);
        // replace sellerId and sellerName in image url and alt text and set src and alt text
        const mkpLogo = $(cartModalId + ' .error-state-modal__logo img');
        const mkpLogoPlaceholder = mkpLogo.attr('data-image-placeholder');
        const mkpAltPlaceholder = mkpLogo.attr('data-alt-placeholder');
        mkpLogo.attr('src', mkpLogoPlaceholder?.replace('(sellerId)', sellerId));
        mkpLogo.attr('alt', mkpAltPlaceholder?.replace('(sellerName)', sellerName));
        // replace sellerName placeholder in modal title and set inner html
        const modalSellerCartTitle = $(cartModalId + ' .error-state-modal__title');
        const messagePlaceholder = modalSellerCartTitle.attr('data-message-placeholder');
        let modalTitleHtml = messagePlaceholder?.replace('(sellerName)', sellerName);
        // update element html with replaced value
        modalSellerCartTitle?.html(modalTitleHtml);
        cartModal.attr("aria-label", modalTitleHtml);
        // calculate if current product price is > order minimum and replace current price and order minimum placeholder
        const mkpOrderMinModalMessage = $(cartModalId + ' .error-state-modal__shipping-text');
        const noOrderMinElem = $(cartModalId + ' .error-state-modal__noOrderMin');
        const mkpOrderMinModalMessage_cp = $(cartModalId + ' .error-state-modal__shipping-text .error-state-modal__shipping-text__cp');
        // add to cart Minimum order price class
        const mkpOrderMinModalMessage_mo = $(cartModalId + ' .error-state-modal__shipping-text .error-state-modal__shipping-text__mo');
        // get mkpShipping local storage to get the shipping details
        const mkpSellerShippingInfo = JSON.parse(localStorage.getItem('mkpShipping'));
        // check if shipping info is available in local storage else return
        if (mkpSellerShippingInfo && mkpSellerShippingInfo['shippingInfo'][sellerId]) {
            const domesticShippingFreeThreshold = mkpSellerShippingInfo['shippingInfo'][sellerId].domesticShippingFreeThreshold;
            const shippingFee = mkpSellerShippingInfo['shippingInfo'][sellerId].shippingFee;
            const modalShippingText = $(cartModalId + ' .error-state-modal__text');
            const qualifyFreeShipping = $(cartModalId + ' .error-state-modal__qualifyFreeShipping');
            const domesticFreeShipping = $(cartModalId + ' .error-state-modal__domesticFreeShipping');
            /**
             * if domestic free shipping threshold > 0 and shipping fee > 0
             * Show free shipping message if threshold is > product price else fall back to min cart threshold
             * */
            if (domesticShippingFreeThreshold > 0 && shippingFee > 0) {
                const mkpOrderMinModalMessage_cp = $(cartModalId + ' .error-state-modal__domesticFreeShipping .error-state-modal__shipping-text__cp');
                if (domesticShippingFreeThreshold > productPrice) {
                    mkpOrderMinModalMessage_cp.html('$' + ((domesticShippingFreeThreshold - productPrice).toFixed(2)).toString());
                    domesticFreeShipping.removeClass('d-none');
                    mkpOrderMinModalMessage.addClass('d-none');
                    modalShippingText.removeClass('d-none');
                    qualifyFreeShipping.addClass('d-none');
                }
                else {
                    qualifyFreeShipping.removeClass('d-none');
                    domesticFreeShipping.addClass('d-none');
                    mkpOrderMinModalMessage.addClass('d-none');
                }
            }
            else {
                const orderMin = mkpSellerShippingInfo['shippingInfo'][sellerId].minCartThresholdValue;
                if (orderMin && orderMin > 0 && orderMin > productPrice) {
                    // calculate order min from min threshold and round off
                    mkpOrderMinModalMessage_cp.html('$' + ((orderMin - productPrice).toFixed(2)).toString());
                    // update order minimum value with actual value from MKP Shipping LS
                    mkpOrderMinModalMessage_mo.html('$' + orderMin.toString());
                    noOrderMinElem.addClass('d-none');
                    mkpOrderMinModalMessage.removeClass('d-none');
                    qualifyFreeShipping.addClass('d-none');
                    domesticFreeShipping.addClass('d-none');
                }
                else if (orderMin === 0) {
                    // if order minimum is 0 then show no order minimum element
                    mkpOrderMinModalMessage.addClass('d-none');
                    noOrderMinElem.removeClass('d-none');
                    qualifyFreeShipping.addClass('d-none');
                    domesticFreeShipping.addClass('d-none');
                }
                else {
                    // above conditions fails then hide order minum elements
                    mkpOrderMinModalMessage.addClass('d-none');
                    noOrderMinElem.addClass('d-none');
                }
            }
            // Shipping fee elements
            const shippingFeeElem = $(cartModalId + ' .error-state-modal__text__shipping');
            const freeShippingElem = $(cartModalId + ' .error-state-modal__freeShipping');
            // if shipping fee > 0 then update html with shipping fee else remove shipping html from DOM
            /**
             * Check if domestic free shipping flag is enabled and
             * if domestic free shipping is > 0 product price is less than threshold then show shipping fee
             * else hide
             * */
            if (shippingFee && shippingFee > 0 && (domesticShippingFreeThreshold > 0 && domesticShippingFreeThreshold > productPrice || domesticShippingFreeThreshold < 1)) {
                shippingFeeElem?.html('$' + shippingFee);
                freeShippingElem.addClass('d-none');
                modalShippingText.removeClass('d-none');
            }
            else if (shippingFee === 0) {
                modalShippingText.addClass('d-none');
                freeShippingElem.removeClass('d-none');
            }
            else {
                modalShippingText?.addClass('d-none');
                freeShippingElem?.addClass('d-none');
            }
            if ($('.main-wrapper').attr('data-custom-page-type') === 'mkp-cross-seller-page') {
                $(".modal-footer__action-btn__cart").html('Go to Seller');
                const goToSeller = $(cartModalId + ' .modal-footer__action-btn__cart');
                goToSeller.attr('seller-url', this._commonService.getSellerLandingPath(sellerId));
            }
            this.updateSrMsgs(cartModalId);
        }
        else {
            console.warn('mkpShipping local storage missing or current seller shipping info is not available');
        }
        window['ErrorStateModalComp'].triggerEmptyStateModal(cartModalId, true);
        if (window['AB'] && window['AB'].DATALAYER) {
            window['AB'].DATALAYER.addedToSellerTypeModalTracking('marketplace');
        }
    }
    // To make ADA read the message as a whole instead of span by span
    updateSrMsgs(cartModalId) {
        const minOrderShippingContent = $(cartModalId + ' .error-state-modal__shipping-text-content').text();
        const domesticFreeShippingContent = $(cartModalId + ' .error-state-modal__domesticFreeShipping-content').text();
        const qualifyFreeShippingContent = $(cartModalId + ' .error-state-modal__qualifyFreeShipping-content').text();
        const shippingTextContent = $(cartModalId + ' .error-state-modal__text-content').text();
        $(cartModalId + ' .error-state-modal__shipping-text-sr').text(minOrderShippingContent);
        $(cartModalId + ' .error-state-modal__domesticFreeShipping-sr').text(domesticFreeShippingContent);
        $(cartModalId + ' .error-state-modal__qualifyFreeShipping-sr').text(qualifyFreeShippingContent);
        $(cartModalId + ' .error-state-modal__text-sr').text(shippingTextContent);
    }
    /**
    * This function adds shown and hidden listeners to first time cart modal.
    */
    addFirstTimeCartModalListeners() {
        const $this = this;
        let cartModalId = '#addToCartModal-' + this.configObj?.programType;
        let closeButtonClass = ' .error-state-modal__header__modal-close';
        // after opening add to cart modal, set focus on close button
        $(cartModalId).on('shown.bs.modal', function () {
            setTimeout(() => {
                $(cartModalId + closeButtonClass).focus();
            }, 1000);
        });
        $(cartModalId).on('hidden.bs.modal', function () {
            setTimeout(() => {
                $this._setFocusInsideQty();
            }, 1000);
        });
    }
    onQscStepperClick() {
        if (window['AB']['COMMON'].getUserChannel() == 'instore') {
            window['rightDrawerComp'].closeDrawer();
            window['storeFulfillmentModal'].component.setModalDisplayData(2);
            return;
        }
        if (!this._isCheckboxChecked) {
            return;
        }
        this.isQuantityStepperExtended = true;
    }
    qscIncrease() {
        if (this.qscQuantity == this.product?.maxPurchaseQty) {
            return;
        }
        this.qscQuantity += 1;
        this.setLocalStorageQscQuantity(this.qscQuantity);
    }
    qscDecrease() {
        // Uncheck checkbox, make quantity-stepper disabled.
        if (this.qscQuantity == 1) {
            this.updateCheckboxEmitter.emit(false);
            return;
        }
        this.qscQuantity -= 1;
        this.setLocalStorageQscQuantity(this.qscQuantity);
    }
    onQscAmtClick() {
        if (!this.isQuantityStepperExtended) {
            return;
        }
        this.updateState.input = this.qscQuantity;
        this.updateState.show = true;
        this.statusAriaLive = 'polite';
        this.setFocusInsideQtyControl();
    }
    setLocalStorageQscQuantity(amount) {
        if (this.product.maxPurchaseQty && amount > this.product.maxPurchaseQty) {
            amount = this.product.maxPurchaseQty;
        }
        this._quickAddBasketService.setQuickAddBasketItemQuantity(this.product.id, amount);
    }
    /**
     * This function is called on cart api success when program type is 1P_SNS
    */
    callSNSSuccessDispatch() {
        const payloadData = {
            'data-bpn': this.product.id,
            'qty': this.product.quantity
        };
        this._commonService.dispatchSnsOneTimeEvent('productQtyUpdateSuccess', payloadData);
    }
    ngOnDestroy() {
        if (this.updateBiaAddAllSubscription) {
            this.updateBiaAddAllSubscription.unsubscribe();
        }
        if (this.subscriptions) {
            this.subscriptions.unsubscribe();
        }
    }
    /**
     * This method return MTO Product Preparation Popup Text
     * @returns String mtoPopupText
     */
    getMtoPopupText() {
        return `${this.product.mtoDisplyableTime}`;
    }
    /**
     * Navigate Domain Banner to open 2 modal store selection
     */
    navigateBannerDomainToOpenStoreSlctChange() {
        const bannerDomainUrl = this._productUtilService.getBannerDomainUrl(this.configObj);
        const generatedTargetUrl = bannerDomainUrl + "/home.html?action=changeStore&goto=" + encodeURIComponent(window.location.href) + "&modaltype=2";
        window.location.href = generatedTargetUrl;
    }
    static { this.ɵfac = function QuantityStepperALV1Component_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || QuantityStepperALV1Component)(i0.ɵɵdirectiveInject(i0.NgZone), i0.ɵɵdirectiveInject(i1.ABTestService), i0.ɵɵdirectiveInject(i1.CommonService), i0.ɵɵdirectiveInject(i1.UserInfoService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i2.ToasterALV1Service), i0.ɵɵdirectiveInject(i1.CartService), i0.ɵɵdirectiveInject(i3.HttpClient), i0.ɵɵdirectiveInject(i1.UtilService), i0.ɵɵdirectiveInject(i1.CartV2Service), i0.ɵɵdirectiveInject(i1.ProductUtilService), i0.ɵɵdirectiveInject(i1.AemService), i0.ɵɵdirectiveInject(ProductSNSModalALService), i0.ɵɵdirectiveInject(i1.QuickAddBasketV1Service)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: QuantityStepperALV1Component, selectors: [["quantity-stepper-al-v1"]], hostBindings: function QuantityStepperALV1Component_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("click", function QuantityStepperALV1Component_click_HostBindingHandler($event) { return ctx.onQscClick($event); }, false, i0.ɵɵresolveWindow);
        } }, inputs: { product: "product", products: "products", calledBy: "calledBy", componentInfo: "componentInfo", carouselTitle: "carouselTitle", carouselId: "carouselId", mainIngredient: "mainIngredient", isRecommended: "isRecommended", crossSellEnabled: "crossSellEnabled", crossSellType: "crossSellType", isAnyProductHasAddlInfo: "isAnyProductHasAddlInfo", isBIA: "isBIA", pathwaysWidget: "pathwaysWidget", isMarketPlaceEnabled: "isMarketPlaceEnabled", isWineShopEnabled: "isWineShopEnabled", isQscV2: "isQscV2", isCheckboxChecked: "isCheckboxChecked", snsInfo: "snsInfo", isMkpSellerTagDisabled: "isMkpSellerTagDisabled", configObj: "configObj" }, outputs: { onQtyUpdate: "onQtyUpdate", removePastPurchasesEmitter: "removePastPurchasesEmitter", removeMiniCartEmitter: "removeMiniCartEmitter", changeMiniCartEmitter: "changeMiniCartEmitter", updateUnavailableCountEmitter: "updateUnavailableCountEmitter", updateCheckboxEmitter: "updateCheckboxEmitter", updateQscQtyEmitter: "updateQscQtyEmitter" }, features: [i0.ɵɵNgOnChangesFeature], decls: 5, vars: 3, consts: [["qscV2", ""], ["class", "quantity-stepper-v3", 3, "ngClass", 4, "ngIf"], [4, "ngIf"], ["class", "btn product-btn__qty-step justify-content-center", "role", "group", "tabindex", "0", "data-qa", "addbutton", 3, "id", "ngClass", "click", "keydown.enter", 4, "ngIf"], ["class", "btn product-btn__update", 4, "ngIf"], ["role", "group", "tabindex", "0", "data-qa", "addbutton", 1, "btn", "product-btn__qty-step", "justify-content-center", 3, "click", "keydown.enter", "id", "ngClass"], ["class", "product-btn__qty-step__decrease", "role", "button", "tabindex", "0", "data-qa", "prdctdcrmntr", 3, "disabled", "id", "click", 4, "ngIf"], ["role", "button", "tabindex", "0", "data-qa", "qty-stppr-qtymsg", 1, "product-btn__qty-step__amt", 3, "click", "keydown.enter", "id"], ["class", "product-btn__qty-step__increase", "role", "button", "tabindex", "0", "data-qa", "prdctincrmntr", 3, "ngClass", "id", "click", 4, "ngIf"], ["role", "button", "tabindex", "0", "data-qa", "prdctdcrmntr", 1, "product-btn__qty-step__decrease", 3, "click", "disabled", "id"], ["aria-hidden", "true", 1, "svg-qty-stepper-decrease", "product-btn__qty-step__decrease--icon"], ["role", "button", "tabindex", "0", "data-qa", "prdctincrmntr", 1, "product-btn__qty-step__increase", 3, "click", "ngClass", "id"], ["aria-hidden", "true", 1, "svg-qty-stepper-increase", "product-btn__qty-step__increase--icon"], [1, "btn", "product-btn__update"], ["onclick", "this.select()", "aria-label", "Cart Quantity", "type", "number", "min", "0", "step", "1", "data-qa", "prd-qty-stppr-qtybox", 1, "product-btn__update__input-box", 3, "keydown.enter", "keydown", "keyup", "ngModelChange", "id", "ngModel", "max"], ["data-qa", "prdqtyupdate", "tabindex", "0", 1, "btn", "product-btn__update__input-btn", 3, "click", "disabled"], [1, "quantity-stepper-v3", 3, "ngClass"], [1, "quantity-stepper-container"], [4, "ngIf", "ngIfElse"], [3, "keyup", "ngClass"], ["aria-live", "assertive", "aria-atomic", "true", 1, "sr-only"], ["class", "btn product-btn__add", "role", "button", "tabindex", "0", "data-qa", "addbutton", 3, "id", "ngClass", "click", 4, "ngIf"], ["role", "group", 3, "ngClass", 4, "ngIf"], ["role", "button", "tabindex", "0", "data-qa", "addbutton", 1, "btn", "product-btn__add", 3, "click", "id", "ngClass"], ["role", "group", 3, "ngClass"], ["role", "button", "tabindex", "0", "data-qa", "prdctdcrmntr", 1, "product-btn__qty-step__decrease", 3, "click", "ngClass", "disabled", "id"], [1, "sr-only"], ["role", "button", "tabindex", "0", "data-qa", "qty-stppr-qtymsg", 1, "product-btn__qty-step__amt", 3, "click", "id"], ["onclick", "this.select()", "aria-label", "Cart Quantity", "type", "number", "min", "1", "step", "1", "data-qa", "prd-qty-stppr-qtybox", 1, "product-btn__update__input-box", 3, "keydown.enter", "keydown", "keyup", "ngModelChange", "id", "ngModel", "max"], ["data-qa", "prdqtyupdate", 1, "btn", "product-btn__update__input-btn", 3, "click", "disabled"], ["id", "mtoModal", "tabindex", "-1", "role", "dialog", "aria-labelledby", "mtoModalLabel", "aria-hidden", "true"], ["role", "document", 1, "mto-popup__dialog", "modal-dialog"], [1, "mto-popup__content", "modal-content"], ["data-qa", "mto", 1, "mto-popup__body", "modal-body"], ["type", "button", "data-dismiss", "modal", "aria-label", "Close", "data-qa", "mto-close", 1, "mto-popup__close-btn", "close"], ["xmlns", "http://www.w3.org/2000/svg", "width", "20", "height", "20", "fill", "none", "viewBox", "0 0 20 20"], ["fill", "#4B4B4B", "fill-rule", "evenodd", "d", "M18.493 2.623L17.3 1.46 9.872 9.074 2.627 1.467 1.42 2.617l7.287 7.65-7.28 7.462 1.193 1.164 7.237-7.418 7.058 7.411 1.207-1.15-7.1-7.455 7.471-7.658z", "clip-rule", "evenodd"], ["id", "mtoModalLabel", "data-qa", "mto-ttl", 1, "mto-popup__title"], ["data-qa", "mto-txt", 1, "mto-popup__text"], ["type", "button", "data-qa", "mto-rsrv-btn", 1, "mto-popup__reserve-btn", "btn", "btn-default", 3, "click"], ["type", "button", "data-qa", "mto-chs-tm-btn", 1, "mto-popup__choose-time-btn", "btn", "btn-default", "btn-secondary", 3, "click"], ["type", "button", "data-dismiss", "modal", "data-qa", "mto-dnt-add-btn", 1, "mto-popup__dont-add-btn", "btn", "btn-link", 3, "click"], ["id", "mtoModalError", "tabindex", "-1", "aria-label", "Item can't be added to cart", "aria-hidden", "true", "role", "dialog"], ["role", "document", 1, "mto-popup-error__dialog", "modal-dialog"], [1, "mto-popup-error__content", "modal-content"], ["data-qa", "mto-err", 1, "mto-popup-error__body", "modal-body"], [1, "mto-popup-error__text-container"], ["data-dismiss", "modal", "aria-label", "Close", "data-qa", "mto-err-close", 1, "mto-popup-error__close-btn", "close"], ["xmlns", "http://www.w3.org/2000/svg", "fill", "none", "viewBox", "0 0 20 20", 1, "mto-popup-error__close-svg"], [1, "mto-popup-error__paragraphs"], ["data-qa", "mto-err-ttl", 1, "mto-popup-error__title"], ["aria-hidden", "true", 1, "mto-popup-error__icon-exclamation"], ["xmlns", "http://www.w3.org/2000/svg", "width", "17", "height", "17", "fill", "#DD1E25", "viewBox", "0 0 16 16", 1, "bi", "bi-exclamation-circle-fill"], ["d", "M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z"], ["data-qa", "mto-err-txt", 1, "mto-popup-error__text"]], template: function QuantityStepperALV1Component_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, QuantityStepperALV1Component_ng_template_0_Template, 2, 2, "ng-template", null, 0, i0.ɵɵtemplateRefExtractor)(2, QuantityStepperALV1Component_div_2_Template, 3, 7, "div", 1)(3, QuantityStepperALV1Component_ng_container_3_Template, 19, 8, "ng-container", 2)(4, QuantityStepperALV1Component_ng_container_4_Template, 17, 5, "ng-container", 2);
        } if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngIf", ctx.calledBy != "minicart" && !ctx.isBiaAddAll);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.mto.popup.show);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.mto.error.show);
        } }, dependencies: [i5.NgClass, i5.NgIf, i2$1.DefaultValueAccessor, i2$1.NumberValueAccessor, i2$1.NgControlStatus, i2$1.MinValidator, i2$1.MaxValidator, i2$1.NgModel, i5.TitleCasePipe] }); }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: QuantityStepperALV1Component, factory: QuantityStepperALV1Component.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(QuantityStepperALV1Component, [{
        type: Component,
        args: [{ selector: 'quantity-stepper-al-v1', template: "<!-- Quantity Stepper for qscV2. -->\n<ng-template #qscV2>\n    <!-- Stepper Buttons -->\n    <div *ngIf=\"!updateState.show && this.calledBy != 'editpastpurchases' && product.price > 0\"\n        id=\"addButton_{{product.id}}\" class=\"btn product-btn__qty-step justify-content-center\"\n        [ngClass]=\"{'product-btn--signin': !isAuthorized}\" role=\"group\" (click)=\"onQscStepperClick()\" (keydown.enter)=\"onQscStepperClick()\"\n        attr.data-qty-id=\"pc{{product.id}}Inpt\" tabindex=\"0\"\n        [attr.aria-label]=\"isAuthorized ? ADD + ' 1 unit of ' + getProductFullName() : SIGNIN + ' 1 unit of ' + getProductFullName()\"\n        data-qa=\"addbutton\">\n        <!-- Decrease Button -->\n        <button *ngIf=\"isQuantityStepperExtended\" class=\"product-btn__qty-step__decrease\"\n            [disabled]=\"showQtyUpdateBtn || updateState.input > product.inventoryQty\" id=\"dec_qtyInfo_{{product.id}}\"\n            (click)=\"qscDecrease()\" role=\"button\" tabindex=\"0\" attr.aria-label=\"Decrease Quantity {{getProductFullName()}}\"\n            data-qa=\"prdctdcrmntr\">\n            <span aria-hidden=\"true\" class=\"svg-qty-stepper-decrease product-btn__qty-step__decrease--icon\"></span>\n        </button>\n        <span class=\"product-btn__qty-step__amt\" id=\"qtyInfo_{{product.id}}\" role=\"button\" (click) = \"onQscAmtClick()\" (keydown.enter) = \"onQscAmtClick()\"\n            attr.aria-label=\"{{quantityAriaLabelMessage}}\" tabindex=\"0\" data-qa=\"qty-stppr-qtymsg\"> {{ qscQuantity }} </span>\n        <!-- Increase Button -->\n        <button *ngIf=\"isQuantityStepperExtended\" class=\"product-btn__qty-step__increase\"\n            [ngClass]=\"{'product-btn__qty-step__increase': true, 'product-btn__qty-step__increase--max-amt qsc-step__increase--max-amt':qscQuantity >= product.inventoryQty || qscQuantity >= product.maxPurchaseQty }\"\n            id=\"inc_qtyInfo_{{product.id}}\" (click)=\"qscIncrease()\" role=\"button\" tabindex=\"0\"\n            attr.aria-label=\"Increase Quantity {{getProductFullName()}}\"\n            attr.aria-disabled=\"{{product.quantity >= product.inventoryQty || product.quantity >= product.maxPurchaseQty ? 'true' : 'false' }}\"\n            data-qa=\"prdctincrmntr\">\n            <span aria-hidden=\"true\" class=\"svg-qty-stepper-increase product-btn__qty-step__increase--icon\"></span>\n        </button>\n    </div>\n    <!-- Update Button -->\n    <div *ngIf=\"updateState.show\" class=\"btn product-btn__update\">\n        <!-- Input Box -->\n        <input onclick=\"this.select()\" class=\"product-btn__update__input-box\" id=\"qtyInfoControl_{{product.id}}\"\n            aria-label=\"Cart Quantity\" attr.aria-describedby=\"{{carouselId}}pg{{product.id}}\"\n            (keydown.enter)=\"qscEnterTabKeyDown()\" (keydown)=\"inputKeydown($event)\" (keyup)=\"inputKeyup($event)\"\n            [(ngModel)]=\"updateState.input\" type=\"number\" min=\"0\" max=\"{{product.maxPurchaseQty}}\" step=\"1\"\n            data-qa=\"prd-qty-stppr-qtybox\" />\n\n        <!-- Update Btn -->\n        <button class=\"btn product-btn__update__input-btn\"\n            [disabled]=\"showQtyUpdateBtn || updateState.input > product.inventoryQty\" (click)=\"qscUpdateAmt()\"\n            attr.aria-describedby=\"{{carouselId}}pg{{product.id}}\" data-qa=\"prdqtyupdate\" tabindex=\"0\">\n            {{updateState.button}}\n        </button>\n    </div>\n</ng-template>\n\n<div class=\"quantity-stepper-v3\" [ngClass]=\"{'qsc-step-default' : isQscV2, 'qsc-step' : isQuantityStepperExtended && isQscV2, 'qsc-step-disabled' : !_isCheckboxChecked && isQscV2}\" *ngIf=\"this.calledBy != 'minicart' && !isBiaAddAll\">\n    <div class=\"quantity-stepper-container\">\n       <ng-container *ngIf=\"!isQscV2; else qscV2\">\n            <div [ngClass]=\"{\n                'product-btn': true,\n                'product-btn--with-addl-info': (!isMarketPlaceEnabled && isAnyProductHasAddlInfo) && !isLightWeightProduct,\n                'product-btn--without-ar': !isAnyProductHasAddlInfo  && !isLightWeightProduct,\n                'full-loading': calledBy != 'snsCheckoutFlowModal' && (product.quantity == 0 || updateState.show),\n                'remove-loading': this.calledBy == 'editpastpurchases',\n                'add-product-checkmark': checkMark,\n                'product-btn--light': isLightWeightProduct\n            }\"\n             (keyup)=\"qtyStepperKeyup($event)\">\n                <span aria-live=\"assertive\" aria-atomic=\"true\" class=\"sr-only\">{{stepperAnnouncement}}</span>\n                <!-- Add Button -->\n                <div *ngIf=\" calledBy != 'snsCheckoutFlowModal' && (product.quantity == null || (product.quantity == 0) && !updateState.show && this.calledBy != 'editpastpurchases' && product.price > 0) \"\n                    id=\"addButton_{{product.id}}\" class=\"btn product-btn__add\" [ngClass]=\"{'product-btn--signin': !isAuthorized,  'd-flex align-items-center justify-content-center': isLightWeightProduct}\"\n                        role=\"button\" (click)=\"addToCart()\"\n                    attr.data-qty-id=\"pc{{product.id}}Inpt\" tabindex=\"0\"\n                        [attr.aria-label]=\"isAuthorized ? ((isOnProductDetail && changeLabel) ? changeLabel : ADD) + ' 1 unit of ' + getProductFullName() : SIGNIN + ' 1 unit of ' + getProductFullName()\"\n                    data-qa=\"addbutton\">\n                        {{ isAuthorized ? ((isOnProductDetail && changeLabel) ? changeLabel : ADD):  isLightWeightProduct ? SIGNIN_LIGHT : SIGNIN }}\n                </div>\n\n                <!-- Stepper Buttons -->\n                <div *ngIf=\"calledBy == 'snsCheckoutFlowModal' || (product.quantity > 0 && !updateState.show && this.calledBy != 'editpastpurchases')\"\n                    [ngClass]=\"{'btn':true, 'product-btn__qty-step': true, 'product-btn__qty-step--loading':loadingSpinner}\"\n                    role=\"group\" attr.aria-describedby=\"{{carouselId}}pg{{product.id}}\">\n\n                    <!-- Decrease Button -->\n                    <button class=\"product-btn__qty-step__decrease\"\n                                [ngClass]=\"{'product-btn__qty-step__decrease--min-amt': calledBy === 'snsCheckoutFlowModal' && qscQuantity <= 1}\"\n                            [disabled]=\"(showQtyUpdateBtn || updateState.input > product.inventoryQty && calledBy !== 'snsCheckoutFlowModal') || (calledBy === 'snsCheckoutFlowModal' && qscQuantity <= 1)\"\n                        id=\"dec_qtyInfo_{{product.id}}\" (click)=\"decreaseCart()\" role=\"button\" tabindex=\"0\"\n                        attr.aria-label=\"Decrease Quantity {{getProductFullName()}}\"\n                        data-qa=\"prdctdcrmntr\">\n                            <span aria-hidden=\"true\" class=\"svg-qty-stepper-decrease product-btn__qty-step__decrease--icon\"></span>\n                    </button>\n                    <!-- Current Quantity info -->\n                    <span class=\"sr-only\"></span>\n                    <span class=\"product-btn__qty-step__amt\"\n                            id=\"qtyInfo_{{product.id}}\" (click)=\"calledBy != 'snsCheckoutFlowModal' && showUpdate()\" role=\"button\"\n                        attr.aria-label=\"{{quantityAriaLabelMessage}}\" tabindex=\"0\"\n                        data-qa=\"qty-stppr-qtymsg\">{{quantityMessage}}</span>\n                    <!-- Increase Button -->\n                        <button class=\"product-btn__qty-step__increase\" [ngClass]=\"{'product-btn__qty-step__increase': true, 'product-btn__qty-step__increase--max-amt':product.quantity >= product.inventoryQty || (product.quantity >= product.maxPurchaseQty && calledBy !== 'snsCheckoutFlowModal') || (calledBy === 'snsCheckoutFlowModal' && qscQuantity >= product.maxPurchaseQty)}\"\n                        id=\"inc_qtyInfo_{{product.id}}\" (click)=\"beforeIncreaseCart(false)\" role=\"button\" tabindex=\"0\"\n                        attr.aria-label=\"Increase Quantity {{getProductFullName()}}\" attr.aria-disabled=\"{{product.quantity >= product.inventoryQty || product.quantity >= product.maxPurchaseQty ? 'true' : 'false' }}\"\n                        data-qa=\"prdctincrmntr\">\n                        <span aria-hidden=\"true\" class=\"svg-qty-stepper-increase product-btn__qty-step__increase--icon\"></span>\n                    </button>\n                </div>\n\n                <!-- Update Button -->\n                <div *ngIf=\"updateState.show && calledBy != 'snsCheckoutFlowModal'\" class=\"btn product-btn__update\">\n                    <!-- Input Box -->\n                    <input onclick=\"this.select()\" class=\"product-btn__update__input-box\" id=\"qtyInfoControl_{{product.id}}\" aria-label=\"Cart Quantity\"\n                            attr.aria-describedby=\"{{carouselId}}pg{{product.id}}\" (keydown.enter)=\"enterTabKeyDown($event)\"\n                            (keydown)=\"inputKeydown($event)\" (keyup)=\"inputKeyup($event)\" [(ngModel)]=\"updateState.input\" type=\"number\" min=\"1\"\n                            max=\"{{product.maxPurchaseQty}}\" step=\"1\" data-qa=\"prd-qty-stppr-qtybox\"/>\n                        \n                    <!-- Update Btn -->\n                    <button class=\"btn product-btn__update__input-btn\" [disabled]=\"showQtyUpdateBtn || updateState.input > product.inventoryQty\" \n                                (click)=\"updateCart()\" attr.aria-describedby=\"{{carouselId}}pg{{product.id}}\" data-qa=\"prdqtyupdate\">\n                            {{updateState.button}}\n                    </button>\n                </div>\n        </div>\n        </ng-container>\n    </div>\n</div>\n\n<!-- MTO Pop up -->\n<ng-container *ngIf=\"mto.popup.show\">\n    <div class=\"mto-popup p-{{product.id}} modal fade\" id=\"mtoModal\" tabindex=\"-1\" role=\"dialog\"\n        aria-labelledby=\"mtoModalLabel\" aria-hidden=\"true\">\n        <div class=\"mto-popup__dialog modal-dialog\" role=\"document\">\n            <div class=\"mto-popup__content modal-content\">\n                <div class=\"mto-popup__body modal-body\" data-qa=\"mto\">\n                    <button class=\"mto-popup__close-btn close\" type=\"button\" data-dismiss=\"modal\" aria-label=\"Close\" data-qa=\"mto-close\">\n                        <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" fill=\"none\" viewBox=\"0 0 20 20\">\n                            <path fill=\"#4B4B4B\" fill-rule=\"evenodd\"\n                                d=\"M18.493 2.623L17.3 1.46 9.872 9.074 2.627 1.467 1.42 2.617l7.287 7.65-7.28 7.462 1.193 1.164 7.237-7.418 7.058 7.411 1.207-1.15-7.1-7.455 7.471-7.658z\"\n                                clip-rule=\"evenodd\" />\n                        </svg>\n                    </button>\n                    <p class=\"mto-popup__title\" id=\"mtoModalLabel\" data-qa=\"mto-ttl\">{{ reservedTimeIntent | titlecase }} time will change</p>\n                    <p class=\"mto-popup__text\" data-qa=\"mto-txt\">This item requires {{ getMtoPopupText() }} to prepare. Please\n                        select a new time for {{ reservedTimeIntent }}</p>\n                    <button type=\"button\" class=\"mto-popup__reserve-btn btn btn-default\"\n                        (click)=\"reserveNewTime();analyticsMTOClicks('reserve-new-time')\" data-qa=\"mto-rsrv-btn\">Reserve new time</button>\n                    <button type=\"button\" class=\"mto-popup__choose-time-btn btn btn-default btn-secondary\"\n                        (click)=\"chooseTimeLater();analyticsMTOClicks('choose-time-later')\" data-qa=\"mto-chs-tm-btn\">Choose time later</button>\n                    <button type=\"button\" class=\"mto-popup__dont-add-btn btn btn-link\" data-dismiss=\"modal\"\n                        (click)=\"analyticsMTOClicks('dont-add-item')\" data-qa=\"mto-dnt-add-btn\">Don't add item</button>\n                </div>\n            </div>\n        </div>\n    </div>\n</ng-container>\n\n<!-- MTO Error Modal -->\n<ng-container *ngIf=\"mto.error.show\">\n    <div class=\"mto-popup-error p-{{product.id}} modal fade\" id=\"mtoModalError\" tabindex=\"-1\" aria-label=\"Item can't be added to cart\" aria-hidden=\"true\" role=\"dialog\">\n        <div class=\"mto-popup-error__dialog modal-dialog\" role=\"document\">\n            <div class=\"mto-popup-error__content modal-content\">\n                <div class=\"mto-popup-error__body modal-body\" data-qa=\"mto-err\">\n                    <div class=\"mto-popup-error__text-container\">\n                        <button class=\"mto-popup-error__close-btn close\" data-dismiss=\"modal\" aria-label=\"Close\" data-qa=\"mto-err-close\">\n                            <svg xmlns=\"http://www.w3.org/2000/svg\" class=\"mto-popup-error__close-svg\" fill=\"none\" viewBox=\"0 0 20 20\">\n                                <path fill=\"#4B4B4B\" fill-rule=\"evenodd\" d=\"M18.493 2.623L17.3 1.46 9.872 9.074 2.627 1.467 1.42 2.617l7.287 7.65-7.28 7.462 1.193 1.164 7.237-7.418 7.058 7.411 1.207-1.15-7.1-7.455 7.471-7.658z\" clip-rule=\"evenodd\" />\n                            </svg>\n                        </button>\n                        <div class=\"mto-popup-error__paragraphs\">\n                            <p class=\"mto-popup-error__title\" data-qa=\"mto-err-ttl\">\n                                <span class=\"mto-popup-error__icon-exclamation\" aria-hidden=\"true\">\n                                    <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"17\" height=\"17\" fill=\"#DD1E25\"\n                                        class=\"bi bi-exclamation-circle-fill\" viewBox=\"0 0 16 16\">\n                                        <path\n                                            d=\"M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zM8 4a.905.905 0 0 0-.9.995l.35 3.507a.552.552 0 0 0 1.1 0l.35-3.507A.905.905 0 0 0 8 4zm.002 6a1 1 0 1 0 0 2 1 1 0 0 0 0-2z\">\n                                        </path>\n                                    </svg>\n                                </span>\n                                Item can't be added to cart\n                            </p>\n                            <p class=\"mto-popup-error__text\" data-qa=\"mto-err-txt\">Made to order items require {{ getMtoPopupText() }} to prepare and won\u2019t be ready in time for {{ reservedTimeIntent }}.</p>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</ng-container>\n" }]
    }, {
        type: Injectable
    }], () => [{ type: i0.NgZone }, { type: i1.ABTestService }, { type: i1.CommonService }, { type: i1.UserInfoService }, { type: i0.ElementRef }, { type: i2.ToasterALV1Service }, { type: i1.CartService }, { type: i3.HttpClient }, { type: i1.UtilService }, { type: i1.CartV2Service }, { type: i1.ProductUtilService }, { type: i1.AemService }, { type: ProductSNSModalALService }, { type: i1.QuickAddBasketV1Service }], { onQscClick: [{
            type: HostListener,
            args: ['window:click', ['$event']]
        }], product: [{
            type: Input
        }], products: [{
            type: Input
        }], calledBy: [{
            type: Input
        }], componentInfo: [{
            type: Input
        }], carouselTitle: [{
            type: Input
        }], carouselId: [{
            type: Input
        }], mainIngredient: [{
            type: Input
        }], isRecommended: [{
            type: Input
        }], crossSellEnabled: [{
            type: Input
        }], crossSellType: [{
            type: Input
        }], isAnyProductHasAddlInfo: [{
            type: Input
        }], isBIA: [{
            type: Input
        }], pathwaysWidget: [{
            type: Input
        }], isMarketPlaceEnabled: [{
            type: Input
        }], isWineShopEnabled: [{
            type: Input
        }], isQscV2: [{
            type: Input
        }], isCheckboxChecked: [{
            type: Input
        }], snsInfo: [{
            type: Input
        }], isMkpSellerTagDisabled: [{
            type: Input
        }], configObj: [{
            type: Input
        }], onQtyUpdate: [{
            type: Output
        }], removePastPurchasesEmitter: [{
            type: Output
        }], removeMiniCartEmitter: [{
            type: Output
        }], changeMiniCartEmitter: [{
            type: Output
        }], updateUnavailableCountEmitter: [{
            type: Output
        }], updateCheckboxEmitter: [{
            type: Output
        }], updateQscQtyEmitter: [{
            type: Output
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(QuantityStepperALV1Component, { className: "QuantityStepperALV1Component", filePath: "components/quantity-stepper-al-v1/quantity-stepper-al-v1.component.ts", lineNumber: 33 }); })();

const _c0 = ["decreaseBtn"];
const _c1 = ["spinnerBlock"];
const _c2 = ["addBtn"];
const _c3 = ["qtyInfoBtn"];
const _c4 = a0 => ({ "btn-stppr-disabled": a0 });
const _c5 = a0 => ({ "svg-btn-stppr-increase--disabled": a0 });
const _c6 = a0 => ({ "svg-btn-stppr-decrease--disabled": a0 });
const _c7 = a0 => ({ "svg-btn-stppr-right-arrow--disabled": a0 });
const _c8 = (a0, a1, a2) => ({ "pc--carousel-wt-dropdown__menu": a0, "pc--carousel-wt-dropdown__menu--c": a1, "d-block": a2 });
const _c9 = (a0, a1) => ({ "pc--carousel-wt-dropdown__menu__container": a0, "pc--carousel-wt-dropdown__menu__container--c": a1 });
const _c10 = (a0, a1, a2) => ({ "pc--carousel-wt-dropdown__menu__container__item": a0, "wt-dropdown__menu__container__item-remove--disabled": a1, "pc--carousel-wt-dropdown__menu__container__item--c": a2 });
const _c11 = (a0, a1) => ({ "pc--carousel-wt-dropdown__menu__container__item": a0, "pc--carousel-wt-dropdown__menu__container__item--c": a1 });
function QuantityStepperALV2Component_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 5);
    i0.ɵɵlistener("click", function QuantityStepperALV2Component_ng_container_0_Template_button_click_1_listener($event) { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.beforeCartAction("increase", $event)); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵattributeInterpolate1("data-qty-id", "pc", ctx_r1.product.id, "Inpt");
    i0.ɵɵpropertyInterpolate1("id", "addButton_", ctx_r1.product.id, "");
    i0.ɵɵattribute("aria-label", ctx_r1.SIGNIN + (ctx_r1.isLBProduct ? " weight of " : " 1 unit of ") + ctx_r1.getProductFullName());
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.SIGNIN);
} }
function QuantityStepperALV2Component_ng_container_1_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 6, 0);
    i0.ɵɵlistener("click", function QuantityStepperALV2Component_ng_container_1_ng_container_1_ng_container_1_Template_button_click_1_listener($event) { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.beforeCartAction("increase", $event)); });
    i0.ɵɵelement(3, "span", 7);
    i0.ɵɵelementStart(4, "span", 8);
    i0.ɵɵtext(5);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵattributeInterpolate1("data-qty-id", "pc", ctx_r1.product.id, "Inpt");
    i0.ɵɵpropertyInterpolate1("id", "addButton_", ctx_r1.product.id, "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c4, ctx_r1.loadingSpinner));
    i0.ɵɵattribute("aria-label", ctx_r1.ADD + " 1 unit of " + ctx_r1.getProductFullName())("aria-disabled", ctx_r1.loadingSpinner);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r1.ADD);
} }
function QuantityStepperALV2Component_ng_container_1_ng_container_1_ng_container_2_div_1_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 21);
} }
function QuantityStepperALV2Component_ng_container_1_ng_container_1_ng_container_2_div_1_span_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "span", 22);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(1, _c6, ctx_r1.loadingSpinner));
} }
function QuantityStepperALV2Component_ng_container_1_ng_container_1_ng_container_2_div_1_span_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 23, 2);
    i0.ɵɵelement(2, "span", 24);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵpropertyInterpolate1("id", "qtySpinner_", ctx_r1.product.id, "");
} }
function QuantityStepperALV2Component_ng_container_1_ng_container_1_ng_container_2_div_1_button_10_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 25, 3);
    i0.ɵɵlistener("click", function QuantityStepperALV2Component_ng_container_1_ng_container_1_ng_container_2_div_1_button_10_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r5); const ctx_r1 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r1.showUpdateQtyInput()); })("keydown.enter", function QuantityStepperALV2Component_ng_container_1_ng_container_1_ng_container_2_div_1_button_10_Template_button_keydown_enter_0_listener() { i0.ɵɵrestoreView(_r5); const ctx_r1 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r1.showUpdateQtyInput()); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵpropertyInterpolate1("id", "qtyInfo_", ctx_r1.product.id, "");
    i0.ɵɵattribute("aria-label", ctx_r1.quantityAriaLabelMessage);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.product.quantity);
} }
function QuantityStepperALV2Component_ng_container_1_ng_container_1_ng_container_2_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 11)(1, "span", 12);
    i0.ɵɵtext(2, "Quantity stepper menu expanded");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "span", 13);
    i0.ɵɵtext(4);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "button", 14, 1);
    i0.ɵɵlistener("click", function QuantityStepperALV2Component_ng_container_1_ng_container_1_ng_container_2_div_1_Template_button_click_5_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r1.beforeCartAction("decrease", $event)); });
    i0.ɵɵtemplate(7, QuantityStepperALV2Component_ng_container_1_ng_container_1_ng_container_2_div_1_span_7_Template, 1, 0, "span", 15)(8, QuantityStepperALV2Component_ng_container_1_ng_container_1_ng_container_2_div_1_span_8_Template, 1, 3, "span", 16);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(9, QuantityStepperALV2Component_ng_container_1_ng_container_1_ng_container_2_div_1_span_9_Template, 3, 2, "span", 17)(10, QuantityStepperALV2Component_ng_container_1_ng_container_1_ng_container_2_div_1_button_10_Template, 3, 4, "button", 18);
    i0.ɵɵelementStart(11, "button", 19);
    i0.ɵɵlistener("click", function QuantityStepperALV2Component_ng_container_1_ng_container_1_ng_container_2_div_1_Template_button_click_11_listener($event) { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r1.beforeCartAction("increase", $event)); });
    i0.ɵɵelement(12, "span", 20);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(4);
    i0.ɵɵtextInterpolate(ctx_r1.stepperAnnouncement);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "dec_qtyInfo_", ctx_r1.product.id, "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(16, _c4, ctx_r1.loadingSpinner));
    i0.ɵɵattribute("aria-label", ctx_r1.product.quantity == 1 ? ctx_r1.REMOVE + " Quantity of " + ctx_r1.getProductFullName() + " from cart" : "Decrease Quantity 1 unit of " + ctx_r1.getProductFullName())("aria-disabled", ctx_r1.loadingSpinner);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.product.quantity == 1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.product.quantity > 1);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.loadingSpinner);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.loadingSpinner);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "inc_qtyInfo_", ctx_r1.product.id, "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(18, _c4, ctx_r1.product.quantity >= ctx_r1.product.maxPurchaseQty || ctx_r1.loadingSpinner));
    i0.ɵɵattribute("aria-label", "Increase Quantity 1 unit of " + ctx_r1.getProductFullName())("aria-disabled", ctx_r1.product.quantity >= ctx_r1.product.maxPurchaseQty || ctx_r1.loadingSpinner);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(20, _c5, ctx_r1.product.quantity >= ctx_r1.product.maxPurchaseQty || ctx_r1.loadingSpinner));
} }
function QuantityStepperALV2Component_ng_container_1_ng_container_1_ng_container_2_div_2_input_3_Template(rf, ctx) { if (rf & 1) {
    const _r7 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "input", 30);
    i0.ɵɵlistener("keydown", function QuantityStepperALV2Component_ng_container_1_ng_container_1_ng_container_2_div_2_input_3_Template_input_keydown_0_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r1 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r1.inputQtyKeydown($event)); });
    i0.ɵɵtwoWayListener("ngModelChange", function QuantityStepperALV2Component_ng_container_1_ng_container_1_ng_container_2_div_2_input_3_Template_input_ngModelChange_0_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r1 = i0.ɵɵnextContext(5); i0.ɵɵtwoWayBindingSet(ctx_r1.updateState.input, $event) || (ctx_r1.updateState.input = $event); return i0.ɵɵresetView($event); });
    i0.ɵɵlistener("keyup", function QuantityStepperALV2Component_ng_container_1_ng_container_1_ng_container_2_div_2_input_3_Template_input_keyup_0_listener($event) { i0.ɵɵrestoreView(_r7); const ctx_r1 = i0.ɵɵnextContext(5); return i0.ɵɵresetView(ctx_r1.inputQtyKeyup($event)); });
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵpropertyInterpolate1("id", "qtyInfoControl_", ctx_r1.product.id, "");
    i0.ɵɵproperty("max", ctx_r1.product.maxPurchaseQty);
    i0.ɵɵtwoWayProperty("ngModel", ctx_r1.updateState.input);
    i0.ɵɵattribute("aria-label", "Cart quantity " + ctx_r1.getProductFullName());
} }
function QuantityStepperALV2Component_ng_container_1_ng_container_1_ng_container_2_div_2_span_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 23, 2);
    i0.ɵɵelement(2, "span", 24);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(5);
    i0.ɵɵpropertyInterpolate1("id", "qtySpinner_", ctx_r1.product.id, "");
} }
function QuantityStepperALV2Component_ng_container_1_ng_container_1_ng_container_2_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 26)(1, "span", 13);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, QuantityStepperALV2Component_ng_container_1_ng_container_1_ng_container_2_div_2_input_3_Template, 1, 5, "input", 27)(4, QuantityStepperALV2Component_ng_container_1_ng_container_1_ng_container_2_div_2_span_4_Template, 3, 2, "span", 17);
    i0.ɵɵelementStart(5, "button", 28);
    i0.ɵɵlistener("click", function QuantityStepperALV2Component_ng_container_1_ng_container_1_ng_container_2_div_2_Template_button_click_5_listener($event) { i0.ɵɵrestoreView(_r6); const ctx_r1 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r1.beforeCartAction("update", $event)); });
    i0.ɵɵelement(6, "span", 29);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.stepperAnnouncement);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.loadingSpinner);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.loadingSpinner);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "update_qtyInfo_", ctx_r1.product.id, "");
    i0.ɵɵattribute("aria-label", "update quantity of " + ctx_r1.getProductFullName())("aria-disabled", ctx_r1.product.quantity >= ctx_r1.product.maxPurchaseQty || ctx_r1.loadingSpinner);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(8, _c7, ctx_r1.product.quantity >= ctx_r1.product.maxPurchaseQty || ctx_r1.loadingSpinner));
} }
function QuantityStepperALV2Component_ng_container_1_ng_container_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, QuantityStepperALV2Component_ng_container_1_ng_container_1_ng_container_2_div_1_Template, 13, 22, "div", 9)(2, QuantityStepperALV2Component_ng_container_1_ng_container_1_ng_container_2_div_2_Template, 7, 10, "div", 10);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.updateState.show);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.updateState.show);
} }
function QuantityStepperALV2Component_ng_container_1_ng_container_1_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    const _r8 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "button", 31);
    i0.ɵɵlistener("click", function QuantityStepperALV2Component_ng_container_1_ng_container_1_ng_container_3_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r8); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.showQtyStepper()); });
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵadvance();
    i0.ɵɵpropertyInterpolate1("id", "bubble_qtyInfo_", ctx_r1.product.id, "");
    i0.ɵɵattribute("aria-label", "collapsed, " + ctx_r1.quantityAriaLabelMessage);
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate(ctx_r1.product.quantity);
} }
function QuantityStepperALV2Component_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, QuantityStepperALV2Component_ng_container_1_ng_container_1_ng_container_1_Template, 6, 10, "ng-container", 4)(2, QuantityStepperALV2Component_ng_container_1_ng_container_1_ng_container_2_Template, 3, 2, "ng-container", 4)(3, QuantityStepperALV2Component_ng_container_1_ng_container_1_ng_container_3_Template, 3, 4, "ng-container", 4);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.product.quantity == null || ctx_r1.product.quantity == 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.product.quantity > 0 && ctx_r1.displayBubble == false);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.product.quantity > 0 && ctx_r1.displayBubble == true);
} }
function QuantityStepperALV2Component_ng_container_1_ng_container_2_button_2_Template(rf, ctx) { if (rf & 1) {
    const _r9 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 36);
    i0.ɵɵlistener("click", function QuantityStepperALV2Component_ng_container_1_ng_container_2_button_2_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r9); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.displayWeights()); });
    i0.ɵɵelementStart(1, "span", 37);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(3, "span", 38)(4, "span", 39);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵattributeInterpolate1("aria-controls", "qtyDropdownContentList_", ctx_r1.product.id, "");
    i0.ɵɵattributeInterpolate1("aria-label", "select weight ", ctx_r1.product.name, "");
    i0.ɵɵpropertyInterpolate1("id", "qtyDropdownBtn_", ctx_r1.product.id, "");
    i0.ɵɵattribute("aria-expanded", ctx_r1.showWeights);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.selectedWeightText);
} }
function QuantityStepperALV2Component_ng_container_1_ng_container_2_button_3_Template(rf, ctx) { if (rf & 1) {
    const _r10 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 40);
    i0.ɵɵlistener("click", function QuantityStepperALV2Component_ng_container_1_ng_container_2_button_3_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r10); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.displayWeights()); });
    i0.ɵɵelementStart(1, "span", 41);
    i0.ɵɵtext(2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵattributeInterpolate1("aria-controls", "qtyDropdownContentList_", ctx_r1.product.id, "");
    i0.ɵɵpropertyInterpolate1("id", "qtyDropdownBtn_", ctx_r1.product.id, "");
    i0.ɵɵattribute("aria-expanded", ctx_r1.showWeights)("aria-label", ctx_r1.quantityAriaLabelMessage);
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate(ctx_r1.selectedWeightText);
} }
function QuantityStepperALV2Component_ng_container_1_ng_container_2_div_4_li_2_Template(rf, ctx) { if (rf & 1) {
    const _r12 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "li", 50);
    i0.ɵɵlistener("click", function QuantityStepperALV2Component_ng_container_1_ng_container_2_div_4_li_2_Template_li_click_0_listener($event) { const i_r13 = i0.ɵɵrestoreView(_r12).index; const ctx_r1 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r1.beforeCartAction("weighted", $event, i_r13)); })("mouseenter", function QuantityStepperALV2Component_ng_container_1_ng_container_2_div_4_li_2_Template_li_mouseenter_0_listener() { const i_r13 = i0.ɵɵrestoreView(_r12).index; const ctx_r1 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r1.mouseEnter(i_r13)); })("keydown.enter", function QuantityStepperALV2Component_ng_container_1_ng_container_2_div_4_li_2_Template_li_keydown_enter_0_listener($event) { const i_r13 = i0.ɵɵrestoreView(_r12).index; const ctx_r1 = i0.ɵɵnextContext(4); return i0.ɵɵresetView(ctx_r1.beforeCartAction("weighted", $event, i_r13)); });
    i0.ɵɵtext(1);
    i0.ɵɵpipe(2, "number");
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r14 = ctx.$implicit;
    const i_r13 = ctx.index;
    const ctx_r1 = i0.ɵɵnextContext(4);
    i0.ɵɵpropertyInterpolate1("id", "dropdown-itm", i_r13, "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(7, _c11, ctx_r1.isCarouselRedesign, ctx_r1.isCarouselRedesign && !ctx_r1.isCarouselBTestEnabled));
    i0.ɵɵadvance();
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(2, 4, item_r14.weight, "1.2"), " lb ");
} }
function QuantityStepperALV2Component_ng_container_1_ng_container_2_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r11 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 42)(1, "ul", 43);
    i0.ɵɵtemplate(2, QuantityStepperALV2Component_ng_container_1_ng_container_2_div_4_li_2_Template, 3, 10, "li", 44);
    i0.ɵɵelementStart(3, "li", 45);
    i0.ɵɵlistener("click", function QuantityStepperALV2Component_ng_container_1_ng_container_2_div_4_Template_li_click_3_listener($event) { i0.ɵɵrestoreView(_r11); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.beforeCartAction("weighted", $event)); })("keydown.enter", function QuantityStepperALV2Component_ng_container_1_ng_container_2_div_4_Template_li_keydown_enter_3_listener($event) { i0.ɵɵrestoreView(_r11); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.beforeCartAction("weighted", $event)); })("mouseenter", function QuantityStepperALV2Component_ng_container_1_ng_container_2_div_4_Template_li_mouseenter_3_listener() { i0.ɵɵrestoreView(_r11); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.mouseEnterRemoveBtn()); });
    i0.ɵɵtext(4, " Remove ");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(5, "div", 46)(6, "span", 47);
    i0.ɵɵtext(7);
    i0.ɵɵpipe(8, "currency");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(9, "span", 48);
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "currency");
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(12, "div", 49);
    i0.ɵɵtext(13, "Final cost by weight");
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(3);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(19, _c8, ctx_r1.isCarouselRedesign, ctx_r1.isCarouselRedesign && !ctx_r1.isCarouselBTestEnabled, ctx_r1.showWeights));
    i0.ɵɵadvance();
    i0.ɵɵattributeInterpolate1("aria-labelledby", "qtyDropdownBtn_", ctx_r1.product.id, "");
    i0.ɵɵpropertyInterpolate1("id", "qtyDropdownContentList_", ctx_r1.product.id, "");
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(23, _c9, ctx_r1.isCarouselRedesign, ctx_r1.isCarouselRedesign && !ctx_r1.isCarouselBTestEnabled));
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngForOf", ctx_r1.weightList);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction3(26, _c10, ctx_r1.isCarouselRedesign, ctx_r1.selectedWeight === 0, ctx_r1.isCarouselRedesign && !ctx_r1.isCarouselBTestEnabled));
    i0.ɵɵattribute("aria-disabled", ctx_r1.selectedWeight === 0);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(30, _c11, ctx_r1.isCarouselRedesign, ctx_r1.isCarouselRedesign && !ctx_r1.isCarouselBTestEnabled));
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1("Estimated Total: ", i0.ɵɵpipeBind2(8, 13, ctx_r1.estimatedPrice, "USD"), "");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate1("Est. Total: ", i0.ɵɵpipeBind2(11, 16, ctx_r1.estimatedPrice, "USD"), "");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction2(33, _c11, ctx_r1.isCarouselRedesign, ctx_r1.isCarouselRedesign && !ctx_r1.isCarouselBTestEnabled));
} }
function QuantityStepperALV2Component_ng_container_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 32);
    i0.ɵɵtemplate(2, QuantityStepperALV2Component_ng_container_1_ng_container_2_button_2_Template, 5, 8, "button", 33)(3, QuantityStepperALV2Component_ng_container_1_ng_container_2_button_3_Template, 3, 7, "button", 34)(4, QuantityStepperALV2Component_ng_container_1_ng_container_2_div_4_Template, 14, 36, "div", 35);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", ctx_r1.selectedWeight == 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.selectedWeight != 0);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.showWeights);
} }
function QuantityStepperALV2Component_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵtemplate(1, QuantityStepperALV2Component_ng_container_1_ng_container_1_Template, 4, 3, "ng-container", 4)(2, QuantityStepperALV2Component_ng_container_1_ng_container_2_Template, 5, 3, "ng-container", 4);
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", !ctx_r1.isLBProduct);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngIf", ctx_r1.isLBProduct);
} }
function QuantityStepperALV2Component_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r15 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 51);
    i0.ɵɵlistener("keydown", function QuantityStepperALV2Component_ng_container_2_Template_div_keydown_1_listener($event) { i0.ɵɵrestoreView(_r15); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.onKeydownMtoModalEvent($event, "#mto-modal")); });
    i0.ɵɵelementStart(2, "div", 52)(3, "div", 53)(4, "div", 54)(5, "button", 55);
    i0.ɵɵelement(6, "span", 56);
    i0.ɵɵelementEnd()();
    i0.ɵɵelementStart(7, "div", 57)(8, "div", 58)(9, "h1", 59);
    i0.ɵɵtext(10);
    i0.ɵɵpipe(11, "titlecase");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(12, "div", 60);
    i0.ɵɵtext(13);
    i0.ɵɵpipe(14, "titlecase");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(15, "div", 61)(16, "button", 62);
    i0.ɵɵlistener("click", function QuantityStepperALV2Component_ng_container_2_Template_button_click_16_listener() { i0.ɵɵrestoreView(_r15); const ctx_r1 = i0.ɵɵnextContext(); ctx_r1.handleSlotAction("reserve-new-time"); return i0.ɵɵresetView(ctx_r1.analyticsMTOClicks("reserve-new-time")); });
    i0.ɵɵtext(17, "Reserve new time");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(18, "button", 63);
    i0.ɵɵlistener("click", function QuantityStepperALV2Component_ng_container_2_Template_button_click_18_listener() { i0.ɵɵrestoreView(_r15); const ctx_r1 = i0.ɵɵnextContext(); ctx_r1.handleSlotAction("choose-time-later"); return i0.ɵɵresetView(ctx_r1.analyticsMTOClicks("choose-time-later")); });
    i0.ɵɵtext(19, "Choose time later");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(20, "button", 64);
    i0.ɵɵlistener("click", function QuantityStepperALV2Component_ng_container_2_Template_button_click_20_listener() { i0.ɵɵrestoreView(_r15); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.analyticsMTOClicks("dont-add-item")); });
    i0.ɵɵtext(21, "Don't add item");
    i0.ɵɵelementEnd()()()()()()();
    i0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(10);
    i0.ɵɵtextInterpolate1("", i0.ɵɵpipeBind1(11, 3, ctx_r1.reservedTimeIntent), " time will change");
    i0.ɵɵadvance(3);
    i0.ɵɵtextInterpolate2(" This item requires ", ctx_r1.product.mtoDisplyableTime, " to prepare. Please select a new time for ", i0.ɵɵpipeBind1(14, 5, ctx_r1.reservedTimeIntent), ". ");
} }
class QuantityStepperALV2Component {
    constructor(_commonService, _userInfoService, _elementRef, cartService, cartV2Service, _productUtilService, _aemService, _productCouponService, _utilService, _http, toasterService) {
        this._commonService = _commonService;
        this._userInfoService = _userInfoService;
        this._elementRef = _elementRef;
        this.cartService = cartService;
        this.cartV2Service = cartV2Service;
        this._productUtilService = _productUtilService;
        this._aemService = _aemService;
        this._productCouponService = _productCouponService;
        this._utilService = _utilService;
        this._http = _http;
        this.toasterService = toasterService;
        // DFTA - wcax env config
        this.config = EnviormentConfig;
        this.ADD = 'Add';
        this.REMOVE = 'Remove';
        this.SIGNIN = 'Sign in to add';
        this.isAuthorized = false;
        this.currentEnv = '';
        this.baseDomainUrl = '';
        this.quantityAriaLabelMessage = '';
        this.displayBubble = true;
        this.loadingSpinner = false;
        this.refocusButton = null;
        this.timeouts = [];
        this.reservedTimeIntent = '';
        this.isCarouselRedesign = false;
        this.isQuantityIncreased = false;
        this.mto = {
            popup: {
                show: false,
                modalId: '#mto-modal',
                closeBtn: '.close',
            }
        };
        this.isLBProduct = false;
        this.showWeights = false;
        this.weightList = [];
        this.estimatedPrice = 0;
        this.selectedWeight = 0;
        this.selectedWeightText = 'Select wt';
        this.updateState = {
            show: false,
            input: null
        };
        this.isAuthorized = this._userInfoService.isAuthorized();
        this.currentEnv = this._commonService.getCurrentEnviorment();
        this.baseDomainUrl = this.config[this.currentEnv]?.baseURL?.replace("{banner}", this._userInfoService.getBanner());
        this.enableAdRelevanceTracking = !this._aemService.getFeatureFlagByNameDisable('disableAdRelevance');
        this.reservedTimeIntent = this._userInfoService.getUserChannel();
        this.debounceAddCart = this._commonService.debounce(this.addCart, 600).bind(this);
    }
    /**
     * Handles the focus out event for the quantity stepper component.
     */
    onFocusOutEvent() {
        this.timeouts.push(setTimeout(() => {
            this.handleDisplay();
        }, 100));
    }
    ;
    /**
     ** Initializes the component.
     */
    ngOnInit() {
        this.isLBProduct = this.product?.displayType === '3' && (this.product?.sellByWeight === 'W' || this.product?.sellByWeight === 'P');
        this.isCarouselRedesign = this.calledBy === 'carousel-v2';
        this.getCurrentCartObj();
        this.isGuestAddToCartABSubscription = this._commonService.isABFlagDisabledEvent$.pipe(first(event => event.flagName === 'isGuestAddToCartDisabled')).subscribe((event) => {
            this.isGuestAddToCart = (event.testValue !== 'a') && !this._userInfoService.isAuthorized() && (!this.configObj.programType || this.configObj.programType === 'abs');
        });
        this._commonService.listenToABXTestingFlag('abACIP295974', 'isGuestAddToCartDisabled', 'ACIP295974');
    }
    /**
     * Lifecycle hook that is called when the component is about to be destroyed.
     * It clears all the timeouts and releases any resources held by the component.
     */
    ngOnDestroy() {
        this.timeouts.forEach(timeout => {
            clearTimeout(timeout);
            this.timeouts = [];
        });
        if (this.isGuestAddToCartABSubscription) {
            this.isGuestAddToCartABSubscription.unsubscribe();
        }
    }
    ;
    /**
     * Handles the display logic for the quantity stepper component.
     * If the component does not have focus and is not an LB product, it displays the bubble.
     * If the component does not have focus and is an LB product, it hides the weights.
     */
    handleDisplay() {
        const focusedElement = this._elementRef.nativeElement.querySelector(':focus');
        const hasFocus = focusedElement !== null;
        if (!hasFocus) {
            if (this.isLBProduct) {
                this.toggleDisplayWeights(false);
            }
            else {
                this.displayBubble = true;
                this.updateState.show = false;
            }
        }
    }
    ;
    /**
     * Add current product in cart.
     *
     * @param {any} quantity New stepper's quantity.
     */
    addCart(quantity) {
        this.loadingSpinner = true;
        if (quantity === 0) {
            this._removeProduct();
        }
        else {
            if (!this.isGuestAddToCart) {
                this._clipDigitalCoupon();
            }
            this._cartAPICall(quantity);
        }
    }
    _clipDigitalCoupon() {
        //Calling auto clip digital coupon method
        this._productCouponService.clipDigitalCoupon(this.product.upc);
    }
    /**
     * Retrieves the current cart object and updates the quantity of the product.
     */
    getCurrentCartObj() {
        let obs = this._commonService.currentCartObj;
        const cartName = this.cartV2Service.getCartName(this.configObj?.programType, this.product.sellerId);
        obs = obs.pipe(map$1(objCart => this.cartV2Service.fetchCartDetailsFromResponse(objCart, cartName)));
        obs.subscribe(objCart => {
            let qty = 0;
            let list = [];
            try {
                let cartProduct = {};
                cartProduct = objCart['cartItems'].find(item => item.itemId == this.product.id);
                if (cartProduct) {
                    qty = cartProduct.selectedWeight ?? (cartProduct.qty ?? cartProduct.quantity);
                    list = cartProduct.incrementPriceList ?? [];
                }
                else {
                    qty = 0;
                    list = [];
                }
                this.product.maxPurchaseQty = cartProduct?.maxPurchaseQty;
                qty = (qty > 0) ? qty : 0;
            }
            catch (e) {
                qty = 0;
                list = [];
            }
            this.product.quantity = qty;
            this.previousQuantity = qty;
            this.weightList = list;
            this.selectedWeight = qty;
            this.selectedWeightText = this.selectedWeight != 0 ? `${this.selectedWeight?.toFixed(2)} lb` : `Select wt`;
            if (this.isLBProduct) {
                this.quantityAriaLabelMessage = this.selectedWeight + ' lb of ' + this.product.name + ' in cart. Click to update';
            }
            else {
                const unitTxt = this.product.quantity > 1 ? 'units' : 'unit';
                this.quantityAriaLabelMessage = this.product.quantity + ` ${unitTxt} of ` + this.product.name + ' in cart. Click to update';
            }
        });
    }
    ;
    /**
     * Retrieves the full name of the product.
     * If the product has a full name, it is returned. Otherwise, the product name is returned.
     * @returns The full name of the product.
     */
    getProductFullName() {
        let fullName = '';
        if (this.product)
            fullName = this.product.fullName && this.product.fullName.length ? this.product.fullName : this.product.name;
        return fullName;
    }
    /**
     * Update analytics product info.
     */
    _updateAnalyticsProductInfo(sellerId) {
        // check for datalayer availability, in case component is loaded on pages without the AEM datalayer
        if (window['AB']?.DATALAYER) {
            let productInfoObj;
            // determine whether the current stepper is on a product that is part of the cross-sell component
            const isCrossSell = this.isLBProduct ? false : (this._elementRef.nativeElement.closest('cross-sell') ? true : false);
            const isBIACrossSell = this._elementRef.nativeElement.closest('.slick-product-carousel')?.querySelectorAll('[data-carousel-behaviour="bia-crossSell"]')?.length;
            const isBIASpaCarousel = this._elementRef.nativeElement.closest('.slick-product-carousel')?.querySelectorAll('[data-carousel-behaviour="bia-spaCarousel"]')?.length;
            let carouselTitle = '';
            if (this.stpprDataObj?.carouselTitle) {
                carouselTitle = this.stpprDataObj.carouselTitle;
            }
            else if (isBIACrossSell) {
                carouselTitle = this._elementRef.nativeElement.closest('cross-sell')?.querySelector('.cross-sell__header .cross-sell__title')?.textContent;
            }
            else if (isBIASpaCarousel) {
                carouselTitle = this._elementRef.nativeElement.closest('.bia-spa-carousel-container')?.querySelector('.bia-spa-carousel-container-header')?.textContent?.trim();
            }
            else if (this._elementRef.nativeElement.closest('.master-product-carousel')) {
                carouselTitle = this._elementRef.nativeElement.closest('.master-product-carousel').querySelector('[data-carousel-title]')?.getAttribute('data-carousel-title');
            }
            else if (window['AB'].DATALAYER.isDFTAPage()) {
                carouselTitle = this._elementRef.nativeElement.closest('.slick-product-carousel')?.previousElementSibling?.textContent?.trim() || '';
            }
            else {
                carouselTitle = this._elementRef.nativeElement.closest('.slick-product-carousel')?.querySelector('lazy-wrapper')?.getAttribute('data-carousel-title') ||
                    this._elementRef.nativeElement.closest('.slick-product-carousel')?.querySelector('.carousel-header-text')?.textContent?.trim();
            }
            productInfoObj = {
                id: this.product.id || this.product.itemId,
                adobeMetricA: this.product['adobeMetrics']?.metricA,
                adobeMetricC: this.product['adobeMetrics']?.metricC,
                fullName: this.product.fullName,
                name: this.product.name,
                units: this._commonService.checkPendingOrder() ? this.product.quantity : this.product.qty,
                unitType: this.product.unitQuantity,
                lbs: '0',
                each: '0',
                pricePerUnit: this.product.pricePer,
                listPrice: this.product.price ? this.product.price.toString() : '',
                carouselSection: carouselTitle,
                basePrice: this.product.basePrice ? this.product.basePrice.toString() : '',
                pricingType: this.product.promoType,
                couponFlag: '0',
                couponClipped: '0',
                couponID: '',
                aisleId: this.product.aisleId,
                upc: this.product.upc,
                isCrossSell: isCrossSell,
                isMTO: this.product.isMtoProduct,
                departmentName: this.product.departmentName,
                pathwaysWidget: this.stpprDataObj?.pathwaysWidget,
                sellerId: sellerId ? sellerId : this.product.sellerId,
                sellerName: this.product['sellerName'],
                editOrderFlow: this._commonService.checkPendingOrder() ? true : false,
                snapEligible: this.product.snapEligible,
                isProductTrackingDisabled: this.product.isProductTrackingDisabled ? true : false,
                isP13nGrid: this._elementRef.nativeElement.closest('#p13nProductGrid') ? true : false,
                quantity: this.product.quantity
            };
            if (this.product.unitQuantity == 'LB') {
                productInfoObj.lbs = this.selectedWeight;
            }
            else if (this.product.unitQuantity == 'EACH') {
                productInfoObj.each = this.product.quantity ? this.product.quantity.toString() : this.product.qty?.toString();
            }
            const coupons = this._commonService.getCouponByUpc(this.product.upc);
            // If there are coupons present on the product, filters the information and adds it to the productInfo object
            if (coupons.length > 0) {
                const couponsClipped = coupons.filter(x => x.status === 'C').length;
                const couponsCount = coupons.length;
                const couponIds = coupons.filter(x => x.status === 'C').map(x => x.offerId).toString();
                productInfoObj.couponFlag = couponsCount.toString();
                productInfoObj.couponClipped = couponsClipped.toString();
                productInfoObj.couponID = couponIds;
            }
            // For items that are not on the minicart, set the recommendation type to be used in analytics code
            let isBuyItAgain;
            let isBrPathway;
            let isPicksForYou = false;
            let isP13nGeneric = false;
            if (carouselTitle) {
                const parentCarousel = $(this._elementRef.nativeElement).closest('.slick-product-carousel');
                const buyItAgainCarousel = parentCarousel.find('[data-carousel-behaviour=buy-it-again]').length;
                const brPathwayCarousel = parentCarousel.find('[data-carousel-driven=pathway-search]').length;
                const p13nGenericCarousel = parentCarousel.find('[data-carousel-driven=p13n-generic]').length;
                productInfoObj.isBIACarousalProduct = parentCarousel.find('[data-carousel-behaviour=bia-spaCarousel]').length ? true : false;
                isBuyItAgain = buyItAgainCarousel ? true : false;
                isBrPathway = brPathwayCarousel ? true : false;
                isPicksForYou = carouselTitle.search(/picks for you|picked for you|picks-for-you|picked-for-you/i) !== -1;
                isP13nGeneric = p13nGenericCarousel ? true : false;
                // set placement value for carousel items
                productInfoObj.placement = window['AB'].DATALAYER.setPlacementInfoCarouselItems(this._elementRef.nativeElement);
            }
            let recommendationObj = {
                isCrossSell: isCrossSell,
                isRecommended: this.stpprDataObj?.isRecommended || isPicksForYou || isP13nGeneric,
                isSponsored: this.product['featured'],
                isPastPurchased: isBuyItAgain || this.product['pastPurchased'],
                isBrPathway: isBrPathway
            };
            if (this.product['adId'] || this.product.eventTracking) {
                recommendationObj.isSponsored = true;
            }
            window['AB'].DATALAYER.recommendationInfo(recommendationObj);
            window['AB'].DATALAYER.productInfo(productInfoObj);
            /**
             * update pageFilter with:
             * carousel title (when a user performs any action related to a carousel)
             */
            if (carouselTitle) {
                window['AB'].DATALAYER.isRecipesPage()
                    ? window['AB'].DATALAYER.setCarouselName(`recipes|${carouselTitle}`)
                    : window['AB'].DATALAYER.setCarouselName(`shop|${carouselTitle}`);
            }
            else {
                window['AB'].DATALAYER.setCarouselName('');
            }
            /**
             * for products that are not in a carousel
             * set metaInfo(number of images clicked on pdp before the user performs a product action)
             */
            if (window['AB'].DATALAYER.isPdp()) {
                if (carouselTitle) {
                    window['AB'].DATALAYER.setPageFilterMetaInfo(false);
                }
                else {
                    window['AB'].DATALAYER.setPageFilterMetaInfo(true);
                }
            }
        }
    }
    setAnalyticsSNSProdAction(action) {
        if (this.configObj?.programType === '1P_SNS') {
            localStorage.setItem('analyticsSNSProdAction', action);
        }
    }
    setAnalyticsProductAction() {
        if (window['AB']?.DATALAYER) {
            const analyticsProductID = this.product.id || this.product.itemId;
            if (!window['AB'].DATALAYER.isProductInAnalyticsCart(analyticsProductID)) {
                this.addItemToCartAnalytics = true;
            }
            else {
                const action = window['AB'].DATALAYER.weightSelectionActionType(analyticsProductID, this.selectedWeight);
                switch (action) {
                    case 'increase':
                        this.increaseQuantityAnalytics = true;
                        break;
                    case 'decrease':
                        this.decreaseQuantityAnalytics = true;
                        break;
                    default:
                        break;
                }
            }
        }
    }
    /**
     * Makes a cart API call to add or update the quantity of a product.
     *
     * @param {number} quantity - The quantity of the product.
     * @returns {void}
     */
    _cartAPICall(quantity) {
        const oldCartIdLs = JSON.parse(localStorage.getItem('cartId'));
        this.cartV2Service.addOrUpdateProductQuantity(this.product, this.product.id, this.isLBProduct ? quantity.toString() : quantity, false, this.product.sellerId, this.isLBProduct, undefined, this.configObj?.programType ? this.configObj.programType : this.configObj?.appName, this.isGuestAddToCart)
            .subscribe((response) => {
            if (response) {
                if (this.isQuantityIncreased) {
                    this.showPriceChangeToast(this.isQuantityIncreased, response);
                    this.isQuantityIncreased = false;
                }
                if (this.configObj?.programType === '1P_SNS') {
                    this.callSNSSuccessDispatch();
                }
                else {
                    this.cartService.refreshCart(response);
                }
                const cartName = this.cartV2Service.getCartName(this.configObj?.programType, this.product.sellerId);
                let singleCartresponse = this.cartV2Service.fetchCartDetailsFromResponse(response, cartName);
                if (singleCartresponse && (singleCartresponse['cartId'] || singleCartresponse['guestCartId'])) {
                    if (singleCartresponse['cartItems']) {
                        this._commonService.sendSponsoredProductClickEvent(this.product, 'quantityStepper', 'addToCart');
                        // make ad relevance call for all products on search page only
                        if (this.enableAdRelevanceTracking) {
                            this._commonService.recordRelevanceImpression(this.product, 'quantityStepper', 'addToCart');
                        }
                        singleCartresponse = this.cartV2Service.handleResponseForPendingOrder(singleCartresponse);
                        this.loadingSpinner = false;
                        this.updateState.show = false;
                        if (this.isLBProduct) {
                            this.focusQtyDropdownBtn();
                        }
                        else {
                            this.handleReturnFocusForQtyStppr();
                        }
                        if (this.isPrebookRedirect) {
                            this.redirectToPrebookPage();
                        }
                        if (window['AB']['DATALAYER']) {
                            const sellerId = this.product.sellerId ? this.product.sellerId : singleCartresponse['cartCategory'] === '1P_WINE' ? '22222222' : window['AB']['DATALAYER'].getBannerSellerId();
                            this._updateAnalyticsProductInfo(sellerId);
                            window['AB']['DATALAYER'].updateCartType('');
                            window['AB']['DATALAYER'].updateCart(response, this.product, response['isWYSIWYGEnabled']);
                            if (this.addItemToCartAnalytics) {
                                window['AB']['DATALAYER'].addItemToCart();
                                this.addItemToCartAnalytics = false;
                            }
                            else if (this.increaseQuantityAnalytics) {
                                window['AB']['DATALAYER'].increaseItemQuantity();
                                this.increaseQuantityAnalytics = false;
                            }
                            else if (this.decreaseQuantityAnalytics) {
                                window['AB']['DATALAYER'].decreaseItemQuantity();
                                this.decreaseQuantityAnalytics = false;
                            }
                        }
                        if (this.product.sellerId && this.configObj?.programType !== 'mkp-carousel') {
                            this.showMkpAddToCartModal(this.product.sellerId, this.product.sellerName, this.product.price, oldCartIdLs);
                        }
                        else if (this.configObj?.programType === 'wineshop') {
                            this.showStaticFirstTimeCartModal('1P_WINE', oldCartIdLs);
                        }
                    }
                }
            }
        }, err => {
            console.error('Error while calling Cart API: ' + err.message);
            this.product.quantity = this.previousQuantity;
            this.selectedWeight = this.previousQuantity;
            this.updateState.show = false;
            this.selectedWeightText = this.selectedWeight != 0 ? `${this.selectedWeight?.toFixed(2)} lb` : 'Select wt';
            this.loadingSpinner = false;
            this.isQuantityIncreased = false;
            if (this.isLBProduct) {
                this.focusQtyDropdownBtn();
            }
            else {
                this.handleReturnFocusForQtyStppr();
            }
        });
    }
    /**
     * Show sign in modal to unregistered users.
     */
    _showSignInModal(configObj) {
        const redirectPath = encodeURIComponent(window.location.href);
        window['SWY'].CONFIGSERVICE.setCookie('ECommRedirectURL', redirectPath, 0);
        if (configObj && configObj?.appName === 'weeklyAd') {
            const bannerDomainUrl = this._productUtilService.getBannerDomainUrl(this.configObj);
            const navPath = bannerDomainUrl + window['AB'].signInLinkPath;
            const analyticsIcmpid = window['AB'] && window['AB']['DATALAYER'] && window['AB']['DATALAYER'].trackWeeklyAdIcmpid && window['AB']['DATALAYER'].trackWeeklyAdIcmpid('sign-in-to-add', navPath) || '';
            window.location.assign(navPath + `${analyticsIcmpid}`);
        }
        else {
            window['AB']['COMMON'].showSignInModal_OTP(window.location.href);
        }
    }
    /**
     * Removes the product from the cart and performs necessary actions.
     * @private
     */
    _removeProduct() {
        this.cartV2Service.removeProduct(this.product, this.product.id, this.product.sellerId, this.configObj?.programType ? this.configObj.programType : this.configObj?.appName, this.isGuestAddToCart).subscribe((response) => {
            if (response) {
                if (this.configObj?.programType === '1P_SNS') {
                    this.callSNSSuccessDispatch();
                }
                else {
                    this.cartService.refreshCart(response);
                }
                const cartName = this.cartV2Service.getCartName(this.configObj?.programType, this.product.sellerId);
                let singleCartresponse = this.cartV2Service.fetchCartDetailsFromResponse(response, cartName);
                this._commonService.sendSponsoredProductClickEvent(this.product, 'quantityStepper', 'removeProduct');
                singleCartresponse = this.cartV2Service.handleResponseForPendingOrder(singleCartresponse);
                this.loadingSpinner = false;
                if (window['AB']['DATALAYER']) {
                    const sellerId = this.product.sellerId ? this.product.sellerId : singleCartresponse['cartCategory'] === '1P_WINE' || cartName === '1P_WINE' ? '22222222' : window['AB']['DATALAYER'].getBannerSellerId();
                    this._updateAnalyticsProductInfo(sellerId);
                    window['AB']['DATALAYER'].updateCartType('');
                    window['AB']['DATALAYER'].updateCart(response, null, response['isWYSIWYGEnabled']);
                    if (this.removeItemFromCartAnalytics) {
                        window['AB']['DATALAYER'].removeItemFromCart();
                        this.removeItemFromCartAnalytics = false;
                    }
                }
            }
        }, err => {
            console.error('Error while calling Cart API: ' + err.message);
            this.product.quantity = this.previousQuantity;
            this.selectedWeight = this.previousQuantity;
            this.selectedWeightText = `${this.selectedWeight?.toFixed(2)} lb`;
            this.loadingSpinner = false;
            this.displayBubble = false;
            if (this.isLBProduct) {
                this.focusQtyDropdownBtn();
            }
            else {
                this.timeouts.push(setTimeout(() => {
                    this.decreaseBtn?.nativeElement.focus();
                }, 100));
            }
        });
    }
    /**
     * Hides the bubble variation and shows the quantity stepper.
     * Sets the focus on the decrement button of the quantity stepper.
     */
    showQtyStepper() {
        this.displayBubble = false;
        this.updateState.show = false;
        this.timeouts.push(setTimeout(() => {
            this.qtyInfoBtn?.nativeElement.focus();
        }, 100));
    }
    /**
     * Updates the loading message for the quantity stepper.
     * @param qty The quantity value.
     */
    updateLoadingMessage(qty) {
        // based on previous quantity stepperannouncenment update or else always empty
        if (qty && qty !== this.previousQuantity) {
            this.stepperAnnouncement = `quantity content ${qty} loading`;
            //Reset the announcement to prevent repeated reading
            setTimeout(() => {
                this.stepperAnnouncement = '';
            }, 3000);
        }
    }
    /**
     * Validates the session before Performing any cart action.
     * @param action - The type of cart action ('increase', 'decrease', 'update').
     * @param event - The event object associated with the action.
     */
    beforeCartAction(action, event, selectedWeightIndex) {
        if (this.isAuthorized || this.isGuestAddToCart) {
            // README: wrapping the entire code as anonymous function to pass it as a callback Function
            const preference = this._userInfoService.getPreference()
                ? this._userInfoService.getPreference().toUpperCase()
                : undefined;
            const performCartActionIfSessionValid = () => {
                if (['delivery', 'dug'].includes(preference?.toLowerCase())) {
                    if (action === 'increase') {
                        if (this.product.isMtoProduct) {
                            // Do MTO validations here and then call increaseCart based on the successful validation
                            if (localStorage.getItem('abSlot') && this._commonService.preparationTimeExceedsPrebook(this.product, 'abSlot')) {
                                this._displayMtoModal('popup', '#mto-modal', { show: true });
                            }
                            else {
                                this.performCartAction(action, event);
                            }
                        }
                        else {
                            this.performCartAction(action, event);
                        }
                    }
                    else if (action === 'decrease') {
                        this.performCartAction(action, event);
                    }
                    else if (action === 'weighted') {
                        this.performCartAction(action, event, selectedWeightIndex);
                    }
                    else if (action === 'update') {
                        this.performCartAction(action, event);
                    }
                }
                else if (preference === 'J4U') {
                    if (action === 'increase') {
                        // Handling weeklyad use case will be handled in a different PR
                        window['storeFulfillmentModal'].component.setModalDisplayData(2);
                    }
                }
            };
            // README: calling validateSession with a callback function (i.e performCartActionIfSessionValid) which does check for
            // a valid session and perform the cart action
            if (this.isGuestAddToCart) {
                performCartActionIfSessionValid();
            }
            else {
                this._commonService.validateSession(performCartActionIfSessionValid);
            }
        }
        else {
            if (action === 'increase') {
                if (window['eddlLoadComplete']) {
                    window['AB']['DATALAYER'].setATCFlag(true);
                }
            }
            this._showSignInModal(this.configObj);
        }
    }
    /**
     * Performs a cart action based on the specified action and event.
     * @param action - The action to perform ('increase', 'decrease', 'update').
     * @param event - The event object associated with the action.
     */
    performCartAction(action, event, selectedWeightIndex) {
        if (action === 'increase') {
            this.isQuantityIncreased = true;
            this.product.quantity = this.product.quantity ? this.product.quantity + 1 : 1;
            this.displayBubble = false;
            if (this.product.quantity === 1) {
                this.addFocusToSpinnerBlock();
                this.addItemToCartAnalytics = true;
                this.setAnalyticsSNSProdAction('add-item');
            }
            else {
                this.refocusButton = event ? event.currentTarget : null;
                this.increaseQuantityAnalytics = true;
                this.setAnalyticsSNSProdAction('quantity-increase');
            }
        }
        if (action === 'decrease') {
            this.product.quantity = this.product.quantity - 1;
            if (this.product.quantity === 0) {
                this.refocusButton = null;
                this.timeouts.push(setTimeout(() => {
                    this.addBtn?.nativeElement.focus();
                }, 100));
                if (window['AB']['DATALAYER']) {
                    this.removeItemFromCartAnalytics = true;
                    this.setAnalyticsSNSProdAction('remove-item');
                }
            }
            else {
                this.refocusButton = event ? event.currentTarget : null;
                this.decreaseQuantityAnalytics = true;
                this.setAnalyticsSNSProdAction('quantity-decrease');
            }
        }
        if (action === 'weighted') {
            this.toggleDisplayWeights(false);
            if (selectedWeightIndex != null && !isNaN(selectedWeightIndex)) {
                if (this.selectedWeight < parseFloat(this.weightList[selectedWeightIndex].weight)) {
                    this.isQuantityIncreased = true;
                }
                this.selectedWeight = parseFloat(this.weightList[selectedWeightIndex].weight);
                this.selectedWeightText = `${this.selectedWeight?.toFixed(2)} lb`;
                this.setAnalyticsProductAction();
            }
            else {
                this.selectedWeight = 0;
                this.selectedWeightText = 'Select wt';
                this.removeItemFromCartAnalytics = true;
                this.focusQtyDropdownBtn();
            }
            this.product.quantity = this.selectedWeight;
        }
        if (action === 'update') {
            this.updateState.input ??= 0;
            if (this.updateState.input > this.product.quantity) {
                this.isQuantityIncreased = true;
                this.addFocusToSpinnerBlock();
                this.increaseQuantityAnalytics = true;
                this.setAnalyticsSNSProdAction('quantity-increase');
            }
            else if (this.updateState.input < this.product.quantity) {
                if (this.updateState.input === 0) {
                    this.refocusButton = null;
                    this.timeouts.push(setTimeout(() => {
                        this.addBtn?.nativeElement.focus();
                    }, 100));
                    if (window['AB']['DATALAYER']) {
                        this.removeItemFromCartAnalytics = true;
                        this.setAnalyticsSNSProdAction('remove-item');
                    }
                }
                else {
                    this.addFocusToSpinnerBlock();
                    this.decreaseQuantityAnalytics = true;
                    this.setAnalyticsSNSProdAction('quantity-decrease');
                }
            }
            this.product.quantity = this.updateState.input;
        }
        if (this.product.maxPurchaseQty && this.product.quantity > this.product.maxPurchaseQty) {
            this.product.quantity = this.product.maxPurchaseQty;
        }
        this.updateLoadingMessage(this.product.quantity);
        this.debounceAddCart(this.product.quantity);
    }
    showPriceChangeToast(isQuantityIncreased, cart) {
        const isOrderAmendDisabled = this._aemService.getFeatureFlagByNameDisable('isOrderAmendDisabled');
        if (!isOrderAmendDisabled && isQuantityIncreased && this._commonService.checkPendingOrder()) {
            const orderedProduct = cart['cartItems']?.find(item => item.itemId === this.product.id);
            const price = this._commonService.getValidProductPrice(this.product);
            const orderedItemPrice = orderedProduct?.price < orderedProduct?.basePrice ? orderedProduct?.price : orderedProduct?.basePrice;
            if (orderedProduct && orderedItemPrice !== price) {
                let msg = `Great news—your price for this item is still $${orderedItemPrice}, based on when you placed your order. `;
                if (orderedItemPrice > price) {
                    msg = `The price for ${this.product.name} has changed, but your price is still $${orderedItemPrice} based on its price on the day your order was placed. `;
                }
                this.toasterService.show({
                    title: 'OK',
                    message: msg,
                    type: ToasterType.Info,
                    interactiveElement: 'See Policy',
                    interactiveElementLink: 'https://www.albertsonscompanies.com/policies-and-disclosures/terms-of-use/default.aspx',
                }, { class: 'popup--toaster--right' });
            }
        }
    }
    /**
     * Redirect to prebook page
    */
    redirectToPrebookPage() {
        window.location.href = '/erums/store/prebook';
    }
    /**
   * Dispalys the MTO Modal
   *
   * @param modalType - can be popup or error modal
   *
   * @param modalId - id of the modal
   *
   * @param modalOptions - options for jQuery modal()
   *
   */
    _displayMtoModal(modalType, modalId, modalOptions) {
        this.mto[modalType].show = true;
        setTimeout(() => {
            $(modalId).modal(modalOptions);
            $(modalId).appendTo('.unified-footer');
            const qtyStepper = this;
            $(modalId).on('shown.bs.modal', function () {
                $(qtyStepper.mto[modalType].closeBtn).focus();
            });
            $(modalId).on('hidden.bs.modal', function () {
                qtyStepper.mto[modalType].show = false;
                $(modalId).remove();
                $(`#addButton_${qtyStepper.product.id}`).focus();
            });
            window['AB']?.DATALAYER?.setModalViewEvents('mto-pickup|view');
        }, 100);
    }
    onKeydownMtoModalEvent($event, modelId) {
        const focusableElements = 'button:not([disabled])';
        this._commonService.handleTabFocus($event, modelId, document.getElementById('mto-modal').parentElement, focusableElements);
    }
    handleSlotAction(type) {
        const abSlot = JSON.parse(localStorage.getItem('abSlot'));
        const slotId = abSlot?.slotId;
        const slotType = abSlot?.type;
        if (slotId) {
            const delRequest = this._deleteSlotRequest(slotId, slotType);
            // README: Delete current prebooked slot
            this._http.delete(delRequest.url, {
                headers: new HttpHeaders(delRequest.headers), responseType: 'text'
            }).subscribe((data) => {
                if (window['AB']['COMMON'].isLSCompatible()) {
                    localStorage.removeItem('abSlot');
                }
                // README: Resets reserve nav message after the slot is deleted
                this._resetReserveNavText();
                this.isPrebookRedirect = type === 'reserve-new-time';
                // README: Add item to cart
                this.performCartAction('increase', null);
                // README: Close MTO modal
                $('#mto-modal').modal('hide');
            }, (err) => {
                // README: Close MTO modal
                $('#mto-modal').modal('hide');
            });
        }
    }
    /**
     * Constructs the request for prebook delete slot
    */
    _deleteSlotRequest(slotId, slotType) {
        const origin = window.location.origin;
        const storeId = window['AB'].userInfo.branchId;
        const userChannel = this._userInfoService.getUserChannel() ? this._userInfoService.getUserChannel().toUpperCase() : '';
        let path = window['SWY'].CONFIGSERVICE.osdpConfig['osdp.slot.promise.service.endpoint'];
        let headers = window['AB'].ecommHttpOptionsOsdp;
        headers.clientId = 'CC';
        headers.storeId = storeId;
        // update path if mockinator is requested
        const wiremockAPIDetails = this.config[this.currentEnv].wiremockAPIDetails;
        // check if wiremock service is enabled
        if (wiremockAPIDetails?.allowWiremockService) {
            const mode = this._utilService.getParams('mode');
            // check mode coming from request parameter
            if (mode === 'record') {
                // prepend record base url to virtual shelf api endpoint
                path = `${wiremockAPIDetails?.recorderBaseUrl}${path}`;
            }
            else if (mode === 'playback') {
                // prepend playback base url to virtual shelf api endpoint
                path = `${wiremockAPIDetails?.playbackBaseUrl}${path}`;
            }
            // update subscription key with mockinator subscription key if mode is either playback or record
            headers['ocp-apim-subscription-key'] = (mode === 'record' || mode === 'playback') ? wiremockAPIDetails?.subscriptionKey : headers['ocp-apim-subscription-key'];
        }
        if (userChannel && (userChannel === 'DELIVERY' || userChannel === 'PICKUP')) {
            if (userChannel === 'PICKUP') {
                headers['serviceType'] = 'DUG';
            }
            else {
                headers['serviceType'] = userChannel;
            }
        }
        let slotTypeParameter = '';
        if (slotType === 'FLASH')
            slotTypeParameter = '?type=FLASH';
        return {
            url: `${origin}${path}/reserve/${storeId}/${slotId}${slotTypeParameter}`,
            headers: headers
        };
    }
    /**
     * Resets reserve nav text after the slot has been deleted
     */
    _resetReserveNavText() {
        // if new navigation flag is enabled, reset the reserve nav text using new classes
        const navEngineEnabled = !this._aemService.getFeatureFlagByNameDisable('isNavigationEngineDisabled');
        if (navEngineEnabled) {
            const reserveNav = document.querySelector('.s_nav_fulfillment_link.fulfillment_link_reserve');
            reserveNav.innerHTML = 'Reserve';
        }
        else {
            if (window['AB'].userInfo.preferenceMode.toLowerCase() === 'dug') {
                const reserveNav = document.querySelector('.reserve-nav__text_pickup');
                if (reserveNav) {
                    reserveNav.textContent = 'Reserve a pickup time';
                }
            }
            else if (window['AB'].userInfo.preferenceMode.toLowerCase() === 'delivery') {
                const reserveNav = document.querySelector('.reserve-nav__text_delivery');
                if (reserveNav) {
                    reserveNav.textContent = 'Reserve a delivery time';
                }
            }
        }
    }
    /**
     * Analytics method for tracking link clicks on MTO modal
     *
    */
    analyticsMTOClicks(linkClicked) {
        if (window['AB'] && window['AB']['DATALAYER']) {
            window['AB']['DATALAYER'].setModalClickEvents(`mto-pickup|${linkClicked}`);
        }
    }
    /**
     * Handles returning focus to the appropriate element for the quantity stepper.
     */
    handleReturnFocusForQtyStppr() {
        if (this.refocusButton) {
            this.refocusButton.focus();
        }
        else {
            this.timeouts.push(setTimeout(() => {
                this.qtyInfoBtn?.nativeElement.focus();
            }, 100));
        }
    }
    ;
    /**
     * Toggles the display of weights.
     * If the weights are shown, they are hidden.
     * If the weights are not shown, the weight list is initialized.
     */
    displayWeights() {
        const preference = this._userInfoService.getPreference()
            ? this._userInfoService.getPreference().toUpperCase()
            : undefined;
        if (preference === 'J4U') {
            window['storeFulfillmentModal'].component.setModalDisplayData(2);
        }
        else {
            if (this.showWeights) {
                this.toggleDisplayWeights(false);
            }
            else {
                if (this.weightList && this.weightList.length > 0) {
                    this.toggleDisplayWeights(true);
                    this.setADANavigation();
                }
                else {
                    this.initializeWeightList();
                }
            }
        }
    }
    ;
    toggleDisplayWeights(isShown) {
        if (this.isCarouselRedesign) {
            if (isShown) {
                $(this._elementRef.nativeElement).closest('.product-carousel-v2').addClass('pc-z-index');
            }
            else {
                $(this._elementRef.nativeElement).closest('.product-carousel-v2').removeClass('pc-z-index');
            }
        }
        this.showWeights = isShown;
    }
    /**
     * Sets up the ADA navigation for the quantity dropdown.
     * This function attaches event listeners to handle keyboard navigation and focus management.
     * It also updates the estimated price based on the selected item.
     */
    setADANavigation() {
        setTimeout(() => {
            const firstItem = "#dropdown-itm0";
            const listItem = ".dropdown-item.wt-dropdown__menu__container__item";
            const removeBtn = ".wt-dropdown__menu__container__item-remove";
            $(firstItem).focus();
            this.estimatedPrice = parseFloat(this.weightList[0].price);
            const that = this;
            $(listItem).on('keydown keypress', function (e) {
                if ($('this:focus')) {
                    let nextFocusableElement = null;
                    if (e.which === 40) {
                        nextFocusableElement = $(this).next();
                    }
                    else if (e.which === 38) {
                        nextFocusableElement = $(this).prev();
                    }
                    ;
                    if (nextFocusableElement && nextFocusableElement.length && nextFocusableElement.length > 0) {
                        if (!nextFocusableElement.get(0).className.includes("wt-dropdown__menu__container__item-remove")) {
                            const nextIndex = nextFocusableElement.get(0).id.replace("dropdown-itm", "");
                            that.estimatedPrice = parseFloat(that.weightList[Number(nextIndex)].price);
                        }
                        else if (nextFocusableElement.get(0).className.includes("wt-dropdown__menu__container__item-remove") &&
                            !nextFocusableElement.get(0).className.includes("wt-dropdown__menu__container__item-remove--disabled")) {
                            that.estimatedPrice = 0;
                        }
                        if (!nextFocusableElement.get(0).className.includes("wt-dropdown__menu__container__item-remove--disabled")) {
                            nextFocusableElement.focus();
                        }
                    }
                }
            });
            $(removeBtn).on('keydown keypress', function (e) {
                if ($('this:focus')) {
                    if (e.which === 38) {
                        const element = $(this).prev();
                        element.focus();
                    }
                }
            });
        }, 500);
    }
    ;
    /**
     * Initializes the weight list by making a request to get the increment price list for the product's UPC.
     */
    initializeWeightList() {
        this.cartV2Service.getIncrementPriceList(this.product.upc)
            .subscribe(response => {
            if (response) {
                const priceAndPromoResponse = response['priceAndPromoResponse'];
                if (priceAndPromoResponse && priceAndPromoResponse.length > 0) {
                    this.weightList = priceAndPromoResponse[0]['incrementPriceList'];
                    if (this.weightList && this.weightList.length > 0) {
                        this.toggleDisplayWeights(true);
                        this.setADANavigation();
                    }
                }
            }
        }, err => {
            this.toggleDisplayWeights(false);
        });
    }
    ;
    /**
     * Refocuses the select weight button.
     */
    focusQtyDropdownBtn() {
        this.timeouts.push(setTimeout(() => {
            $(`#qtyDropdownBtn_${this.product.id}`).focus();
        }, 100));
    }
    ;
    /**
     * Handles the mouse enter event for the quantity stepper.
     * @param i - The index of the item.
     */
    mouseEnter(i) {
        this.estimatedPrice = parseFloat(this.weightList[i].price);
        this.timeouts.push(setTimeout(() => {
            $('#dropdown-itm' + i).focus();
        }, 0));
    }
    ;
    /**
     * Handles the mouse enter event for the remove button.
     * Resets the estimated price to 0.
     */
    mouseEnterRemoveBtn() {
        this.estimatedPrice = 0;
    }
    ;
    /**
    * Add focus to spinner block
    */
    addFocusToSpinnerBlock() {
        this.loadingSpinner = true;
        this.refocusButton = null;
        this.timeouts.push(setTimeout(() => {
            this.spinnerBlock?.nativeElement.focus();
        }, 100));
    }
    /**
    * Update Quantity Manually
    */
    showUpdateQtyInput() {
        this.updateState.input = this.product.quantity;
        this.updateState.show = true;
        setTimeout(() => {
            $(`#qtyInfoControl_${this.product.id}`).focus();
        }, 100);
    }
    /**
     * This function is called on cart api success when program type is 1P_SNS
    */
    callSNSSuccessDispatch() {
        const payloadData = {
            'data-bpn': this.product.id,
            'qty': this.product.quantity
        };
        this._commonService.dispatchSnsOneTimeEvent('productQtyUpdateSuccess', payloadData);
    }
    /**
     * Input Keyup event. Used to prevent numbers greater than maxPurchaseQty value.
     * Event will trigger when key is released.
     */
    inputQtyKeyup(event) {
        if (this.product.maxPurchaseQty && event.target.value > this.product.maxPurchaseQty) {
            event.preventDefault();
            this.updateState.input = this.product.maxPurchaseQty;
        }
    }
    /**
        * Input Keydown event. Used to remove e,+,- and period from quantity input.
        * Event will trigger when key is pressed.
        */
    inputQtyKeydown(event) {
        const e = event;
        const keyCode = !e.which ? e.keyCode : e.which;
        const actionsToAllow = [8, 9, 13, 37, 38, 39, 40, 46]; // backspace, tab, enter, arrows and delete
        const keysToAllow = '0123456789'; // had to do this because firefox sees 1 as ! and ¡ etc if we use keyCodes
        // Prevent all but numbers, backspace, delete, tab and enter
        if (!(actionsToAllow.includes(keyCode) || keysToAllow.includes(e.key))) {
            e.preventDefault();
        }
        // Prevent double space keystroke adding a decimal/. to input
        if (event.key == ' ') {
            let inputField = document.querySelector(`#qtyInfoControl_${this.product.id}`);
            inputField.value = inputField.value.replace(/[^0-9]*/g, '');
        }
    }
    /**
    * This function shows the first time cart modal authored version (static).
    */
    showStaticFirstTimeCartModal(cartId, cartIdLs) {
        const cartModalId = '#addToCartModal-' + this.configObj?.programType;
        if (cartIdLs && cartIdLs[cartId]) {
            return;
        }
        else {
            window['ErrorStateModalComp'].triggerEmptyStateModal(cartModalId, true);
            if (window['AB'] && window['AB'].DATALAYER) {
                window['AB'].DATALAYER.addedToSellerTypeModalTracking('wineshop');
            }
        }
    }
    /**
    * Triggers MKP Add to cart Modal when user adding seller Product for first time
    * Checks cartId local storage to determine the cart seller cart activity
    * Replaces modal placeholders with order min and product price
    * **/
    showMkpAddToCartModal(sellerId, sellerName, productPrice, cartIdLs) {
        if (cartIdLs && cartIdLs[sellerId]) {
            return;
        }
        else {
            this.showDynamicFirstTimeCartModal(sellerId, sellerName, productPrice);
        }
    }
    /**
  * This function shows the first time cart modal api driven version (dynamic).
  */
    showDynamicFirstTimeCartModal(sellerId, sellerName, productPrice) {
        // generate add to cart modal based on program type
        const cartModalId = '#addToCartModal-' + this.configObj?.programType;
        const cartModal = $(cartModalId);
        // replace sellerId and sellerName in image url and alt text and set src and alt text
        const mkpLogo = $(cartModalId + ' .error-state-modal__logo img');
        const mkpLogoPlaceholder = mkpLogo.attr('data-image-placeholder');
        const mkpAltPlaceholder = mkpLogo.attr('data-alt-placeholder');
        mkpLogo.attr('src', mkpLogoPlaceholder?.replace('(sellerId)', sellerId));
        mkpLogo.attr('alt', mkpAltPlaceholder?.replace('(sellerName)', sellerName));
        // replace sellerName placeholder in modal title and set inner html
        const modalSellerCartTitle = $(cartModalId + ' .error-state-modal__title');
        const messagePlaceholder = modalSellerCartTitle.attr('data-message-placeholder');
        let modalTitleHtml = messagePlaceholder?.replace('(sellerName)', sellerName);
        // update element html with replaced value
        modalSellerCartTitle?.html(modalTitleHtml);
        cartModal.attr("aria-label", modalTitleHtml);
        // calculate if current product price is > order minimum and replace current price and order minimum placeholder
        const mkpOrderMinModalMessage = $(cartModalId + ' .error-state-modal__shipping-text');
        const noOrderMinElem = $(cartModalId + ' .error-state-modal__noOrderMin');
        const mkpOrderMinModalMessage_cp = $(cartModalId + ' .error-state-modal__shipping-text .error-state-modal__shipping-text__cp');
        // add to cart Minimum order price class
        const mkpOrderMinModalMessage_mo = $(cartModalId + ' .error-state-modal__shipping-text .error-state-modal__shipping-text__mo');
        // get mkpShipping local storage to get the shipping details
        const mkpSellerShippingInfo = JSON.parse(localStorage.getItem('mkpShipping'));
        // check if shipping info is available in local storage else return
        if (mkpSellerShippingInfo && mkpSellerShippingInfo['shippingInfo'][sellerId]) {
            const domesticShippingFreeThreshold = mkpSellerShippingInfo['shippingInfo'][sellerId].domesticShippingFreeThreshold;
            const shippingFee = mkpSellerShippingInfo['shippingInfo'][sellerId].shippingFee;
            const modalShippingText = $(cartModalId + ' .error-state-modal__text');
            const qualifyFreeShipping = $(cartModalId + ' .error-state-modal__qualifyFreeShipping');
            const domesticFreeShipping = $(cartModalId + ' .error-state-modal__domesticFreeShipping');
            /**
             * if domestic free shipping threshold > 0 and shipping fee > 0
             * Show free shipping message if threshold is > product price else fall back to min cart threshold
             * */
            if (domesticShippingFreeThreshold > 0 && shippingFee > 0) {
                const mkpOrderMinModalMessage_cp = $(cartModalId + ' .error-state-modal__domesticFreeShipping .error-state-modal__shipping-text__cp');
                if (domesticShippingFreeThreshold > productPrice) {
                    mkpOrderMinModalMessage_cp.html('$' + ((domesticShippingFreeThreshold - productPrice).toFixed(2)).toString());
                    domesticFreeShipping.removeClass('d-none');
                    mkpOrderMinModalMessage.addClass('d-none');
                    modalShippingText.removeClass('d-none');
                    qualifyFreeShipping.addClass('d-none');
                }
                else {
                    qualifyFreeShipping.removeClass('d-none');
                    domesticFreeShipping.addClass('d-none');
                    mkpOrderMinModalMessage.addClass('d-none');
                }
            }
            else {
                const orderMin = mkpSellerShippingInfo['shippingInfo'][sellerId].minCartThresholdValue;
                if (orderMin && orderMin > 0 && orderMin > productPrice) {
                    // calculate order min from min threshold and round off
                    mkpOrderMinModalMessage_cp.html('$' + ((orderMin - productPrice).toFixed(2)).toString());
                    // update order minimum value with actual value from MKP Shipping LS
                    mkpOrderMinModalMessage_mo.html('$' + orderMin.toString());
                    noOrderMinElem.addClass('d-none');
                    mkpOrderMinModalMessage.removeClass('d-none');
                    qualifyFreeShipping.addClass('d-none');
                    domesticFreeShipping.addClass('d-none');
                }
                else if (orderMin === 0) {
                    // if order minimum is 0 then show no order minimum element
                    mkpOrderMinModalMessage.addClass('d-none');
                    noOrderMinElem.removeClass('d-none');
                    qualifyFreeShipping.addClass('d-none');
                    domesticFreeShipping.addClass('d-none');
                }
                else {
                    // above conditions fails then hide order minum elements
                    mkpOrderMinModalMessage.addClass('d-none');
                    noOrderMinElem.addClass('d-none');
                }
            }
            // Shipping fee elements
            const shippingFeeElem = $(cartModalId + ' .error-state-modal__text__shipping');
            const freeShippingElem = $(cartModalId + ' .error-state-modal__freeShipping');
            // if shipping fee > 0 then update html with shipping fee else remove shipping html from DOM
            /**
             * Check if domestic free shipping flag is enabled and
             * if domestic free shipping is > 0 product price is less than threshold then show shipping fee
             * else hide
             * */
            if (shippingFee && shippingFee > 0 && (domesticShippingFreeThreshold > 0 && domesticShippingFreeThreshold > productPrice || domesticShippingFreeThreshold < 1)) {
                shippingFeeElem?.html('$' + shippingFee);
                freeShippingElem.addClass('d-none');
                modalShippingText.removeClass('d-none');
            }
            else if (shippingFee === 0) {
                modalShippingText.addClass('d-none');
                freeShippingElem.removeClass('d-none');
            }
            else {
                modalShippingText?.addClass('d-none');
                freeShippingElem?.addClass('d-none');
            }
            if ($('.main-wrapper').attr('data-custom-page-type') === 'mkp-cross-seller-page') {
                $(".modal-footer__action-btn__cart").html('Go to Seller');
                const goToSeller = $(cartModalId + ' .modal-footer__action-btn__cart');
                goToSeller.attr('seller-url', this._commonService.getSellerLandingPath(sellerId));
            }
            this.updateSrMsgs(cartModalId);
        }
        else {
            console.warn('mkpShipping local storage missing or current seller shipping info is not available');
        }
        window['ErrorStateModalComp'].triggerEmptyStateModal(cartModalId, true);
        if (window['AB'] && window['AB'].DATALAYER) {
            window['AB'].DATALAYER.addedToSellerTypeModalTracking('marketplace');
        }
    }
    // To make ADA read the message as a whole instead of span by span
    updateSrMsgs(cartModalId) {
        const minOrderShippingContent = $(cartModalId + ' .error-state-modal__shipping-text-content').text();
        const domesticFreeShippingContent = $(cartModalId + ' .error-state-modal__domesticFreeShipping-content').text();
        const qualifyFreeShippingContent = $(cartModalId + ' .error-state-modal__qualifyFreeShipping-content').text();
        const shippingTextContent = $(cartModalId + ' .error-state-modal__text-content').text();
        $(cartModalId + ' .error-state-modal__shipping-text-sr').text(minOrderShippingContent);
        $(cartModalId + ' .error-state-modal__domesticFreeShipping-sr').text(domesticFreeShippingContent);
        $(cartModalId + ' .error-state-modal__qualifyFreeShipping-sr').text(qualifyFreeShippingContent);
        $(cartModalId + ' .error-state-modal__text-sr').text(shippingTextContent);
    }
    static { this.ɵfac = function QuantityStepperALV2Component_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || QuantityStepperALV2Component)(i0.ɵɵdirectiveInject(i1.CommonService), i0.ɵɵdirectiveInject(i1.UserInfoService), i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.CartService), i0.ɵɵdirectiveInject(i1.CartV2Service), i0.ɵɵdirectiveInject(i1.ProductUtilService), i0.ɵɵdirectiveInject(i1.AemService), i0.ɵɵdirectiveInject(i1.ProductCouponService), i0.ɵɵdirectiveInject(i1.UtilService), i0.ɵɵdirectiveInject(i3.HttpClient), i0.ɵɵdirectiveInject(i2.ToasterALV1Service)); }; }
    static { this.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: QuantityStepperALV2Component, selectors: [["quantity-stepper-al-v2"]], viewQuery: function QuantityStepperALV2Component_Query(rf, ctx) { if (rf & 1) {
            i0.ɵɵviewQuery(_c0, 5);
            i0.ɵɵviewQuery(_c1, 5);
            i0.ɵɵviewQuery(_c2, 5);
            i0.ɵɵviewQuery(_c3, 5);
        } if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.decreaseBtn = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.spinnerBlock = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.addBtn = _t.first);
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.qtyInfoBtn = _t.first);
        } }, hostBindings: function QuantityStepperALV2Component_HostBindings(rf, ctx) { if (rf & 1) {
            i0.ɵɵlistener("focusout", function QuantityStepperALV2Component_focusout_HostBindingHandler($event) { return ctx.onFocusOutEvent($event); });
        } }, inputs: { product: "product", calledBy: "calledBy", stpprDataObj: "stpprDataObj", configObj: "configObj", isCarouselBTestEnabled: "isCarouselBTestEnabled" }, decls: 3, vars: 3, consts: [["addBtn", ""], ["decreaseBtn", ""], ["spinnerBlock", ""], ["qtyInfoBtn", ""], [4, "ngIf"], ["data-qa", "addbutton", 1, "btn", "btn-primary", "btn-stppr", "btn-stppr-signIn", "p-0", "d-flex", "align-items-center", "justify-content-center", "btn-stppr-text", 3, "click", "id"], ["data-qa", "addbutton", 1, "btn", "btn-primary", "btn-stppr", "btn-stppr-add", "p-0", "d-flex", "align-items-center", "justify-content-center", 3, "click", "id", "ngClass"], ["aria-hidden", "true", 1, "svg-btn-stppr-increase"], [1, "pl-2", "btn-stppr-text"], ["class", "rounded-pill background-color-primary-default btn-stppr btn-stppr-expand p-0 d-flex w-100", "role", "group", "aria-labelledby", "qtyStpprExpandedLabel", 4, "ngIf"], ["class", "rounded-pill background-color-primary-default btn-stppr btn-stppr-expand p-0 d-flex justify-content-end w-100", 4, "ngIf"], ["role", "group", "aria-labelledby", "qtyStpprExpandedLabel", 1, "rounded-pill", "background-color-primary-default", "btn-stppr", "btn-stppr-expand", "p-0", "d-flex", "w-100"], ["id", "qtyStpprExpandedLabel", 1, "sr-only"], ["aria-live", "assertive", "aria-atomic", "true", 1, "sr-only"], ["data-qa", "prdctdcrmntr", 1, "btn", "btn-primary", "w-25", "border-0", "p-0", "d-flex", "align-items-center", "justify-content-center", 3, "click", "id", "ngClass"], ["aria-hidden", "true", "class", "svg-btn-stppr-trash-bin", 4, "ngIf"], ["aria-hidden", "true", "class", "svg-btn-stppr-decrease", 3, "ngClass", 4, "ngIf"], ["aria-hidden", "true", "tabindex", "-1", "class", "w-50 d-flex justify-content-center align-items-center", 3, "id", 4, "ngIf"], ["data-qa", "qty-stppr-qtymsg", "class", "btn btn-primary w-50 border-0 rounded-0 p-0 btn-stppr-text", 3, "id", "click", "keydown.enter", 4, "ngIf"], ["data-qa", "prdctincrmntr", 1, "btn", "btn-primary", "w-25", "border-0", "p-0", "d-flex", "justify-content-center", "align-items-center", 3, "click", "id", "ngClass"], ["aria-hidden", "true", 1, "svg-btn-stppr-increase", 3, "ngClass"], ["aria-hidden", "true", 1, "svg-btn-stppr-trash-bin"], ["aria-hidden", "true", 1, "svg-btn-stppr-decrease", 3, "ngClass"], ["aria-hidden", "true", "tabindex", "-1", 1, "w-50", "d-flex", "justify-content-center", "align-items-center", 3, "id"], [1, "pp-loading-spinner"], ["data-qa", "qty-stppr-qtymsg", 1, "btn", "btn-primary", "w-50", "border-0", "rounded-0", "p-0", "btn-stppr-text", 3, "click", "keydown.enter", "id"], [1, "rounded-pill", "background-color-primary-default", "btn-stppr", "btn-stppr-expand", "p-0", "d-flex", "justify-content-end", "w-100"], ["class", "w-50 background-color-primary-default color-neutral-100 btn-stppr-expand__input btn-stppr-text title-xs text-center p-0 mt-1 mb-1", "onclick", "this.select();", "type", "number", "min", "1", "step", "1", "data-qa", "prd-qty-stppr-qtybox", 3, "id", "max", "ngModel", "keydown", "ngModelChange", "keyup", 4, "ngIf"], ["data-qa", "prdqtyupdate", 1, "btn", "btn-primary", "w-25", "border-0", "p-0", "d-flex", "justify-content-center", "align-items-center", 3, "click", "id"], ["aria-hidden", "true", 1, "svg-btn-stppr-right-arrow", 3, "ngClass"], ["onclick", "this.select();", "type", "number", "min", "1", "step", "1", "data-qa", "prd-qty-stppr-qtybox", 1, "w-50", "background-color-primary-default", "color-neutral-100", "btn-stppr-expand__input", "btn-stppr-text", "title-xs", "text-center", "p-0", "mt-1", "mb-1", 3, "keydown", "ngModelChange", "keyup", "id", "max", "ngModel"], ["data-qa", "qty-stppr-bbl", 1, "btn", "btn-primary", "btn-circle--md", 3, "click", "id"], [1, "dropdown", "wt-dropdown"], ["data-qa", "addwgtBtn", "class", "wt-dropdown__button btn btn-primary btn-stppr d-flex align-items-center border-0", "aria-haspopup", "true", 3, "id", "click", 4, "ngIf"], ["data-qa", "qty-stppr-wgtbbl", "class", "btn btn-primary btn-circle btn-stppr d-flex align-items-center px-2", "aria-haspopup", "true", 3, "id", "click", 4, "ngIf"], ["data-qa", "addwgt-drdwn", "class", "dropdown-menu dropdown-menu-right wt-dropdown__menu p-0", 3, "ngClass", 4, "ngIf"], ["data-qa", "addwgtBtn", "aria-haspopup", "true", 1, "wt-dropdown__button", "btn", "btn-primary", "btn-stppr", "d-flex", "align-items-center", "border-0", 3, "click", "id"], [1, "body-text", "wt-dropdown__text"], [1, "svg-caret-down", "ml-2"], [1, "svg-caret-up", "ml-2"], ["data-qa", "qty-stppr-wgtbbl", "aria-haspopup", "true", 1, "btn", "btn-primary", "btn-circle", "btn-stppr", "d-flex", "align-items-center", "px-2", 3, "click", "id"], [1, "title-xs", "wt-dropdown__text"], ["data-qa", "addwgt-drdwn", 1, "dropdown-menu", "dropdown-menu-right", "wt-dropdown__menu", "p-0", 3, "ngClass"], ["tabindex", "-1", "role", "menu", 1, "wt-dropdown__menu__container", "p-0", 3, "ngClass", "id"], ["class", "dropdown-item wt-dropdown__menu__container__item body-text-sm d-flex align-items-center", "role", "menuitem", "tabindex", "-1", 3, "ngClass", "id", "click", "mouseenter", "keydown.enter", 4, "ngFor", "ngForOf"], ["role", "menuitem", "tabindex", "-1", 1, "dropdown-item", "wt-dropdown__menu__container__item", "wt-dropdown__menu__container__item-remove", "body-text-sm", "d-flex", "align-items-center", 3, "click", "keydown.enter", "mouseenter", "ngClass"], [1, "dropdown-item", "wt-dropdown__menu__price", "wt-dropdown__menu__price--selected", "color-primary-default", "pb-0", "body-text-sm", 3, "ngClass"], ["aria-live", "polite", 1, "sr-only"], ["aria-hidden", "true"], [1, "dropdown-item", "wt-dropdown__menu__price", "pt-0", "body-text-sm", 3, "ngClass"], ["role", "menuitem", "tabindex", "-1", 1, "dropdown-item", "wt-dropdown__menu__container__item", "body-text-sm", "d-flex", "align-items-center", 3, "click", "mouseenter", "keydown.enter", "ngClass", "id"], ["tabindex", "-1", "id", "mto-modal", "role", "dialog", "aria-labelledby", "product-mto-modal-label", "aria-hidden", "true", 1, "modal", "fade", "product-mto-modal", 3, "keydown"], [1, "modal-dialog", "modal-dialog-centered", "notif-modal"], ["data-qa", "mto", 1, "modal-content"], [1, "modal-header"], ["type", "button", "data-dismiss", "modal", "aria-label", "Close", "data-qa", "mto-close", 1, "close"], [1, "svg-icon", "svg-close-primary"], [1, "modal-body", "notif-styles"], [1, "notif-styles__content"], ["id", "product-mto-modal-label", "data-qa", "mto-ttl", 1, "notif-styles__content--title"], ["data-qa", "mto-txt", 1, "body-text", "text-center", "mb-4"], [1, "d-flex", "flex-column", "align-items-center", "justify-content-center"], ["aria-label", "Reserve new time", "data-qa", "mto-rsrv-btn", 1, "btn", "btn-md", "pds-btn-filled--primary", "mb-2", "py-2", 3, "click"], ["aria-label", "Choose time later", "data-qa", "mto-chs-tm-btn", 1, "btn", "btn-md", "pds-btn-outlined--primary", "py-2", "mb-4", 3, "click"], ["type", "button", "data-dismiss", "modal", "aria-label", "Don't add item", "data-qa", "mto-dnt-add-btn", 1, "btn", "btn-sm", "pds-btn-transparent--primary", "word-underline", "py-2", 3, "click"]], template: function QuantityStepperALV2Component_Template(rf, ctx) { if (rf & 1) {
            i0.ɵɵtemplate(0, QuantityStepperALV2Component_ng_container_0_Template, 3, 6, "ng-container", 4)(1, QuantityStepperALV2Component_ng_container_1_Template, 3, 2, "ng-container", 4)(2, QuantityStepperALV2Component_ng_container_2_Template, 22, 7, "ng-container", 4);
        } if (rf & 2) {
            i0.ɵɵproperty("ngIf", !ctx.isAuthorized && !ctx.isGuestAddToCart);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.isAuthorized || ctx.isGuestAddToCart);
            i0.ɵɵadvance();
            i0.ɵɵproperty("ngIf", ctx.mto.popup.show);
        } }, dependencies: [i5.NgClass, i5.NgForOf, i5.NgIf, i2$1.DefaultValueAccessor, i2$1.NumberValueAccessor, i2$1.NgControlStatus, i2$1.MinValidator, i2$1.MaxValidator, i2$1.NgModel, i5.DecimalPipe, i5.TitleCasePipe, i5.CurrencyPipe] }); }
    static { this.ɵprov = /*@__PURE__*/ i0.ɵɵdefineInjectable({ token: QuantityStepperALV2Component, factory: QuantityStepperALV2Component.ɵfac }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(QuantityStepperALV2Component, [{
        type: Component,
        args: [{ selector: 'quantity-stepper-al-v2', template: "<ng-container *ngIf=\"!isAuthorized  && !isGuestAddToCart\">\n    <button attr.data-qty-id=\"pc{{product.id}}Inpt\" (click)=\"beforeCartAction('increase',$event)\" id=\"addButton_{{product.id}}\" data-qa=\"addbutton\" class=\"btn btn-primary btn-stppr btn-stppr-signIn p-0 d-flex align-items-center justify-content-center btn-stppr-text\" [attr.aria-label]=\"SIGNIN + (isLBProduct ? ' weight of ' : ' 1 unit of ') + getProductFullName()\">{{SIGNIN}}</button>\n</ng-container>\n\n<ng-container *ngIf=\"isAuthorized || isGuestAddToCart\">\n\n    <ng-container *ngIf=\"!isLBProduct\">\n\n        <ng-container *ngIf=\"(product.quantity == null || product.quantity == 0)\">        \n            <button #addBtn attr.data-qty-id=\"pc{{product.id}}Inpt\" (click)=\"beforeCartAction('increase',$event)\" id=\"addButton_{{product.id}}\" data-qa=\"addbutton\" class=\"btn btn-primary btn-stppr btn-stppr-add p-0 d-flex align-items-center justify-content-center\" [ngClass]=\"{'btn-stppr-disabled': loadingSpinner}\" [attr.aria-label]=\"ADD + ' 1 unit of ' + getProductFullName()\" [attr.aria-disabled]=\"loadingSpinner\">\n                <span aria-hidden=\"true\" class=\"svg-btn-stppr-increase\"></span>\n                <span class=\"pl-2 btn-stppr-text\">{{ADD}}</span>\n            </button>\n        </ng-container>\n\n            <!--Quantity stepper (Quantity >= 1) -->\n        <ng-container *ngIf=\"product.quantity > 0 && displayBubble == false\">\n            <div *ngIf=\"!updateState.show\" class=\"rounded-pill background-color-primary-default btn-stppr btn-stppr-expand p-0 d-flex w-100\" role=\"group\" aria-labelledby=\"qtyStpprExpandedLabel\">\n                <span id=\"qtyStpprExpandedLabel\" class=\"sr-only\">Quantity stepper menu expanded</span>\n                <span aria-live=\"assertive\" aria-atomic=\"true\" class=\"sr-only\">{{stepperAnnouncement}}</span>\n                <button #decreaseBtn data-qa=\"prdctdcrmntr\" id=\"dec_qtyInfo_{{product.id}}\" (click)=\"beforeCartAction('decrease',$event)\" class=\"btn btn-primary w-25 border-0 p-0 d-flex align-items-center justify-content-center\" [ngClass]=\"{'btn-stppr-disabled': loadingSpinner}\" [attr.aria-label]=\"product.quantity == 1 ? REMOVE + ' Quantity of ' + getProductFullName() + ' from cart' : 'Decrease Quantity 1 unit of ' + getProductFullName()\" [attr.aria-disabled]=\"loadingSpinner\">\n                    <span *ngIf=\"product.quantity == 1\" aria-hidden=\"true\" class=\"svg-btn-stppr-trash-bin\"></span>\n                    <span *ngIf=\"product.quantity > 1\" aria-hidden=\"true\" class=\"svg-btn-stppr-decrease\" [ngClass]=\"{'svg-btn-stppr-decrease--disabled': loadingSpinner}\"></span>\n                </button>\n                <span #spinnerBlock *ngIf=\"loadingSpinner\" id=\"qtySpinner_{{product.id}}\" aria-hidden=\"true\" tabindex=\"-1\" class=\"w-50 d-flex justify-content-center align-items-center\">\n                    <span class=\"pp-loading-spinner\"></span>\n                </span>\n                <button #qtyInfoBtn data-qa=\"qty-stppr-qtymsg\" *ngIf=\"!loadingSpinner\" id=\"qtyInfo_{{product.id}}\" class=\"btn btn-primary w-50 border-0 rounded-0 p-0 btn-stppr-text\" [attr.aria-label]=\"quantityAriaLabelMessage\" (click) = \"showUpdateQtyInput()\" (keydown.enter) = \"showUpdateQtyInput()\">{{product.quantity}}</button>\n                <button data-qa=\"prdctincrmntr\" id=\"inc_qtyInfo_{{product.id}}\" class=\"btn btn-primary w-25 border-0 p-0 d-flex justify-content-center align-items-center\" [ngClass]=\"{'btn-stppr-disabled': product.quantity >= product.maxPurchaseQty || loadingSpinner}\" (click)=\"beforeCartAction('increase',$event)\" [attr.aria-label]=\"'Increase Quantity 1 unit of ' + getProductFullName()\" [attr.aria-disabled]=\"product.quantity >= product.maxPurchaseQty || loadingSpinner\">\n                    <span aria-hidden=\"true\" class=\"svg-btn-stppr-increase\" [ngClass]=\"{'svg-btn-stppr-increase--disabled': product.quantity >= product.maxPurchaseQty || loadingSpinner}\"></span>\n                </button>\n            </div>\n\n             <!-- Update quantity Manually -->\n\n             <div *ngIf=\"updateState.show\" class=\"rounded-pill background-color-primary-default btn-stppr btn-stppr-expand p-0 d-flex justify-content-end w-100\">\n                <span aria-live=\"assertive\" aria-atomic=\"true\" class=\"sr-only\">{{stepperAnnouncement}}</span>\n                <input *ngIf=\"!loadingSpinner\" class=\"w-50 background-color-primary-default color-neutral-100 btn-stppr-expand__input btn-stppr-text title-xs text-center p-0 mt-1 mb-1\" \n                onclick=\"this.select();\"  [attr.aria-label]=\" 'Cart quantity ' + getProductFullName()\" id=\"qtyInfoControl_{{product.id}}\"\n                type=\"number\" min=\"1\" [max]=\"product.maxPurchaseQty\" (keydown)=\"inputQtyKeydown($event)\" step=\"1\" [(ngModel)]=\"updateState.input\" (keyup)=\"inputQtyKeyup($event)\" data-qa=\"prd-qty-stppr-qtybox\">\n\n                <span #spinnerBlock *ngIf=\"loadingSpinner\" id=\"qtySpinner_{{product.id}}\" aria-hidden=\"true\" tabindex=\"-1\" class=\"w-50 d-flex justify-content-center align-items-center\">\n                    <span class=\"pp-loading-spinner\"></span>\n                </span>\n\n                <button id=\"update_qtyInfo_{{product.id}}\" class=\"btn btn-primary w-25 border-0 p-0 d-flex justify-content-center align-items-center\" (click)=\"beforeCartAction('update',$event)\" data-qa=\"prdqtyupdate\" [attr.aria-label]=\"'update quantity of ' + getProductFullName()\"  \n                [attr.aria-disabled]=\"product.quantity >= product.maxPurchaseQty || loadingSpinner\">\n                    <span aria-hidden=\"true\" class=\"svg-btn-stppr-right-arrow\" [ngClass]=\"{'svg-btn-stppr-right-arrow--disabled': product.quantity >= product.maxPurchaseQty || loadingSpinner}\"></span>\n                </button>\n\n            </div>\n        </ng-container>\n    \n        <!-- Numeric only quantity stepper or bubble variation -->\n        <ng-container *ngIf=\"product.quantity > 0 && displayBubble == true\">\n            <button data-qa=\"qty-stppr-bbl\" id=\"bubble_qtyInfo_{{product.id}}\" class=\"btn btn-primary btn-circle--md\" (click)=\"showQtyStepper()\" [attr.aria-label]=\"'collapsed, '+ quantityAriaLabelMessage\">{{product.quantity}}</button>\n        </ng-container>\n\n    </ng-container>\n\n    <ng-container *ngIf=\"isLBProduct\">\n    \n        <div class=\"dropdown wt-dropdown\">\n            <button *ngIf=\"selectedWeight == 0\" data-qa=\"addwgtBtn\" class=\"wt-dropdown__button btn btn-primary btn-stppr d-flex align-items-center border-0\" (click)=\"displayWeights()\" id=\"qtyDropdownBtn_{{product.id}}\" aria-haspopup=\"true\" attr.aria-controls=\"qtyDropdownContentList_{{product.id}}\" attr.aria-expanded=\"{{showWeights}}\" attr.aria-label=\"select weight {{product.name}}\">\n                <span class=\"body-text wt-dropdown__text\">{{selectedWeightText}}</span>\n                <span class=\"svg-caret-down ml-2\"></span>\n                <span class=\"svg-caret-up ml-2\"></span>\n            </button>\n\n            <button *ngIf=\"selectedWeight != 0\" data-qa=\"qty-stppr-wgtbbl\" class=\"btn btn-primary btn-circle btn-stppr d-flex align-items-center px-2\" (click)=\"displayWeights()\" id=\"qtyDropdownBtn_{{product.id}}\" aria-haspopup=\"true\" attr.aria-controls=\"qtyDropdownContentList_{{product.id}}\" attr.aria-expanded=\"{{showWeights}}\" [attr.aria-label]=\"quantityAriaLabelMessage\">\n                <span class=\"title-xs wt-dropdown__text\">{{selectedWeightText}}</span>\n            </button>\n\n            <div data-qa=\"addwgt-drdwn\" class=\"dropdown-menu dropdown-menu-right wt-dropdown__menu p-0\" [ngClass]=\"{'pc--carousel-wt-dropdown__menu': isCarouselRedesign,\n            'pc--carousel-wt-dropdown__menu--c': isCarouselRedesign && !isCarouselBTestEnabled, 'd-block' : showWeights}\" *ngIf=\"showWeights\">\n                <ul [ngClass]=\"{'pc--carousel-wt-dropdown__menu__container': isCarouselRedesign, 'pc--carousel-wt-dropdown__menu__container--c': isCarouselRedesign && !isCarouselBTestEnabled}\" \n                class=\"wt-dropdown__menu__container p-0\" \n                tabindex=\"-1\" id=\"qtyDropdownContentList_{{product.id}}\" role=\"menu\" attr.aria-labelledby=\"qtyDropdownBtn_{{product.id}}\">\n\n                    <li *ngFor=\"let item of weightList; let i=index\" \n                        [ngClass]=\"{'pc--carousel-wt-dropdown__menu__container__item':isCarouselRedesign,\n                                    'pc--carousel-wt-dropdown__menu__container__item--c':isCarouselRedesign&& !isCarouselBTestEnabled}\"\n                        class=\"dropdown-item wt-dropdown__menu__container__item body-text-sm d-flex align-items-center\"\n                        id=\"dropdown-itm{{i}}\"\n                        (click)=\"beforeCartAction('weighted',$event,i)\"\n                        (mouseenter)=\"mouseEnter(i)\"\n                        (keydown.enter)=\"beforeCartAction('weighted',$event,i)\"\n                        role=\"menuitem\"\n                        tabindex=\"-1\"\n                        >\n                        {{ item.weight | number:'1.2' }} lb\n                    </li>\n                    <li class=\"dropdown-item wt-dropdown__menu__container__item wt-dropdown__menu__container__item-remove body-text-sm d-flex align-items-center\"\n                        [ngClass]=\"{'pc--carousel-wt-dropdown__menu__container__item':isCarouselRedesign\n                                    ,'wt-dropdown__menu__container__item-remove--disabled' : selectedWeight === 0,\n                                    'pc--carousel-wt-dropdown__menu__container__item--c':isCarouselRedesign&& !isCarouselBTestEnabled}\"\n                        role=\"menuitem\"\n                        tabindex=\"-1\"\n                        [attr.aria-disabled]=\"selectedWeight === 0\"\n                        (click)=\"beforeCartAction('weighted',$event)\"\n                        (keydown.enter)=\"beforeCartAction('weighted',$event)\"\n                        (mouseenter)=\"mouseEnterRemoveBtn()\"\n                        >\n                        Remove\n                    </li>\n                </ul>\n                <div [ngClass]=\"{'pc--carousel-wt-dropdown__menu__container__item':isCarouselRedesign, 'pc--carousel-wt-dropdown__menu__container__item--c':isCarouselRedesign && !isCarouselBTestEnabled}\" \n                class=\"dropdown-item wt-dropdown__menu__price wt-dropdown__menu__price--selected color-primary-default pb-0 body-text-sm\">\n                    <span class=\"sr-only\" aria-live=\"polite\">Estimated Total: {{ estimatedPrice | currency: 'USD' }}</span>\n                    <span aria-hidden=\"true\">Est. Total: {{ estimatedPrice | currency: 'USD' }}</span>\n                </div>\n                <div [ngClass]=\"{'pc--carousel-wt-dropdown__menu__container__item':isCarouselRedesign, 'pc--carousel-wt-dropdown__menu__container__item--c':isCarouselRedesign && !isCarouselBTestEnabled}\" \n                class=\"dropdown-item wt-dropdown__menu__price pt-0 body-text-sm\">Final cost by weight</div>\n            </div>\n        </div>\n    </ng-container>\n    \n</ng-container>\n\n<!-- MTO Pop up -->\n <!-- <h1>MTO Modal</h1> -->\n <ng-container *ngIf=\"mto.popup.show\">\n\n    <div class=\"modal fade product-mto-modal\" tabindex=\"-1\" id=\"mto-modal\" role=\"dialog\" aria-labelledby=\"product-mto-modal-label\" aria-hidden=\"true\" (keydown)=\"onKeydownMtoModalEvent($event, '#mto-modal')\">\n        <div class=\"modal-dialog modal-dialog-centered notif-modal\">\n            <div class=\"modal-content\" data-qa=\"mto\">\n                <div class=\"modal-header\">\n                    <button type=\"button\" class=\"close\" data-dismiss=\"modal\" aria-label=\"Close\" data-qa=\"mto-close\">\n                        <span class=\"svg-icon svg-close-primary\"></span>\n                    </button>\n                </div>\n                <div class=\"modal-body notif-styles\" >\n                    <div class=\"notif-styles__content\">\n                        <h1 id=\"product-mto-modal-label\" class=\"notif-styles__content--title\" data-qa=\"mto-ttl\">{{ reservedTimeIntent | titlecase }}\n                            time will change</h1>\n                        <div class=\"body-text text-center mb-4\" data-qa=\"mto-txt\">\n                            This item requires {{ product.mtoDisplyableTime }} to prepare. Please select a new time for {{ reservedTimeIntent | titlecase }}.\n                        </div>\n                        <div class=\"d-flex flex-column align-items-center justify-content-center\">\n                            <button class=\"btn btn-md pds-btn-filled--primary mb-2 py-2\" aria-label=\"Reserve new time\" (click)=\"handleSlotAction('reserve-new-time');analyticsMTOClicks('reserve-new-time')\" data-qa=\"mto-rsrv-btn\">Reserve new\n                                time</button>\n                            <button class=\"btn btn-md pds-btn-outlined--primary py-2 mb-4\" aria-label=\"Choose time later\" (click)=\"handleSlotAction('choose-time-later');analyticsMTOClicks('choose-time-later')\" data-qa=\"mto-chs-tm-btn\">Choose time\n                                later</button>\n                            <button type=\"button\" class=\"btn btn-sm pds-btn-transparent--primary word-underline py-2\" data-dismiss=\"modal\" aria-label=\"Don't add item\" (click)=\"analyticsMTOClicks('dont-add-item')\" data-qa=\"mto-dnt-add-btn\">Don't add item</button>\n                        </div>\n\n                    </div>\n                </div>\n            </div>\n        </div>\n    </div>\n</ng-container>" }]
    }, {
        type: Injectable
    }], () => [{ type: i1.CommonService }, { type: i1.UserInfoService }, { type: i0.ElementRef }, { type: i1.CartService }, { type: i1.CartV2Service }, { type: i1.ProductUtilService }, { type: i1.AemService }, { type: i1.ProductCouponService }, { type: i1.UtilService }, { type: i3.HttpClient }, { type: i2.ToasterALV1Service }], { product: [{
            type: Input
        }], calledBy: [{
            type: Input,
            args: ['calledBy']
        }], stpprDataObj: [{
            type: Input
        }], configObj: [{
            type: Input
        }], isCarouselBTestEnabled: [{
            type: Input,
            args: ['isCarouselBTestEnabled']
        }], decreaseBtn: [{
            type: ViewChild,
            args: ['decreaseBtn']
        }], spinnerBlock: [{
            type: ViewChild,
            args: ['spinnerBlock']
        }], addBtn: [{
            type: ViewChild,
            args: ['addBtn']
        }], qtyInfoBtn: [{
            type: ViewChild,
            args: ['qtyInfoBtn']
        }], 
    /**
     * Handles the focus out event for the quantity stepper component.
     */
    onFocusOutEvent: [{
            type: HostListener,
            args: ['focusout', ['$event']]
        }] }); })();
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassDebugInfo(QuantityStepperALV2Component, { className: "QuantityStepperALV2Component", filePath: "components/quantity-stepper-al-v2/quantity-stepper-al-v2.component.ts", lineNumber: 28 }); })();

class QuantityStepperModule {
    static { this.ɵfac = function QuantityStepperModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || QuantityStepperModule)(); }; }
    static { this.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: QuantityStepperModule }); }
    static { this.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ providers: [
            QuantityStepperALV1Component,
            QuantityStepperALV2Component,
            QuantityDropdownALV1Component,
            ProductSNSModalALService
        ], imports: [CommonModule,
            FormsModule,
            ToasterModule] }); }
}
(() => { (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(QuantityStepperModule, [{
        type: NgModule,
        args: [{
                declarations: [QuantityStepperALV1Component, QuantityStepperALV2Component, QuantityDropdownALV1Component, ProductSNSModalALComponent],
                exports: [
                    QuantityStepperALV1Component,
                    QuantityStepperALV2Component,
                    QuantityDropdownALV1Component
                ],
                imports: [
                    CommonModule,
                    FormsModule,
                    ToasterModule
                ],
                providers: [
                    QuantityStepperALV1Component,
                    QuantityStepperALV2Component,
                    QuantityDropdownALV1Component,
                    ProductSNSModalALService
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && i0.ɵɵsetNgModuleScope(QuantityStepperModule, { declarations: [QuantityStepperALV1Component, QuantityStepperALV2Component, QuantityDropdownALV1Component, ProductSNSModalALComponent], imports: [CommonModule,
        FormsModule,
        ToasterModule], exports: [QuantityStepperALV1Component,
        QuantityStepperALV2Component,
        QuantityDropdownALV1Component] }); })();
i0.ɵɵsetComponentScope(ProductSNSModalALComponent, [i5.NgClass, i5.NgForOf, i5.NgIf, i2$1.ɵNgNoValidate, i2$1.NgSelectOption, i2$1.ɵNgSelectMultipleOption, i2$1.DefaultValueAccessor, i2$1.RadioControlValueAccessor, i2$1.NgControlStatus, i2$1.NgControlStatusGroup, i2$1.NgModel, i2$1.NgForm, QuantityStepperALV1Component], [i5.DatePipe]);

// //Component

/**
 * Generated bundle index. Do not edit.
 */

export { ProductSNSModalALComponent, ProductSNSModalALService, QuantityDropdownALV1Component, QuantityStepperALV1Component, QuantityStepperALV2Component, QuantityStepperModule };
